 export type Vector3 = [number, number, number];

 export function predictIterator(input: number[]): Vector3 {
        let var0: Vector3;
        let var1: Vector3;  
        let var2: Vector3;
        let var3: Vector3;
        let var4: Vector3;
        let var5: Vector3;
        let var6: Vector3;
        let var7: Vector3;
        let var8: Vector3;
        let var9: Vector3;
        let var10: Vector3;
        let var11: Vector3;
        let var12: Vector3;
        let var13: Vector3;
        let var14: Vector3;
        let var15: Vector3;
        let var16: Vector3;  
        let var17: Vector3;
        let var18: Vector3;
        let var19: Vector3;
        let var20: Vector3;
        let var21: Vector3;
        let var22:  Vector3;
        let var23: Vector3;
        let var24: Vector3;
        let var25: Vector3;
        let var26: Vector3;
        let var27: Vector3;
        let var28: Vector3;
        let var29: Vector3;
        let var30: Vector3;
        let var31: Vector3;
        let var32: Vector3;
        let var33: Vector3;
        let var34: Vector3;
        let var35: Vector3;
        let var36: Vector3;
        let var37: Vector3;
        let var38: Vector3;
        let var39: Vector3;
        let var40: Vector3;
        let var41: Vector3;  
        let var42: Vector3;
        let var43: Vector3;
        let var44: Vector3;
        let var45: Vector3;
        let var46: Vector3;
        let var47: Vector3;
        let var48: Vector3;
        let var49: Vector3;
        let var50: Vector3;
        let var51: Vector3;
        let var52: Vector3;
        let var53: Vector3;
        let var54: Vector3;
        let var55: Vector3;
        let var56: Vector3;  
        let var57: Vector3;
        let var58: Vector3;
        let var59: Vector3;
        let var60: Vector3;
        let var61: Vector3;
        let var62: Vector3;
        let var63: Vector3;
        let var64: Vector3;
        let var65: Vector3;
        let var66: Vector3;
        let var67: Vector3;
        let var68: Vector3;
        let var69: Vector3;
        let var70: Vector3;
        let var71: Vector3;
        let var72: Vector3;  
        let var73: Vector3;
        let var74: Vector3;
        let var75: Vector3;
        let var76: Vector3;
        let var77: Vector3;
        let var78: Vector3;
        let var79: Vector3;
        let var80: Vector3;
        let var81: Vector3;
        let var82: Vector3;
        let var83: Vector3;
        let var84: Vector3;
        let var85: Vector3;
        let var86: Vector3;
        let var87: Vector3;
        let var88: Vector3;
        let var89: Vector3;
        let var90: Vector3;
        let var91: Vector3;
        let var92: Vector3;
        let var93: Vector3;
        let var94: Vector3;
        let var95: Vector3;
        let var96: Vector3;
        let var97: Vector3;
        let var98: Vector3;
        let var99: Vector3;

    if (input[11] <= 1.5) {
        if (input[5] <= 1.095014065504074) {
            if (input[1] <= 6.5) {
                if (input[8] <= 41.66666603088379) {
                    if (input[3] <= 2.333333373069763) {
                        if (input[10] <= 2.5) {
                            var0 = [0.0, 1.0, 0.0];
                        } else {
                            var0 = [0.5, 0.5, 0.0];
                        }
                    } else {
                        if (input[6] <= 10.0) {
                            var0 = [0.0, 1.0, 0.0];
                        } else {
                            if (input[5] <= 0.7071067839860916) {
                                var0 = [0.0, 1.0, 0.0];
                            } else {
                                var0 = [0.0, 0.0, 1.0];
                            }
                        }
                    }
                } else {
                    var0 = [0.0, 0.0, 1.0];
                }
            } else {
                var0 = [0.0, 0.0, 1.0];
            }
        } else {
            if (input[0] <= 10.0) {
                if (input[2] <= 2.199999988079071) {
                    var0 = [0.0, 1.0, 0.0];
                } else {
                    if (input[2] <= 6.375) {
                        var0 = [0.0, 0.0, 1.0];
                    } else {
                        var0 = [1.0, 0.0, 0.0];
                    }
                }
            } else {
                var0 = [0.0, 1.0, 0.0];
            }
        }
    } else {
        if (input[3] <= 25.619047164916992) {
            if (input[4] <= 1.028465360403061) {
                if (input[8] <= 12.5) {
                    if (input[4] <= 0.814578115940094) {
                        var0 = [1.0, 0.0, 0.0];
                    } else {
                        if (input[6] <= 7.142857074737549) {
                            if (input[12] <= 1.5) {
                                var0 = [1.0, 0.0, 0.0];
                            } else {
                                var0 = [0.0, 1.0, 0.0];
                            }
                        } else {
                            var0 = [1.0, 0.0, 0.0];
                        }
                    }
                } else {
                    if (input[0] <= 3.0) {
                        var0 = [1.0, 0.0, 0.0];
                    } else {
                        if (input[0] <= 4.5) {
                            var0 = [0.0, 1.0, 0.0];
                        } else {
                            var0 = [0.0, 0.0, 1.0];
                        }
                    }
                }
            } else {
                if (input[2] <= 5.055555582046509) {
                    var0 = [0.0, 0.0, 1.0];
                } else {
                    if (input[7] <= 20.09803867340088) {
                        if (input[2] <= 6.999999761581421) {
                            var0 = [0.0, 0.0, 1.0];
                        } else {
                            var0 = [0.0, 1.0, 0.0];
                        }
                    } else {
                        if (input[9] <= 1.5) {
                            var0 = [0.0, 1.0, 0.0];
                        } else {
                            var0 = [1.0, 0.0, 0.0];
                        }
                    }
                }
            }
        } else {
            var0 = [0.0, 1.0, 0.0];
        }
    }
    if (input[11] <= 2.5) {
        if (input[4] <= 0.3863389939069748) {
            if (input[2] <= 14.300000190734863) {
                if (input[8] <= 30.0) {
                    if (input[6] <= 8.333333015441895) {
                        var1 = [0.0, 1.0, 0.0];
                    } else {
                        if (input[9] <= 1.1666666865348816) {
                            var1 = [0.0, 1.0, 0.0];
                        } else {
                            var1 = [1.0, 0.0, 0.0];
                        }
                    }
                } else {
                    if (input[7] <= 45.83333206176758) {
                        var1 = [0.0, 0.0, 1.0];
                    } else {
                        var1 = [1.0, 0.0, 0.0];
                    }
                }
            } else {
                var1 = [1.0, 0.0, 0.0];
            }
        } else {
            if (input[10] <= 9.0) {
                if (input[4] <= 2.6161491870880127) {
                    if (input[0] <= 4.5) {
                        if (input[9] <= 1.4166666865348816) {
                            var1 = [0.0, 1.0, 0.0];
                        } else {
                            if (input[12] <= 1.5) {
                                var1 = [0.0, 0.0, 1.0];
                            } else {
                                if (input[9] <= 2.166666626930237) {
                                    var1 = [0.0, 1.0, 0.0];
                                } else {
                                    var1 = [0.0, 0.0, 1.0];
                                }
                            }
                        }
                    } else {
                        if (input[2] <= 6.375) {
                            var1 = [0.0, 0.0, 1.0];
                        } else {
                            if (input[3] <= 12.666666507720947) {
                                var1 = [0.0, 1.0, 0.0];
                            } else {
                                var1 = [1.0, 0.0, 0.0];
                            }
                        }
                    }
                } else {
                    var1 = [1.0, 0.0, 0.0];
                }
            } else {
                var1 = [1.0, 0.0, 0.0];
            }
        }
    } else {
        if (input[12] <= 3.0) {
            if (input[12] <= 1.5) {
                var1 = [1.0, 0.0, 0.0];
            } else {
                if (input[0] <= 9.5) {
                    var1 = [0.0, 1.0, 0.0];
                } else {
                    var1 = [1.0, 0.0, 0.0];
                }
            }
        } else {
            var1 = [0.0, 1.0, 0.0];
        }
    }
    if (input[8] <= 12.698412418365479) {
        if (input[10] <= 1.5) {
            if (input[11] <= 2.5) {
                if (input[5] <= 1.232046663761139) {
                    if (input[9] <= 1.8333333134651184) {
                        if (input[5] <= 0.2357022613286972) {
                            var2 = [1.0, 0.0, 0.0];
                        } else {
                            var2 = [0.0, 1.0, 0.0];
                        }
                    } else {
                        var2 = [0.0, 0.0, 1.0];
                    }
                } else {
                    if (input[9] <= 2.1111111640930176) {
                        if (input[4] <= 1.619306743144989) {
                            if (input[9] <= 1.3095238208770752) {
                                var2 = [1.0, 0.0, 0.0];
                            } else {
                                var2 = [0.0, 0.0, 1.0];
                            }
                        } else {
                            var2 = [0.0, 1.0, 0.0];
                        }
                    } else {
                        if (input[7] <= 52.727272033691406) {
                            var2 = [1.0, 0.0, 0.0];
                        } else {
                            var2 = [0.0, 0.0, 1.0];
                        }
                    }
                }
            } else {
                if (input[3] <= 15.107142925262451) {
                    var2 = [1.0, 0.0, 0.0];
                } else {
                    if (input[9] <= 1.399999976158142) {
                        var2 = [0.0, 1.0, 0.0];
                    } else {
                        var2 = [1.0, 0.0, 0.0];
                    }
                }
            }
        } else {
            if (input[2] <= 9.0) {
                if (input[2] <= 2.5) {
                    var2 = [0.0, 1.0, 0.0];
                } else {
                    if (input[7] <= 41.66666603088379) {
                        var2 = [0.0, 1.0, 0.0];
                    } else {
                        var2 = [0.3333333333333333, 0.6666666666666666, 0.0];
                    }
                }
            } else {
                var2 = [1.0, 0.0, 0.0];
            }
        }
    } else {
        if (input[0] <= 4.5) {
            if (input[4] <= 0.21650634706020355) {
                var2 = [1.0, 0.0, 0.0];
            } else {
                if (input[0] <= 2.5) {
                    if (input[11] <= 1.5) {
                        var2 = [0.0, 0.0, 1.0];
                    } else {
                        var2 = [1.0, 0.0, 0.0];
                    }
                } else {
                    var2 = [0.0, 1.0, 0.0];
                }
            }
        } else {
            var2 = [0.0, 0.0, 1.0];
        }
    }
    if (input[1] <= 3.5) {
        if (input[10] <= 4.0) {
            if (input[9] <= 1.100000023841858) {
                if (input[4] <= 0.48065122961997986) {
                    if (input[11] <= 1.5) {
                        var3 = [0.0, 1.0, 0.0];
                    } else {
                        if (input[10] <= 1.5) {
                            var3 = [0.0, 1.0, 0.0];
                        } else {
                            var3 = [1.0, 0.0, 0.0];
                        }
                    }
                } else {
                    var3 = [0.0, 0.0, 1.0];
                }
            } else {
                if (input[11] <= 1.5) {
                    var3 = [0.0, 0.0, 1.0];
                } else {
                    if (input[6] <= 8.333333015441895) {
                        if (input[2] <= 10.550000190734863) {
                            var3 = [1.0, 0.0, 0.0];
                        } else {
                            var3 = [0.0, 1.0, 0.0];
                        }
                    } else {
                        var3 = [1.0, 0.0, 0.0];
                    }
                }
            }
        } else {
            var3 = [0.0, 1.0, 0.0];
        }
    } else {
        if (input[9] <= 1.7222222089767456) {
            if (input[2] <= 5.833333492279053) {
                if (input[4] <= 0.9278843402862549) {
                    var3 = [0.0, 0.0, 1.0];
                } else {
                    if (input[0] <= 9.5) {
                        if (input[3] <= 9.946428775787354) {
                            var3 = [1.0, 0.0, 0.0];
                        } else {
                            var3 = [0.0, 0.0, 1.0];
                        }
                    } else {
                        var3 = [0.0, 1.0, 0.0];
                    }
                }
            } else {
                var3 = [0.0, 1.0, 0.0];
            }
        } else {
            if (input[1] <= 4.5) {
                var3 = [1.0, 0.0, 0.0];
            } else {
                if (input[5] <= 2.3302865028381348) {
                    if (input[9] <= 2.583333373069763) {
                        var3 = [0.0, 0.0, 1.0];
                    } else {
                        if (input[7] <= 47.321428298950195) {
                            if (input[1] <= 9.5) {
                                var3 = [1.0, 0.0, 0.0];
                            } else {
                                var3 = [0.0, 0.0, 1.0];
                            }
                        } else {
                            var3 = [0.0, 0.0, 1.0];
                        }
                    }
                } else {
                    var3 = [1.0, 0.0, 0.0];
                }
            }
        }
    }
    if (input[7] <= 15.476190090179443) {
        if (input[2] <= 7.916666507720947) {
            if (input[2] <= 3.533333420753479) {
                var4 = [0.0, 0.0, 1.0];
            } else {
                var4 = [1.0, 0.0, 0.0];
            }
        } else {
            var4 = [0.0, 1.0, 0.0];
        }
    } else {
        if (input[10] <= 0.5) {
            if (input[9] <= 1.2428571581840515) {
                if (input[7] <= 26.785714149475098) {
                    if (input[3] <= 9.375) {
                        var4 = [0.0, 0.0, 1.0];
                    } else {
                        var4 = [0.0, 1.0, 0.0];
                    }
                } else {
                    var4 = [0.0, 1.0, 0.0];
                }
            } else {
                if (input[0] <= 7.5) {
                    if (input[6] <= 7.142857074737549) {
                        if (input[2] <= 9.392857074737549) {
                            var4 = [0.0, 0.0, 1.0];
                        } else {
                            var4 = [0.0, 1.0, 0.0];
                        }
                    } else {
                        if (input[3] <= 5.225000023841858) {
                            var4 = [0.0, 1.0, 0.0];
                        } else {
                            if (input[1] <= 5.0) {
                                if (input[4] <= 0.7398206144571304) {
                                    var4 = [0.0, 0.0, 1.0];
                                } else {
                                    var4 = [1.0, 0.0, 0.0];
                                }
                            } else {
                                var4 = [0.0, 0.0, 1.0];
                            }
                        }
                    }
                } else {
                    if (input[4] <= 1.9146039485931396) {
                        if (input[5] <= 3.943899154663086) {
                            var4 = [0.0, 0.0, 1.0];
                        } else {
                            var4 = [1.0, 0.0, 0.0];
                        }
                    } else {
                        var4 = [1.0, 0.0, 0.0];
                    }
                }
            }
        } else {
            if (input[4] <= 0.25) {
                if (input[5] <= 0.4857022613286972) {
                    var4 = [0.0, 1.0, 0.0];
                } else {
                    if (input[7] <= 41.66666603088379) {
                        var4 = [1.0, 0.0, 0.0];
                    } else {
                        if (input[2] <= 2.5) {
                            var4 = [0.0, 1.0, 0.0];
                        } else {
                            var4 = [1.0, 0.0, 0.0];
                        }
                    }
                }
            } else {
                var4 = [1.0, 0.0, 0.0];
            }
        }
    }
    if (input[2] <= 6.166666746139526) {
        if (input[2] <= 2.549999952316284) {
            if (input[9] <= 1.625) {
                var5 = [0.0, 1.0, 0.0];
            } else {
                if (input[12] <= 1.5) {
                    var5 = [0.0, 0.0, 1.0];
                } else {
                    var5 = [0.0, 1.0, 0.0];
                }
            }
        } else {
            if (input[4] <= 0.20000000298023224) {
                var5 = [0.0, 1.0, 0.0];
            } else {
                if (input[11] <= 2.5) {
                    if (input[1] <= 9.0) {
                        if (input[7] <= 45.0) {
                            var5 = [0.0, 0.0, 1.0];
                        } else {
                            if (input[12] <= 1.5) {
                                if (input[9] <= 2.1666666865348816) {
                                    if (input[5] <= 1.8470820784568787) {
                                        if (input[5] <= 1.6102492213249207) {
                                            var5 = [0.0, 0.0, 1.0];
                                        } else {
                                            var5 = [1.0, 0.0, 0.0];
                                        }
                                    } else {
                                        var5 = [0.0, 0.0, 1.0];
                                    }
                                } else {
                                    var5 = [1.0, 0.0, 0.0];
                                }
                            } else {
                                var5 = [0.0, 0.0, 1.0];
                            }
                        }
                    } else {
                        var5 = [1.0, 0.0, 0.0];
                    }
                } else {
                    var5 = [1.0, 0.0, 0.0];
                }
            }
        }
    } else {
        if (input[8] <= 22.5) {
            if (input[1] <= 9.5) {
                if (input[9] <= 2.25) {
                    if (input[10] <= 1.5) {
                        if (input[9] <= 1.8333333134651184) {
                            var5 = [0.0, 1.0, 0.0];
                        } else {
                            var5 = [1.0, 0.0, 0.0];
                        }
                    } else {
                        if (input[0] <= 1.5) {
                            var5 = [0.0, 1.0, 0.0];
                        } else {
                            var5 = [1.0, 0.0, 0.0];
                        }
                    }
                } else {
                    if (input[3] <= 6.733333468437195) {
                        var5 = [0.0, 0.0, 1.0];
                    } else {
                        var5 = [1.0, 0.0, 0.0];
                    }
                }
            } else {
                var5 = [0.0, 0.0, 1.0];
            }
        } else {
            var5 = [1.0, 0.0, 0.0];
        }
    }
    if (input[1] <= 4.5) {
        if (input[4] <= 0.18633899092674255) {
            if (input[3] <= 8.791666746139526) {
                var6 = [0.0, 1.0, 0.0];
            } else {
                if (input[5] <= 1.25) {
                    var6 = [1.0, 0.0, 0.0];
                } else {
                    var6 = [0.0, 1.0, 0.0];
                }
            }
        } else {
            if (input[0] <= 5.5) {
                if (input[1] <= 3.5) {
                    if (input[1] <= 2.5) {
                        var6 = [0.0, 1.0, 0.0];
                    } else {
                        var6 = [0.0, 0.0, 1.0];
                    }
                } else {
                    var6 = [0.0, 1.0, 0.0];
                }
            } else {
                var6 = [1.0, 0.0, 0.0];
            }
        }
    } else {
        if (input[10] <= 0.5) {
            if (input[7] <= 15.476190090179443) {
                if (input[9] <= 1.7222222089767456) {
                    if (input[7] <= 6.25) {
                        var6 = [0.0, 0.0, 1.0];
                    } else {
                        var6 = [0.0, 1.0, 0.0];
                    }
                } else {
                    var6 = [1.0, 0.0, 0.0];
                }
            } else {
                if (input[3] <= 11.166666507720947) {
                    if (input[4] <= 0.2357022613286972) {
                        var6 = [1.0, 0.0, 0.0];
                    } else {
                        if (input[3] <= 4.464285612106323) {
                            var6 = [0.0, 0.0, 1.0];
                        } else {
                            if (input[5] <= 0.7254734337329865) {
                                var6 = [0.0, 1.0, 0.0];
                            } else {
                                if (input[0] <= 3.5) {
                                    var6 = [1.0, 0.0, 0.0];
                                } else {
                                    var6 = [0.0, 0.0, 1.0];
                                }
                            }
                        }
                    }
                } else {
                    if (input[9] <= 1.625) {
                        var6 = [0.0, 1.0, 0.0];
                    } else {
                        if (input[0] <= 14.0) {
                            if (input[2] <= 6.333333253860474) {
                                var6 = [0.0, 0.0, 1.0];
                            } else {
                                var6 = [1.0, 0.0, 0.0];
                            }
                        } else {
                            var6 = [1.0, 0.0, 0.0];
                        }
                    }
                }
            }
        } else {
            var6 = [1.0, 0.0, 0.0];
        }
    }
    if (input[4] <= 0.3863389939069748) {
        if (input[1] <= 3.5) {
            if (input[11] <= 1.5) {
                if (input[10] <= 2.5) {
                    var7 = [0.0, 1.0, 0.0];
                } else {
                    if (input[5] <= 0.4857022613286972) {
                        var7 = [0.0, 1.0, 0.0];
                    } else {
                        var7 = [0.6, 0.4, 0.0];
                    }
                }
            } else {
                if (input[5] <= 1.25) {
                    var7 = [1.0, 0.0, 0.0];
                } else {
                    if (input[1] <= 2.5) {
                        var7 = [0.0, 1.0, 0.0];
                    } else {
                        if (input[12] <= 1.5) {
                            var7 = [1.0, 0.0, 0.0];
                        } else {
                            var7 = [0.0, 1.0, 0.0];
                        }
                    }
                }
            }
        } else {
            var7 = [1.0, 0.0, 0.0];
        }
    } else {
        if (input[3] <= 9.633333683013916) {
            if (input[2] <= 6.166666746139526) {
                if (input[4] <= 0.9418420195579529) {
                    if (input[5] <= 1.095014065504074) {
                        if (input[7] <= 16.66666603088379) {
                            var7 = [0.0, 0.0, 1.0];
                        } else {
                            var7 = [0.0, 1.0, 0.0];
                        }
                    } else {
                        var7 = [0.0, 0.0, 1.0];
                    }
                } else {
                    var7 = [0.0, 0.0, 1.0];
                }
            } else {
                if (input[10] <= 0.5) {
                    if (input[3] <= 5.464285612106323) {
                        var7 = [0.0, 0.0, 1.0];
                    } else {
                        var7 = [0.0, 1.0, 0.0];
                    }
                } else {
                    var7 = [1.0, 0.0, 0.0];
                }
            }
        } else {
            if (input[7] <= 30.952380180358887) {
                if (input[4] <= 0.9851674735546112) {
                    if (input[5] <= 1.1943814158439636) {
                        var7 = [0.0, 1.0, 0.0];
                    } else {
                        if (input[9] <= 1.488888919353485) {
                            var7 = [0.0, 0.0, 1.0];
                        } else {
                            var7 = [1.0, 0.0, 0.0];
                        }
                    }
                } else {
                    if (input[12] <= 1.5) {
                        var7 = [0.0, 0.0, 1.0];
                    } else {
                        if (input[3] <= 10.803030014038086) {
                            var7 = [0.0, 0.0, 1.0];
                        } else {
                            var7 = [0.0, 1.0, 0.0];
                        }
                    }
                }
            } else {
                if (input[1] <= 7.5) {
                    var7 = [1.0, 0.0, 0.0];
                } else {
                    if (input[12] <= 1.5) {
                        var7 = [0.0, 1.0, 0.0];
                    } else {
                        var7 = [1.0, 0.0, 0.0];
                    }
                }
            }
        }
    }
    if (input[4] <= 0.45220860838890076) {
        if (input[12] <= 1.5) {
            if (input[3] <= 10.375) {
                if (input[1] <= 3.5) {
                    if (input[5] <= 2.062334656715393) {
                        var8 = [0.0, 1.0, 0.0];
                    } else {
                        var8 = [1.0, 0.0, 0.0];
                    }
                } else {
                    if (input[0] <= 3.0) {
                        var8 = [1.0, 0.0, 0.0];
                    } else {
                        var8 = [0.0, 0.0, 1.0];
                    }
                }
            } else {
                var8 = [1.0, 0.0, 0.0];
            }
        } else {
            var8 = [0.0, 1.0, 0.0];
        }
    } else {
        if (input[3] <= 13.775000095367432) {
            if (input[1] <= 11.0) {
                if (input[9] <= 1.3666666746139526) {
                    if (input[11] <= 1.5) {
                        if (input[6] <= 10.0) {
                            var8 = [0.0, 1.0, 0.0];
                        } else {
                            if (input[2] <= 2.549999952316284) {
                                var8 = [0.0, 1.0, 0.0];
                            } else {
                                var8 = [0.0, 0.0, 1.0];
                            }
                        }
                    } else {
                        if (input[5] <= 1.3645421862602234) {
                            var8 = [0.0, 1.0, 0.0];
                        } else {
                            if (input[5] <= 1.8470820784568787) {
                                var8 = [1.0, 0.0, 0.0];
                            } else {
                                var8 = [0.0, 0.0, 1.0];
                            }
                        }
                    }
                } else {
                    if (input[1] <= 5.5) {
                        if (input[6] <= 16.66666603088379) {
                            var8 = [0.0, 0.0, 1.0];
                        } else {
                            if (input[12] <= 1.5) {
                                var8 = [0.0, 0.0, 1.0];
                            } else {
                                var8 = [0.0, 1.0, 0.0];
                            }
                        }
                    } else {
                        if (input[10] <= 0.5) {
                            if (input[5] <= 0.7254734337329865) {
                                var8 = [0.0, 1.0, 0.0];
                            } else {
                                var8 = [0.0, 0.0, 1.0];
                            }
                        } else {
                            var8 = [1.0, 0.0, 0.0];
                        }
                    }
                }
            } else {
                var8 = [1.0, 0.0, 0.0];
            }
        } else {
            if (input[3] <= 23.708333015441895) {
                if (input[1] <= 5.5) {
                    if (input[5] <= 3.417717933654785) {
                        if (input[11] <= 1.5) {
                            var8 = [1.0, 0.0, 0.0];
                        } else {
                            var8 = [0.0, 0.0, 1.0];
                        }
                    } else {
                        var8 = [1.0, 0.0, 0.0];
                    }
                } else {
                    var8 = [0.0, 0.0, 1.0];
                }
            } else {
                var8 = [1.0, 0.0, 0.0];
            }
        }
    }
    if (input[9] <= 1.7222222089767456) {
        if (input[2] <= 5.833333492279053) {
            if (input[1] <= 2.5) {
                if (input[10] <= 2.5) {
                    var9 = [0.0, 1.0, 0.0];
                } else {
                    if (input[5] <= 0.25) {
                        var9 = [0.0, 1.0, 0.0];
                    } else {
                        var9 = [0.5, 0.5, 0.0];
                    }
                }
            } else {
                if (input[8] <= 6.666666507720947) {
                    if (input[3] <= 7.833333253860474) {
                        if (input[11] <= 1.5) {
                            if (input[9] <= 1.25) {
                                var9 = [0.0, 1.0, 0.0];
                            } else {
                                var9 = [0.0, 0.0, 1.0];
                            }
                        } else {
                            var9 = [0.0, 0.0, 1.0];
                        }
                    } else {
                        if (input[11] <= 1.5) {
                            var9 = [0.0, 1.0, 0.0];
                        } else {
                            var9 = [1.0, 0.0, 0.0];
                        }
                    }
                } else {
                    var9 = [0.0, 0.0, 1.0];
                }
            }
        } else {
            if (input[3] <= 11.25) {
                var9 = [0.0, 1.0, 0.0];
            } else {
                if (input[12] <= 1.5) {
                    var9 = [1.0, 0.0, 0.0];
                } else {
                    var9 = [0.0, 1.0, 0.0];
                }
            }
        }
    } else {
        if (input[4] <= 0.9374448955059052) {
            if (input[11] <= 1.5) {
                if (input[8] <= 50.0) {
                    var9 = [0.0, 1.0, 0.0];
                } else {
                    var9 = [1.0, 0.0, 0.0];
                }
            } else {
                var9 = [1.0, 0.0, 0.0];
            }
        } else {
            if (input[1] <= 7.5) {
                if (input[5] <= 2.2999948263168335) {
                    var9 = [0.0, 0.0, 1.0];
                } else {
                    var9 = [1.0, 0.0, 0.0];
                }
            } else {
                if (input[2] <= 8.08730149269104) {
                    var9 = [1.0, 0.0, 0.0];
                } else {
                    var9 = [0.0, 0.0, 1.0];
                }
            }
        }
    }
    if (input[3] <= 4.099999904632568) {
        if (input[2] <= 2.75) {
            var10 = [0.0, 1.0, 0.0];
        } else {
            if (input[0] <= 1.5) {
                if (input[5] <= 0.4857022613286972) {
                    var10 = [0.0, 1.0, 0.0];
                } else {
                    var10 = [1.0, 0.0, 0.0];
                }
            } else {
                var10 = [0.0, 0.0, 1.0];
            }
        }
    } else {
        if (input[3] <= 9.633333683013916) {
            if (input[9] <= 4.0) {
                if (input[8] <= 45.0) {
                    if (input[5] <= 0.24494896829128265) {
                        var10 = [1.0, 0.0, 0.0];
                    } else {
                        if (input[3] <= 6.625) {
                            if (input[9] <= 1.5) {
                                var10 = [0.0, 1.0, 0.0];
                            } else {
                                var10 = [0.0, 0.0, 1.0];
                            }
                        } else {
                            if (input[5] <= 0.7581702470779419) {
                                var10 = [0.0, 1.0, 0.0];
                            } else {
                                var10 = [0.0, 0.0, 1.0];
                            }
                        }
                    }
                } else {
                    var10 = [1.0, 0.0, 0.0];
                }
            } else {
                var10 = [1.0, 0.0, 0.0];
            }
        } else {
            if (input[9] <= 1.2678571343421936) {
                if (input[3] <= 12.75) {
                    var10 = [1.0, 0.0, 0.0];
                } else {
                    if (input[7] <= 7.142857074737549) {
                        var10 = [0.0, 0.0, 1.0];
                    } else {
                        var10 = [0.0, 1.0, 0.0];
                    }
                }
            } else {
                if (input[1] <= 7.5) {
                    var10 = [1.0, 0.0, 0.0];
                } else {
                    if (input[4] <= 1.2661237716674805) {
                        var10 = [0.0, 0.0, 1.0];
                    } else {
                        if (input[4] <= 2.6218982934951782) {
                            if (input[5] <= 1.6211378574371338) {
                                var10 = [0.0, 1.0, 0.0];
                            } else {
                                var10 = [1.0, 0.0, 0.0];
                            }
                        } else {
                            var10 = [1.0, 0.0, 0.0];
                        }
                    }
                }
            }
        }
    }
    if (input[4] <= 0.45220860838890076) {
        if (input[7] <= 43.75) {
            if (input[10] <= 6.5) {
                if (input[11] <= 1.5) {
                    var11 = [0.0, 1.0, 0.0];
                } else {
                    if (input[2] <= 10.550000190734863) {
                        var11 = [1.0, 0.0, 0.0];
                    } else {
                        var11 = [0.0, 1.0, 0.0];
                    }
                }
            } else {
                var11 = [0.0, 1.0, 0.0];
            }
        } else {
            if (input[0] <= 2.5) {
                if (input[2] <= 9.0) {
                    if (input[3] <= 2.333333373069763) {
                        if (input[7] <= 58.33333206176758) {
                            if (input[3] <= 1.75) {
                                var11 = [0.0, 1.0, 0.0];
                            } else {
                                var11 = [1.0, 0.0, 0.0];
                            }
                        } else {
                            var11 = [0.0, 1.0, 0.0];
                        }
                    } else {
                        var11 = [0.0, 1.0, 0.0];
                    }
                } else {
                    var11 = [1.0, 0.0, 0.0];
                }
            } else {
                var11 = [0.0, 1.0, 0.0];
            }
        }
    } else {
        if (input[2] <= 5.0333333015441895) {
            if (input[4] <= 1.7146530747413635) {
                if (input[3] <= 9.375) {
                    if (input[8] <= 26.66666603088379) {
                        var11 = [0.0, 0.0, 1.0];
                    } else {
                        if (input[0] <= 2.5) {
                            var11 = [0.0, 0.0, 1.0];
                        } else {
                            var11 = [0.0, 1.0, 0.0];
                        }
                    }
                } else {
                    if (input[11] <= 2.5) {
                        if (input[6] <= 7.142857074737549) {
                            var11 = [0.0, 0.0, 1.0];
                        } else {
                            var11 = [1.0, 0.0, 0.0];
                        }
                    } else {
                        var11 = [1.0, 0.0, 0.0];
                    }
                }
            } else {
                var11 = [0.0, 1.0, 0.0];
            }
        } else {
            if (input[8] <= 58.33333206176758) {
                if (input[11] <= 2.5) {
                    if (input[2] <= 6.041666746139526) {
                        var11 = [0.0, 0.0, 1.0];
                    } else {
                        if (input[4] <= 1.047722578048706) {
                            if (input[7] <= 28.571428298950195) {
                                var11 = [1.0, 0.0, 0.0];
                            } else {
                                var11 = [0.0, 0.0, 1.0];
                            }
                        } else {
                            if (input[1] <= 10.5) {
                                var11 = [0.0, 1.0, 0.0];
                            } else {
                                var11 = [1.0, 0.0, 0.0];
                            }
                        }
                    }
                } else {
                    if (input[1] <= 5.5) {
                        var11 = [1.0, 0.0, 0.0];
                    } else {
                        if (input[8] <= 5.55555534362793) {
                            var11 = [1.0, 0.0, 0.0];
                        } else {
                            var11 = [0.0, 1.0, 0.0];
                        }
                    }
                }
            } else {
                var11 = [1.0, 0.0, 0.0];
            }
        }
    }

    if (input[8] <= 66.66666793823242) {
        if (input[2] <= 6.166666746139526) {
            if (input[9] <= 1.100000023841858) {
                if (input[4] <= 0.48065122961997986) {
                    if (input[2] <= 2.75) {
                        var12 = [0.0, 1.0, 0.0];
                    } else {
                        if (input[2] <= 3.708333373069763) {
                            if (input[2] <= 3.333333373069763) {
                                if (input[5] <= 0.7214045226573944) {
                                    var12 = [0.6, 0.4, 0.0];
                                } else {
                                    var12 = [0.0, 1.0, 0.0];
                                }
                            } else {
                                var12 = [1.0, 0.0, 0.0];
                            }
                        } else {
                            var12 = [0.0, 1.0, 0.0];
                        }
                    }
                } else {
                    var12 = [0.0, 0.0, 1.0];
                }
            } else {
                if (input[3] <= 2.2333332896232605) {
                    var12 = [0.0, 1.0, 0.0];
                } else {
                    if (input[11] <= 1.5) {
                        if (input[3] <= 3.6999999284744263) {
                            if (input[6] <= 41.66666603088379) {
                                var12 = [0.0, 1.0, 0.0];
                            } else {
                                var12 = [0.0, 0.0, 1.0];
                            }
                        } else {
                            var12 = [0.0, 0.0, 1.0];
                        }
                    } else {
                        if (input[2] <= 3.547619104385376) {
                            var12 = [1.0, 0.0, 0.0];
                        } else {
                            if (input[8] <= 5.0) {
                                if (input[0] <= 7.5) {
                                    var12 = [0.0, 0.0, 1.0];
                                } else {
                                    if (input[3] <= 15.666666984558105) {
                                        var12 = [1.0, 0.0, 0.0];
                                    } else {
                                        var12 = [0.0, 0.0, 1.0];
                                    }
                                }
                            } else {
                                var12 = [0.0, 0.0, 1.0];
                            }
                        }
                    }
                }
            }
        } else {
            if (input[9] <= 2.166666626930237) {
                if (input[9] <= 1.8333333134651184) {
                    if (input[1] <= 2.5) {
                        if (input[12] <= 2.0) {
                            var12 = [1.0, 0.0, 0.0];
                        } else {
                            var12 = [0.0, 1.0, 0.0];
                        }
                    } else {
                        var12 = [0.0, 1.0, 0.0];
                    }
                } else {
                    if (input[5] <= 0.7071067839860916) {
                        var12 = [0.0, 1.0, 0.0];
                    } else {
                        var12 = [1.0, 0.0, 0.0];
                    }
                }
            } else {
                if (input[10] <= 0.5) {
                    var12 = [0.0, 0.0, 1.0];
                } else {
                    var12 = [1.0, 0.0, 0.0];
                }
            }
        }
    } else {
        var12 = [1.0, 0.0, 0.0];
    }
    ;
    if (input[2] <= 6.604166746139526) {
        if (input[10] <= 0.5) {
            if (input[0] <= 7.5) {
                if (input[1] <= 2.5) {
                    if (input[3] <= 7.75) {
                        var13 = [1.0, 0.0, 0.0];
                    } else {
                        var13 = [0.0, 1.0, 0.0];
                    }
                } else {
                    if (input[9] <= 2.5) {
                        if (input[7] <= 8.333333015441895) {
                            if (input[4] <= 0.9398373067378998) {
                                var13 = [0.0, 0.0, 1.0];
                            } else {
                                var13 = [0.0, 1.0, 0.0];
                            }
                        } else {
                            if (input[11] <= 1.5) {
                                var13 = [0.0, 0.0, 1.0];
                            } else {
                                if (input[6] <= 15.476190090179443) {
                                    if (input[2] <= 3.614285707473755) {
                                        if (input[0] <= 6.0) {
                                            var13 = [0.0, 0.0, 1.0];
                                        } else {
                                            var13 = [1.0, 0.0, 0.0];
                                        }
                                    } else {
                                        var13 = [0.0, 0.0, 1.0];
                                    }
                                } else {
                                    var13 = [1.0, 0.0, 0.0];
                                }
                            }
                        }
                    } else {
                        if (input[0] <= 4.5) {
                            var13 = [1.0, 0.0, 0.0];
                        } else {
                            var13 = [0.0, 0.0, 1.0];
                        }
                    }
                }
            } else {
                if (input[0] <= 9.5) {
                    var13 = [1.0, 0.0, 0.0];
                } else {
                    if (input[11] <= 1.5) {
                        var13 = [0.0, 1.0, 0.0];
                    } else {
                        if (input[11] <= 3.0) {
                            var13 = [0.0, 0.0, 1.0];
                        } else {
                            var13 = [1.0, 0.0, 0.0];
                        }
                    }
                }
            }
        } else {
            if (input[11] <= 2.0) {
                if (input[7] <= 58.33333206176758) {
                    if (input[5] <= 0.25) {
                        var13 = [0.0, 1.0, 0.0];
                    } else {
                        var13 = [1.0, 0.0, 0.0];
                    }
                } else {
                    var13 = [0.0, 1.0, 0.0];
                }
            } else {
                var13 = [1.0, 0.0, 0.0];
            }
        }
    } else {
        if (input[9] <= 2.2777777910232544) {
            if (input[8] <= 37.5) {
                if (input[2] <= 10.25) {
                    var13 = [0.0, 1.0, 0.0];
                } else {
                    if (input[12] <= 1.5) {
                        var13 = [1.0, 0.0, 0.0];
                    } else {
                        var13 = [0.0, 1.0, 0.0];
                    }
                }
            } else {
                var13 = [1.0, 0.0, 0.0];
            }
        } else {
            if (input[9] <= 3.642857074737549) {
                var13 = [1.0, 0.0, 0.0];
            } else {
                if (input[9] <= 5.200000047683716) {
                    if (input[4] <= 0.75) {
                        var13 = [1.0, 0.0, 0.0];
                    } else {
                        var13 = [0.0, 0.0, 1.0];
                    }
                } else {
                    var13 = [1.0, 0.0, 0.0];
                }
            }
        }
    }
    ;
    if (input[5] <= 1.1236095428466797) {
        if (input[11] <= 1.5) {
            if (input[2] <= 3.5) {
                if (input[10] <= 2.5) {
                    var14 = [0.0, 1.0, 0.0];
                } else {
                    var14 = [0.3333333333333333, 0.6666666666666666, 0.0];
                }
            } else {
                if (input[5] <= 0.8859826326370239) {
                    if (input[4] <= 0.45220860838890076) {
                        if (input[8] <= 50.0) {
                            var14 = [0.0, 1.0, 0.0];
                        } else {
                            var14 = [1.0, 0.0, 0.0];
                        }
                    } else {
                        if (input[2] <= 8.75) {
                            if (input[9] <= 1.3666666746139526) {
                                var14 = [0.0, 1.0, 0.0];
                            } else {
                                var14 = [0.0, 0.0, 1.0];
                            }
                        } else {
                            var14 = [0.0, 1.0, 0.0];
                        }
                    }
                } else {
                    var14 = [1.0, 0.0, 0.0];
                }
            }
        } else {
            var14 = [1.0, 0.0, 0.0];
        }
    } else {
        if (input[2] <= 6.388888835906982) {
            if (input[1] <= 2.5) {
                var14 = [0.0, 1.0, 0.0];
            } else {
                if (input[5] <= 1.3367033004760742) {
                    if (input[0] <= 5.5) {
                        var14 = [0.0, 0.0, 1.0];
                    } else {
                        var14 = [1.0, 0.0, 0.0];
                    }
                } else {
                    if (input[2] <= 4.888888835906982) {
                        if (input[0] <= 6.5) {
                            var14 = [0.0, 0.0, 1.0];
                        } else {
                            if (input[9] <= 1.4428571462631226) {
                                var14 = [1.0, 0.0, 0.0];
                            } else {
                                if (input[4] <= 0.7576011121273041) {
                                    var14 = [0.0, 0.0, 1.0];
                                } else {
                                    var14 = [1.0, 0.0, 0.0];
                                }
                            }
                        }
                    } else {
                        var14 = [0.0, 0.0, 1.0];
                    }
                }
            }
        } else {
            if (input[3] <= 22.273109436035156) {
                if (input[2] <= 8.642857074737549) {
                    if (input[8] <= 5.55555534362793) {
                        var14 = [1.0, 0.0, 0.0];
                    } else {
                        if (input[4] <= 2.3423160314559937) {
                            var14 = [0.0, 1.0, 0.0];
                        } else {
                            var14 = [1.0, 0.0, 0.0];
                        }
                    }
                } else {
                    var14 = [0.0, 0.0, 1.0];
                }
            } else {
                var14 = [0.0, 1.0, 0.0];
            }
        }
    }
    ;
    if (input[2] <= 2.549999952316284) {
        var15 = [0.0, 1.0, 0.0];
    } else {
        if (input[11] <= 1.5) {
            if (input[0] <= 1.5) {
                if (input[1] <= 4.5) {
                    var15 = [0.0, 1.0, 0.0];
                } else {
                    var15 = [1.0, 0.0, 0.0];
                }
            } else {
                if (input[5] <= 1.095014065504074) {
                    if (input[3] <= 4.547618865966797) {
                        var15 = [0.0, 0.0, 1.0];
                    } else {
                        if (input[9] <= 1.100000023841858) {
                            var15 = [0.0, 1.0, 0.0];
                        } else {
                            if (input[3] <= 6.75) {
                                var15 = [0.0, 1.0, 0.0];
                            } else {
                                var15 = [0.0, 0.0, 1.0];
                            }
                        }
                    }
                } else {
                    var15 = [0.0, 0.0, 1.0];
                }
            }
        } else {
            if (input[5] <= 0.4860784709453583) {
                var15 = [1.0, 0.0, 0.0];
            } else {
                if (input[9] <= 1.2428571581840515) {
                    if (input[5] <= 1.0448623895645142) {
                        var15 = [1.0, 0.0, 0.0];
                    } else {
                        if (input[7] <= 58.33333206176758) {
                            var15 = [0.0, 1.0, 0.0];
                        } else {
                            var15 = [0.0, 0.0, 1.0];
                        }
                    }
                } else {
                    if (input[11] <= 2.5) {
                        if (input[5] <= 1.9680446982383728) {
                            if (input[7] <= 14.583333015441895) {
                                var15 = [0.0, 1.0, 0.0];
                            } else {
                                if (input[3] <= 9.946428775787354) {
                                    if (input[1] <= 5.0) {
                                        var15 = [1.0, 0.0, 0.0];
                                    } else {
                                        var15 = [0.0, 0.0, 1.0];
                                    }
                                } else {
                                    var15 = [0.0, 0.0, 1.0];
                                }
                            }
                        } else {
                            if (input[0] <= 10.5) {
                                var15 = [1.0, 0.0, 0.0];
                            } else {
                                var15 = [0.0, 0.0, 1.0];
                            }
                        }
                    } else {
                        var15 = [1.0, 0.0, 0.0];
                    }
                }
            }
        }
    }
    ;
    if (input[4] <= 0.45220860838890076) {
        if (input[5] <= 1.25) {
            if (input[2] <= 4.399999976158142) {
                if (input[8] <= 10.0) {
                    if (input[2] <= 2.5) {
                        var16 = [0.0, 1.0, 0.0];
                    } else {
                        var16 = [1.0, 0.0, 0.0];
                    }
                } else {
                    var16 = [0.0, 0.0, 1.0];
                }
            } else {
                if (input[11] <= 1.5) {
                    var16 = [0.0, 1.0, 0.0];
                } else {
                    var16 = [1.0, 0.0, 0.0];
                }
            }
        } else {
            var16 = [0.0, 1.0, 0.0];
        }
    } else {
        if (input[7] <= 15.476190090179443) {
            if (input[8] <= 6.666666507720947) {
                if (input[9] <= 1.7222222089767456) {
                    var16 = [0.0, 1.0, 0.0];
                } else {
                    var16 = [1.0, 0.0, 0.0];
                }
            } else {
                var16 = [0.0, 0.0, 1.0];
            }
        } else {
            if (input[3] <= 10.545454502105713) {
                if (input[5] <= 1.1785112917423248) {
                    if (input[8] <= 58.33333206176758) {
                        if (input[2] <= 8.75) {
                            if (input[2] <= 3.0) {
                                if (input[12] <= 1.5) {
                                    var16 = [0.0, 0.0, 1.0];
                                } else {
                                    var16 = [0.0, 1.0, 0.0];
                                }
                            } else {
                                var16 = [0.0, 0.0, 1.0];
                            }
                        } else {
                            var16 = [0.0, 1.0, 0.0];
                        }
                    } else {
                        var16 = [1.0, 0.0, 0.0];
                    }
                } else {
                    var16 = [0.0, 0.0, 1.0];
                }
            } else {
                if (input[7] <= 20.09803867340088) {
                    var16 = [0.0, 0.0, 1.0];
                } else {
                    if (input[0] <= 10.5) {
                        var16 = [1.0, 0.0, 0.0];
                    } else {
                        if (input[1] <= 12.5) {
                            var16 = [0.0, 1.0, 0.0];
                        } else {
                            var16 = [1.0, 0.0, 0.0];
                        }
                    }
                }
            }
        }
    }
    ;
    if (input[4] <= 2.179014563560486) {
        if (input[3] <= 6.761904716491699) {
            if (input[1] <= 3.5) {
                if (input[7] <= 58.33333206176758) {
                    if (input[2] <= 4.333333373069763) {
                        if (input[5] <= 0.7214045226573944) {
                            if (input[7] <= 25.0) {
                                var17 = [1.0, 0.0, 0.0];
                            } else {
                                var17 = [0.5, 0.5, 0.0];
                            }
                        } else {
                            var17 = [0.0, 1.0, 0.0];
                        }
                    } else {
                        var17 = [0.0, 1.0, 0.0];
                    }
                } else {
                    var17 = [0.0, 1.0, 0.0];
                }
            } else {
                if (input[7] <= 10.0) {
                    var17 = [0.0, 1.0, 0.0];
                } else {
                    if (input[2] <= 2.5) {
                        if (input[3] <= 3.100000023841858) {
                            var17 = [0.0, 0.0, 1.0];
                        } else {
                            var17 = [0.0, 1.0, 0.0];
                        }
                    } else {
                        if (input[4] <= 0.2357022613286972) {
                            var17 = [1.0, 0.0, 0.0];
                        } else {
                            var17 = [0.0, 0.0, 1.0];
                        }
                    }
                }
            }
        } else {
            if (input[8] <= 5.0) {
                if (input[4] <= 1.2546536922454834) {
                    if (input[2] <= 3.114285707473755) {
                        if (input[3] <= 7.833333253860474) {
                            var17 = [0.0, 0.0, 1.0];
                        } else {
                            var17 = [1.0, 0.0, 0.0];
                        }
                    } else {
                        if (input[1] <= 4.5) {
                            if (input[3] <= 11.125) {
                                if (input[4] <= 0.9094497561454773) {
                                    var17 = [0.0, 1.0, 0.0];
                                } else {
                                    var17 = [1.0, 0.0, 0.0];
                                }
                            } else {
                                var17 = [1.0, 0.0, 0.0];
                            }
                        } else {
                            var17 = [1.0, 0.0, 0.0];
                        }
                    }
                } else {
                    if (input[0] <= 8.0) {
                        var17 = [0.0, 0.0, 1.0];
                    } else {
                        if (input[5] <= 2.494002342224121) {
                            var17 = [0.0, 1.0, 0.0];
                        } else {
                            var17 = [1.0, 0.0, 0.0];
                        }
                    }
                }
            } else {
                if (input[2] <= 6.055555582046509) {
                    var17 = [0.0, 0.0, 1.0];
                } else {
                    if (input[0] <= 3.5) {
                        var17 = [1.0, 0.0, 0.0];
                    } else {
                        var17 = [0.0, 1.0, 0.0];
                    }
                }
            }
        }
    } else {
        if (input[4] <= 2.4203792810440063) {
            if (input[5] <= 3.407714009284973) {
                var17 = [0.0, 0.0, 1.0];
            } else {
                var17 = [1.0, 0.0, 0.0];
            }
        } else {
            var17 = [1.0, 0.0, 0.0];
        }
    }
    ;
    if (input[9] <= 2.5277777910232544) {
        if (input[3] <= 6.583333253860474) {
            if (input[5] <= 0.43570226430892944) {
                if (input[6] <= 25.0) {
                    if (input[5] <= 0.20000000298023224) {
                        var18 = [0.0, 1.0, 0.0];
                    } else {
                        var18 = [0.0, 0.0, 1.0];
                    }
                } else {
                    var18 = [0.0, 0.0, 1.0];
                }
            } else {
                if (input[9] <= 1.4166666865348816) {
                    if (input[10] <= 1.5) {
                        var18 = [0.0, 1.0, 0.0];
                    } else {
                        var18 = [0.3333333333333333, 0.6666666666666666, 0.0];
                    }
                } else {
                    if (input[3] <= 4.099999904632568) {
                        var18 = [0.0, 1.0, 0.0];
                    } else {
                        var18 = [0.0, 0.0, 1.0];
                    }
                }
            }
        } else {
            if (input[5] <= 0.7254734337329865) {
                var18 = [0.0, 1.0, 0.0];
            } else {
                if (input[4] <= 1.619306743144989) {
                    if (input[11] <= 3.0) {
                        if (input[8] <= 6.666666507720947) {
                            if (input[2] <= 4.047618985176086) {
                                if (input[4] <= 0.7398206144571304) {
                                    var18 = [0.0, 0.0, 1.0];
                                } else {
                                    var18 = [1.0, 0.0, 0.0];
                                }
                            } else {
                                var18 = [0.0, 0.0, 1.0];
                            }
                        } else {
                            var18 = [0.0, 0.0, 1.0];
                        }
                    } else {
                        var18 = [1.0, 0.0, 0.0];
                    }
                } else {
                    if (input[5] <= 2.8800069093704224) {
                        var18 = [0.0, 1.0, 0.0];
                    } else {
                        var18 = [1.0, 0.0, 0.0];
                    }
                }
            }
        }
    } else {
        if (input[7] <= 43.75) {
            var18 = [1.0, 0.0, 0.0];
        } else {
            if (input[7] <= 63.33333206176758) {
                if (input[9] <= 2.833333373069763) {
                    var18 = [1.0, 0.0, 0.0];
                } else {
                    var18 = [0.0, 0.0, 1.0];
                }
            } else {
                var18 = [1.0, 0.0, 0.0];
            }
        }
    }
    ;
    if (input[9] <= 1.2678571343421936) {
        if (input[6] <= 3.3333332538604736) {
            if (input[4] <= 0.4165063500404358) {
                if (input[3] <= 12.75) {
                    if (input[3] <= 6.833333492279053) {
                        if (input[11] <= 1.5) {
                            var19 = [0.0, 1.0, 0.0];
                        } else {
                            var19 = [1.0, 0.0, 0.0];
                        }
                    } else {
                        if (input[8] <= 10.0) {
                            var19 = [1.0, 0.0, 0.0];
                        } else {
                            var19 = [0.0, 0.0, 1.0];
                        }
                    }
                } else {
                    var19 = [0.0, 1.0, 0.0];
                }
            } else {
                var19 = [0.0, 1.0, 0.0];
            }
        } else {
            if (input[0] <= 3.5) {
                var19 = [0.0, 1.0, 0.0];
            } else {
                var19 = [0.0, 0.0, 1.0];
            }
        }
    } else {
        if (input[2] <= 6.541666746139526) {
            if (input[3] <= 9.375) {
                if (input[10] <= 2.5) {
                    if (input[9] <= 2.5) {
                        if (input[8] <= 26.66666603088379) {
                            if (input[4] <= 0.42204125225543976) {
                                var19 = [1.0, 0.0, 0.0];
                            } else {
                                var19 = [0.0, 0.0, 1.0];
                            }
                        } else {
                            if (input[2] <= 3.0) {
                                var19 = [0.0, 1.0, 0.0];
                            } else {
                                var19 = [0.0, 0.0, 1.0];
                            }
                        }
                    } else {
                        var19 = [1.0, 0.0, 0.0];
                    }
                } else {
                    var19 = [0.0, 1.0, 0.0];
                }
            } else {
                if (input[3] <= 15.666666984558105) {
                    var19 = [1.0, 0.0, 0.0];
                } else {
                    if (input[5] <= 3.6248546838760376) {
                        var19 = [0.0, 0.0, 1.0];
                    } else {
                        var19 = [1.0, 0.0, 0.0];
                    }
                }
            }
        } else {
            if (input[0] <= 1.5) {
                if (input[12] <= 1.5) {
                    if (input[3] <= 2.2500000596046448) {
                        var19 = [1.0, 0.0, 0.0];
                    } else {
                        var19 = [0.0, 1.0, 0.0];
                    }
                } else {
                    var19 = [0.0, 1.0, 0.0];
                }
            } else {
                if (input[12] <= 1.5) {
                    var19 = [1.0, 0.0, 0.0];
                } else {
                    if (input[2] <= 7.697916507720947) {
                        var19 = [1.0, 0.0, 0.0];
                    } else {
                        var19 = [0.0, 1.0, 0.0];
                    }
                }
            }
        }
    }
    ;
    if (input[2] <= 2.583333373069763) {
        var20 = [0.0, 1.0, 0.0];
    } else {
        if (input[5] <= 2.0807149410247803) {
            if (input[10] <= 0.5) {
                if (input[5] <= 1.5702679753303528) {
                    if (input[2] <= 6.0) {
                        if (input[9] <= 1.100000023841858) {
                            if (input[5] <= 0.4714045226573944) {
                                var20 = [1.0, 0.0, 0.0];
                            } else {
                                var20 = [0.0, 1.0, 0.0];
                            }
                        } else {
                            if (input[8] <= 58.33333206176758) {
                                var20 = [0.0, 0.0, 1.0];
                            } else {
                                var20 = [1.0, 0.0, 0.0];
                            }
                        }
                    } else {
                        if (input[11] <= 3.0) {
                            if (input[1] <= 4.5) {
                                var20 = [0.0, 1.0, 0.0];
                            } else {
                                if (input[1] <= 7.5) {
                                    if (input[4] <= 0.46650634706020355) {
                                        var20 = [0.0, 1.0, 0.0];
                                    } else {
                                        if (input[9] <= 1.9166666269302368) {
                                            var20 = [0.0, 1.0, 0.0];
                                        } else {
                                            var20 = [0.0, 0.0, 1.0];
                                        }
                                    }
                                } else {
                                    var20 = [0.0, 1.0, 0.0];
                                }
                            }
                        } else {
                            var20 = [1.0, 0.0, 0.0];
                        }
                    }
                } else {
                    var20 = [0.0, 0.0, 1.0];
                }
            } else {
                if (input[1] <= 4.5) {
                    if (input[0] <= 1.5) {
                        if (input[10] <= 4.0) {
                            var20 = [0.5, 0.5, 0.0];
                        } else {
                            var20 = [0.0, 1.0, 0.0];
                        }
                    } else {
                        var20 = [1.0, 0.0, 0.0];
                    }
                } else {
                    var20 = [1.0, 0.0, 0.0];
                }
            }
        } else {
            if (input[9] <= 1.1666666865348816) {
                var20 = [0.0, 1.0, 0.0];
            } else {
                if (input[5] <= 2.857627511024475) {
                    var20 = [1.0, 0.0, 0.0];
                } else {
                    if (input[4] <= 0.7201562225818634) {
                        if (input[4] <= 0.5651051849126816) {
                            var20 = [1.0, 0.0, 0.0];
                        } else {
                            var20 = [0.0, 0.0, 1.0];
                        }
                    } else {
                        var20 = [1.0, 0.0, 0.0];
                    }
                }
            }
        }
    }
    ;
    if (input[5] <= 2.0840890407562256) {
        if (input[1] <= 2.5) {
            if (input[5] <= 0.25) {
                var21 = [0.0, 1.0, 0.0];
            } else {
                if (input[8] <= 12.5) {
                    if (input[5] <= 0.75) {
                        if (input[2] <= 2.5) {
                            var21 = [0.0, 1.0, 0.0];
                        } else {
                            var21 = [1.0, 0.0, 0.0];
                        }
                    } else {
                        var21 = [1.0, 0.0, 0.0];
                    }
                } else {
                    var21 = [0.0, 1.0, 0.0];
                }
            }
        } else {
            if (input[8] <= 7.142857074737549) {
                if (input[9] <= 1.4166666865348816) {
                    if (input[7] <= 41.66666603088379) {
                        var21 = [0.0, 1.0, 0.0];
                    } else {
                        if (input[6] <= 7.142857074737549) {
                            var21 = [0.0, 0.0, 1.0];
                        } else {
                            var21 = [1.0, 0.0, 0.0];
                        }
                    }
                } else {
                    if (input[4] <= 0.2357022613286972) {
                        if (input[10] <= 3.5) {
                            var21 = [1.0, 0.0, 0.0];
                        } else {
                            var21 = [0.0, 1.0, 0.0];
                        }
                    } else {
                        if (input[0] <= 5.0) {
                            var21 = [0.0, 0.0, 1.0];
                        } else {
                            if (input[7] <= 6.25) {
                                var21 = [1.0, 0.0, 0.0];
                            } else {
                                var21 = [0.0, 1.0, 0.0];
                            }
                        }
                    }
                }
            } else {
                if (input[12] <= 1.5) {
                    if (input[2] <= 6.0) {
                        var21 = [0.0, 0.0, 1.0];
                    } else {
                        if (input[1] <= 5.0) {
                            var21 = [1.0, 0.0, 0.0];
                        } else {
                            var21 = [0.0, 0.0, 1.0];
                        }
                    }
                } else {
                    if (input[4] <= 0.6582483053207397) {
                        var21 = [1.0, 0.0, 0.0];
                    } else {
                        if (input[5] <= 0.7254734337329865) {
                            var21 = [0.0, 1.0, 0.0];
                        } else {
                            if (input[0] <= 9.0) {
                                var21 = [0.0, 0.0, 1.0];
                            } else {
                                var21 = [0.0, 1.0, 0.0];
                            }
                        }
                    }
                }
            }
        }
    } else {
        if (input[1] <= 2.5) {
            var21 = [0.0, 1.0, 0.0];
        } else {
            if (input[0] <= 10.5) {
                var21 = [1.0, 0.0, 0.0];
            } else {
                if (input[3] <= 23.708333015441895) {
                    if (input[1] <= 11.5) {
                        var21 = [0.0, 0.0, 1.0];
                    } else {
                        var21 = [1.0, 0.0, 0.0];
                    }
                } else {
                    var21 = [1.0, 0.0, 0.0];
                }
            }
        }
    }
    ;
    if (input[4] <= 0.45220860838890076) {
        if (input[11] <= 1.5) {
            if (input[9] <= 3.5) {
                var22 = [0.0, 1.0, 0.0];
            } else {
                var22 = [1.0, 0.0, 0.0];
            }
        } else {
            if (input[4] <= 0.4028453379869461) {
                if (input[0] <= 4.5) {
                    var22 = [1.0, 0.0, 0.0];
                } else {
                    if (input[8] <= 8.333333015441895) {
                        var22 = [1.0, 0.0, 0.0];
                    } else {
                        if (input[3] <= 45.0) {
                            var22 = [0.0, 0.0, 1.0];
                        } else {
                            var22 = [0.0, 1.0, 0.0];
                        }
                    }
                }
            } else {
                var22 = [0.0, 1.0, 0.0];
            }
        }
    } else {
        if (input[3] <= 10.386363506317139) {
            if (input[9] <= 1.3666666746139526) {
                if (input[4] <= 0.48065122961997986) {
                    var22 = [0.0, 1.0, 0.0];
                } else {
                    if (input[8] <= 10.0) {
                        if (input[0] <= 4.5) {
                            var22 = [0.0, 1.0, 0.0];
                        } else {
                            var22 = [0.0, 0.0, 1.0];
                        }
                    } else {
                        var22 = [0.0, 0.0, 1.0];
                    }
                }
            } else {
                if (input[9] <= 5.200000047683716) {
                    if (input[4] <= 1.5998365879058838) {
                        var22 = [0.0, 0.0, 1.0];
                    } else {
                        if (input[12] <= 1.5) {
                            var22 = [1.0, 0.0, 0.0];
                        } else {
                            var22 = [0.0, 0.0, 1.0];
                        }
                    }
                } else {
                    var22 = [1.0, 0.0, 0.0];
                }
            }
        } else {
            if (input[2] <= 7.697916507720947) {
                if (input[5] <= 3.2592287063598633) {
                    if (input[3] <= 14.650000095367432) {
                        if (input[2] <= 5.055555582046509) {
                            var22 = [0.0, 0.0, 1.0];
                        } else {
                            var22 = [1.0, 0.0, 0.0];
                        }
                    } else {
                        if (input[1] <= 6.5) {
                            var22 = [0.0, 0.0, 1.0];
                        } else {
                            var22 = [0.0, 1.0, 0.0];
                        }
                    }
                } else {
                    var22 = [1.0, 0.0, 0.0];
                }
            } else {
                var22 = [0.0, 1.0, 0.0];
            }
        }
    }
    ;
    if (input[4] <= 0.42204125225543976) {
        if (input[11] <= 1.5) {
            if (input[7] <= 58.33333206176758) {
                if (input[2] <= 4.0) {
                    var23 = [0.6666666666666666, 0.3333333333333333, 0.0];
                } else {
                    var23 = [0.0, 1.0, 0.0];
                }
            } else {
                var23 = [0.0, 1.0, 0.0];
            }
        } else {
            if (input[3] <= 18.833333015441895) {
                var23 = [1.0, 0.0, 0.0];
            } else {
                var23 = [0.0, 1.0, 0.0];
            }
        }
    } else {
        if (input[8] <= 12.222221851348877) {
            if (input[11] <= 2.5) {
                if (input[3] <= 9.133333683013916) {
                    if (input[5] <= 0.8859826326370239) {
                        if (input[3] <= 5.464285612106323) {
                            var23 = [0.0, 0.0, 1.0];
                        } else {
                            var23 = [0.0, 1.0, 0.0];
                        }
                    } else {
                        var23 = [0.0, 0.0, 1.0];
                    }
                } else {
                    if (input[2] <= 5.055555582046509) {
                        var23 = [0.0, 0.0, 1.0];
                    } else {
                        if (input[1] <= 4.5) {
                            var23 = [0.0, 1.0, 0.0];
                        } else {
                            if (input[5] <= 1.1495760679244995) {
                                var23 = [0.0, 1.0, 0.0];
                            } else {
                                if (input[3] <= 15.416666984558105) {
                                    var23 = [1.0, 0.0, 0.0];
                                } else {
                                    var23 = [0.0, 0.0, 1.0];
                                }
                            }
                        }
                    }
                }
            } else {
                if (input[3] <= 15.107142925262451) {
                    var23 = [1.0, 0.0, 0.0];
                } else {
                    if (input[9] <= 1.399999976158142) {
                        var23 = [0.0, 1.0, 0.0];
                    } else {
                        var23 = [1.0, 0.0, 0.0];
                    }
                }
            }
        } else {
            if (input[2] <= 6.4375) {
                var23 = [0.0, 0.0, 1.0];
            } else {
                if (input[4] <= 2.6552042961120605) {
                    if (input[12] <= 4.5) {
                        var23 = [0.0, 1.0, 0.0];
                    } else {
                        var23 = [0.0, 0.0, 1.0];
                    }
                } else {
                    var23 = [1.0, 0.0, 0.0];
                }
            }
        }
    }
    ;
    if (input[4] <= 0.45220860838890076) {
        if (input[8] <= 37.5) {
            if (input[7] <= 43.75) {
                if (input[2] <= 5.333333373069763) {
                    if (input[8] <= 10.0) {
                        var24 = [1.0, 0.0, 0.0];
                    } else {
                        var24 = [0.0, 0.0, 1.0];
                    }
                } else {
                    if (input[11] <= 2.5) {
                        var24 = [0.0, 1.0, 0.0];
                    } else {
                        var24 = [1.0, 0.0, 0.0];
                    }
                }
            } else {
                if (input[10] <= 1.5) {
                    var24 = [0.0, 1.0, 0.0];
                } else {
                    if (input[5] <= 0.7357022613286972) {
                        var24 = [0.0, 1.0, 0.0];
                    } else {
                        var24 = [1.0, 0.0, 0.0];
                    }
                }
            }
        } else {
            var24 = [1.0, 0.0, 0.0];
        }
    } else {
        if (input[1] <= 12.0) {
            if (input[3] <= 11.416666507720947) {
                if (input[7] <= 14.583333015441895) {
                    if (input[4] <= 0.9204005599021912) {
                        var24 = [1.0, 0.0, 0.0];
                    } else {
                        var24 = [0.0, 1.0, 0.0];
                    }
                } else {
                    if (input[9] <= 5.200000047683716) {
                        if (input[8] <= 26.66666603088379) {
                            if (input[7] <= 41.66666603088379) {
                                if (input[5] <= 0.8532858192920685) {
                                    var24 = [0.0, 0.0, 1.0];
                                } else {
                                    if (input[4] <= 0.9735951125621796) {
                                        var24 = [0.0, 1.0, 0.0];
                                    } else {
                                        var24 = [0.0, 0.0, 1.0];
                                    }
                                }
                            } else {
                                var24 = [0.0, 0.0, 1.0];
                            }
                        } else {
                            if (input[5] <= 0.4258769750595093) {
                                if (input[4] <= 1.1582483053207397) {
                                    var24 = [0.0, 1.0, 0.0];
                                } else {
                                    var24 = [0.0, 0.0, 1.0];
                                }
                            } else {
                                var24 = [0.0, 0.0, 1.0];
                            }
                        }
                    } else {
                        var24 = [1.0, 0.0, 0.0];
                    }
                }
            } else {
                if (input[9] <= 1.6888889074325562) {
                    if (input[8] <= 10.55555534362793) {
                        var24 = [0.0, 0.0, 1.0];
                    } else {
                        var24 = [0.0, 1.0, 0.0];
                    }
                } else {
                    if (input[7] <= 20.833333015441895) {
                        if (input[6] <= 4.166666507720947) {
                            var24 = [1.0, 0.0, 0.0];
                        } else {
                            var24 = [0.0, 0.0, 1.0];
                        }
                    } else {
                        var24 = [1.0, 0.0, 0.0];
                    }
                }
            }
        } else {
            var24 = [1.0, 0.0, 0.0];
        }
    }
    ;
    if (input[2] <= 6.388888835906982) {
        if (input[5] <= 0.6318812966346741) {
            if (input[8] <= 25.0) {
                if (input[0] <= 2.5) {
                    if (input[9] <= 1.5) {
                        if (input[7] <= 58.33333206176758) {
                            if (input[3] <= 2.25) {
                                if (input[10] <= 2.5) {
                                    var25 = [0.0, 1.0, 0.0];
                                } else {
                                    var25 = [1.0, 0.0, 0.0];
                                }
                            } else {
                                var25 = [0.0, 1.0, 0.0];
                            }
                        } else {
                            var25 = [0.0, 1.0, 0.0];
                        }
                    } else {
                        var25 = [0.0, 1.0, 0.0];
                    }
                } else {
                    var25 = [1.0, 0.0, 0.0];
                }
            } else {
                var25 = [0.0, 0.0, 1.0];
            }
        } else {
            if (input[3] <= 9.675000190734863) {
                var25 = [0.0, 0.0, 1.0];
            } else {
                if (input[11] <= 2.5) {
                    if (input[1] <= 4.5) {
                        var25 = [1.0, 0.0, 0.0];
                    } else {
                        if (input[2] <= 3.25) {
                            var25 = [0.0, 1.0, 0.0];
                        } else {
                            var25 = [0.0, 0.0, 1.0];
                        }
                    }
                } else {
                    var25 = [1.0, 0.0, 0.0];
                }
            }
        }
    } else {
        if (input[3] <= 10.875) {
            if (input[9] <= 2.333333373069763) {
                var25 = [0.0, 1.0, 0.0];
            } else {
                if (input[4] <= 0.8726779818534851) {
                    var25 = [1.0, 0.0, 0.0];
                } else {
                    if (input[9] <= 3.642857074737549) {
                        var25 = [1.0, 0.0, 0.0];
                    } else {
                        if (input[0] <= 3.5) {
                            var25 = [0.0, 0.0, 1.0];
                        } else {
                            if (input[2] <= 8.642857074737549) {
                                var25 = [1.0, 0.0, 0.0];
                            } else {
                                var25 = [0.0, 0.0, 1.0];
                            }
                        }
                    }
                }
            }
        } else {
            if (input[9] <= 1.8777778148651123) {
                if (input[10] <= 1.5) {
                    var25 = [0.0, 1.0, 0.0];
                } else {
                    var25 = [1.0, 0.0, 0.0];
                }
            } else {
                var25 = [1.0, 0.0, 0.0];
            }
        }
    }
    ;
    if (input[4] <= 2.4203792810440063) {
        if (input[9] <= 1.7333332896232605) {
            if (input[4] <= 1.0813162922859192) {
                if (input[0] <= 4.5) {
                    if (input[2] <= 11.5) {
                        if (input[5] <= 0.25) {
                            if (input[11] <= 1.5) {
                                var26 = [0.0, 1.0, 0.0];
                            } else {
                                var26 = [1.0, 0.0, 0.0];
                            }
                        } else {
                            if (input[2] <= 5.958333253860474) {
                                if (input[2] <= 3.8333332538604736) {
                                    var26 = [0.0, 1.0, 0.0];
                                } else {
                                    var26 = [0.0, 0.0, 1.0];
                                }
                            } else {
                                var26 = [0.0, 1.0, 0.0];
                            }
                        }
                    } else {
                        var26 = [1.0, 0.0, 0.0];
                    }
                } else {
                    if (input[2] <= 3.033333420753479) {
                        if (input[2] <= 2.6333333253860474) {
                            var26 = [0.0, 0.0, 1.0];
                        } else {
                            var26 = [1.0, 0.0, 0.0];
                        }
                    } else {
                        if (input[0] <= 6.5) {
                            var26 = [0.0, 0.0, 1.0];
                        } else {
                            var26 = [1.0, 0.0, 0.0];
                        }
                    }
                }
            } else {
                if (input[7] <= 20.535714149475098) {
                    var26 = [0.0, 1.0, 0.0];
                } else {
                    if (input[3] <= 11.946428775787354) {
                        if (input[4] <= 1.4320356845855713) {
                            var26 = [0.0, 0.0, 1.0];
                        } else {
                            var26 = [0.0, 1.0, 0.0];
                        }
                    } else {
                        var26 = [0.0, 1.0, 0.0];
                    }
                }
            }
        } else {
            if (input[5] <= 0.8213316202163696) {
                if (input[10] <= 9.0) {
                    var26 = [0.0, 0.0, 1.0];
                } else {
                    var26 = [1.0, 0.0, 0.0];
                }
            } else {
                if (input[4] <= 1.2066758275032043) {
                    var26 = [1.0, 0.0, 0.0];
                } else {
                    if (input[5] <= 1.1585887968540192) {
                        var26 = [1.0, 0.0, 0.0];
                    } else {
                        var26 = [0.0, 0.0, 1.0];
                    }
                }
            }
        }
    } else {
        var26 = [1.0, 0.0, 0.0];
    }
    ;
    if (input[5] <= 0.8859826326370239) {
        if (input[8] <= 41.66666603088379) {
            if (input[9] <= 2.25) {
                if (input[1] <= 5.5) {
                    if (input[1] <= 2.5) {
                        if (input[7] <= 25.0) {
                            var27 = [1.0, 0.0, 0.0];
                        } else {
                            if (input[7] <= 75.0) {
                                if (input[3] <= 1.75) {
                                    var27 = [0.0, 1.0, 0.0];
                                } else {
                                    var27 = [0.5, 0.5, 0.0];
                                }
                            } else {
                                var27 = [0.0, 1.0, 0.0];
                            }
                        }
                    } else {
                        var27 = [0.0, 1.0, 0.0];
                    }
                } else {
                    if (input[7] <= 22.91666603088379) {
                        var27 = [0.0, 1.0, 0.0];
                    } else {
                        if (input[8] <= 22.5) {
                            var27 = [0.0, 0.0, 1.0];
                        } else {
                            var27 = [0.0, 1.0, 0.0];
                        }
                    }
                }
            } else {
                var27 = [0.0, 0.0, 1.0];
            }
        } else {
            if (input[11] <= 1.5) {
                var27 = [0.0, 0.0, 1.0];
            } else {
                var27 = [1.0, 0.0, 0.0];
            }
        }
    } else {
        if (input[3] <= 23.797618865966797) {
            if (input[1] <= 2.5) {
                if (input[5] <= 1.25) {
                    var27 = [1.0, 0.0, 0.0];
                } else {
                    var27 = [0.0, 1.0, 0.0];
                }
            } else {
                if (input[9] <= 1.9285714030265808) {
                    if (input[11] <= 2.5) {
                        if (input[0] <= 3.5) {
                            if (input[2] <= 3.8333332538604736) {
                                var27 = [0.0, 1.0, 0.0];
                            } else {
                                var27 = [0.0, 0.0, 1.0];
                            }
                        } else {
                            if (input[2] <= 3.547619104385376) {
                                if (input[0] <= 6.0) {
                                    var27 = [0.0, 0.0, 1.0];
                                } else {
                                    var27 = [1.0, 0.0, 0.0];
                                }
                            } else {
                                var27 = [0.0, 0.0, 1.0];
                            }
                        }
                    } else {
                        var27 = [0.0, 1.0, 0.0];
                    }
                } else {
                    if (input[1] <= 8.5) {
                        if (input[4] <= 0.9920296967029572) {
                            var27 = [1.0, 0.0, 0.0];
                        } else {
                            if (input[4] <= 1.33071631193161) {
                                var27 = [0.0, 0.0, 1.0];
                            } else {
                                if (input[9] <= 2.833333373069763) {
                                    var27 = [1.0, 0.0, 0.0];
                                } else {
                                    var27 = [0.0, 0.0, 1.0];
                                }
                            }
                        }
                    } else {
                        if (input[7] <= 51.28204917907715) {
                            var27 = [0.0, 0.0, 1.0];
                        } else {
                            var27 = [1.0, 0.0, 0.0];
                        }
                    }
                }
            }
        } else {
            if (input[8] <= 51.66666793823242) {
                var27 = [0.0, 1.0, 0.0];
            } else {
                var27 = [1.0, 0.0, 0.0];
            }
        }
    }
    ;
    if (input[9] <= 1.3666666746139526) {
        if (input[0] <= 4.5) {
            if (input[1] <= 2.5) {
                if (input[7] <= 25.0) {
                    var28 = [1.0, 0.0, 0.0];
                } else {
                    if (input[11] <= 1.5) {
                        var28 = [0.0, 1.0, 0.0];
                    } else {
                        if (input[8] <= 12.5) {
                            if (input[0] <= 2.5) {
                                var28 = [1.0, 0.0, 0.0];
                            } else {
                                var28 = [0.0, 1.0, 0.0];
                            }
                        } else {
                            var28 = [0.0, 1.0, 0.0];
                        }
                    }
                }
            } else {
                var28 = [0.0, 1.0, 0.0];
            }
        } else {
            if (input[12] <= 1.5) {
                if (input[2] <= 2.6333333253860474) {
                    var28 = [0.0, 0.0, 1.0];
                } else {
                    var28 = [1.0, 0.0, 0.0];
                }
            } else {
                if (input[7] <= 14.285714149475098) {
                    if (input[0] <= 5.5) {
                        var28 = [0.0, 1.0, 0.0];
                    } else {
                        var28 = [0.0, 0.0, 1.0];
                    }
                } else {
                    var28 = [0.0, 1.0, 0.0];
                }
            }
        }
    } else {
        if (input[8] <= 58.33333206176758) {
            if (input[10] <= 3.5) {
                if (input[9] <= 1.7333332896232605) {
                    if (input[2] <= 6.666666507720947) {
                        var28 = [0.0, 0.0, 1.0];
                    } else {
                        var28 = [0.0, 1.0, 0.0];
                    }
                } else {
                    if (input[4] <= 0.8082483112812042) {
                        var28 = [1.0, 0.0, 0.0];
                    } else {
                        if (input[11] <= 1.5) {
                            if (input[12] <= 1.5) {
                                var28 = [0.0, 0.0, 1.0];
                            } else {
                                if (input[6] <= 16.66666603088379) {
                                    var28 = [0.0, 0.0, 1.0];
                                } else {
                                    var28 = [0.0, 1.0, 0.0];
                                }
                            }
                        } else {
                            if (input[5] <= 1.941713571548462) {
                                var28 = [0.0, 0.0, 1.0];
                            } else {
                                var28 = [1.0, 0.0, 0.0];
                            }
                        }
                    }
                }
            } else {
                var28 = [0.0, 1.0, 0.0];
            }
        } else {
            var28 = [1.0, 0.0, 0.0];
        }
    }
    ;
    if (input[11] <= 1.5) {
        if (input[4] <= 0.48065122961997986) {
            if (input[0] <= 4.5) {
                if (input[5] <= 0.48065122961997986) {
                    var29 = [0.0, 1.0, 0.0];
                } else {
                    if (input[7] <= 36.66666603088379) {
                        var29 = [0.0, 1.0, 0.0];
                    } else {
                        if (input[1] <= 3.5) {
                            var29 = [0.5, 0.5, 0.0];
                        } else {
                            var29 = [0.0, 0.0, 1.0];
                        }
                    }
                }
            } else {
                var29 = [0.0, 0.0, 1.0];
            }
        } else {
            if (input[2] <= 6.166666746139526) {
                if (input[3] <= 11.675000190734863) {
                    var29 = [0.0, 0.0, 1.0];
                } else {
                    var29 = [0.0, 1.0, 0.0];
                }
            } else {
                if (input[9] <= 1.8333333134651184) {
                    var29 = [0.0, 1.0, 0.0];
                } else {
                    var29 = [0.0, 0.0, 1.0];
                }
            }
        }
    } else {
        if (input[8] <= 14.999999523162842) {
            if (input[2] <= 5.666666746139526) {
                if (input[11] <= 2.5) {
                    if (input[5] <= 0.4714045226573944) {
                        var29 = [1.0, 0.0, 0.0];
                    } else {
                        if (input[1] <= 4.5) {
                            if (input[2] <= 2.7333333492279053) {
                                var29 = [1.0, 0.0, 0.0];
                            } else {
                                if (input[6] <= 7.142857074737549) {
                                    var29 = [0.0, 0.0, 1.0];
                                } else {
                                    var29 = [1.0, 0.0, 0.0];
                                }
                            }
                        } else {
                            var29 = [0.0, 0.0, 1.0];
                        }
                    }
                } else {
                    var29 = [1.0, 0.0, 0.0];
                }
            } else {
                if (input[0] <= 8.5) {
                    if (input[9] <= 1.4375) {
                        if (input[3] <= 11.125) {
                            var29 = [0.0, 1.0, 0.0];
                        } else {
                            var29 = [1.0, 0.0, 0.0];
                        }
                    } else {
                        var29 = [1.0, 0.0, 0.0];
                    }
                } else {
                    var29 = [0.0, 1.0, 0.0];
                }
            }
        } else {
            if (input[8] <= 37.5) {
                if (input[4] <= 1.752532109618187) {
                    var29 = [0.0, 1.0, 0.0];
                } else {
                    var29 = [1.0, 0.0, 0.0];
                }
            } else {
                var29 = [1.0, 0.0, 0.0];
            }
        }
    }
    ;
    if (input[10] <= 0.5) {
        if (input[4] <= 0.45220860838890076) {
            if (input[3] <= 8.366666316986084) {
                if (input[9] <= 1.1666666865348816) {
                    var30 = [0.0, 1.0, 0.0];
                } else {
                    var30 = [1.0, 0.0, 0.0];
                }
            } else {
                var30 = [0.0, 1.0, 0.0];
            }
        } else {
            if (input[11] <= 2.5) {
                if (input[12] <= 1.5) {
                    if (input[9] <= 1.4166666865348816) {
                        if (input[0] <= 4.0) {
                            var30 = [0.0, 1.0, 0.0];
                        } else {
                            if (input[3] <= 10.541666746139526) {
                                var30 = [0.0, 0.0, 1.0];
                            } else {
                                var30 = [0.0, 1.0, 0.0];
                            }
                        }
                    } else {
                        if (input[5] <= 1.5998365879058838) {
                            var30 = [0.0, 0.0, 1.0];
                        } else {
                            if (input[9] <= 2.1666666865348816) {
                                var30 = [0.0, 0.0, 1.0];
                            } else {
                                var30 = [1.0, 0.0, 0.0];
                            }
                        }
                    }
                } else {
                    if (input[0] <= 5.5) {
                        if (input[8] <= 22.5) {
                            if (input[2] <= 6.791666746139526) {
                                var30 = [0.0, 0.0, 1.0];
                            } else {
                                var30 = [0.0, 1.0, 0.0];
                            }
                        } else {
                            var30 = [0.0, 1.0, 0.0];
                        }
                    } else {
                        if (input[5] <= 1.1200074553489685) {
                            var30 = [0.0, 1.0, 0.0];
                        } else {
                            if (input[5] <= 2.403122067451477) {
                                var30 = [0.0, 0.0, 1.0];
                            } else {
                                if (input[8] <= 5.0) {
                                    var30 = [1.0, 0.0, 0.0];
                                } else {
                                    var30 = [0.0, 0.0, 1.0];
                                }
                            }
                        }
                    }
                }
            } else {
                var30 = [1.0, 0.0, 0.0];
            }
        }
    } else {
        if (input[0] <= 1.5) {
            if (input[9] <= 3.5) {
                var30 = [0.0, 1.0, 0.0];
            } else {
                var30 = [1.0, 0.0, 0.0];
            }
        } else {
            var30 = [1.0, 0.0, 0.0];
        }
    }
    ;
    if (input[4] <= 0.3863389939069748) {
        if (input[12] <= 1.5) {
            if (input[8] <= 20.0) {
                if (input[11] <= 1.5) {
                    if (input[2] <= 4.0) {
                        if (input[2] <= 2.5) {
                            var31 = [0.0, 1.0, 0.0];
                        } else {
                            var31 = [0.25, 0.75, 0.0];
                        }
                    } else {
                        var31 = [0.0, 1.0, 0.0];
                    }
                } else {
                    if (input[2] <= 7.75) {
                        var31 = [1.0, 0.0, 0.0];
                    } else {
                        if (input[2] <= 9.5) {
                            var31 = [0.0, 1.0, 0.0];
                        } else {
                            var31 = [1.0, 0.0, 0.0];
                        }
                    }
                }
            } else {
                var31 = [0.0, 0.0, 1.0];
            }
        } else {
            var31 = [0.0, 1.0, 0.0];
        }
    } else {
        if (input[2] <= 4.722222089767456) {
            if (input[9] <= 1.100000023841858) {
                if (input[3] <= 8.416666746139526) {
                    var31 = [0.0, 0.0, 1.0];
                } else {
                    var31 = [0.0, 1.0, 0.0];
                }
            } else {
                var31 = [0.0, 0.0, 1.0];
            }
        } else {
            if (input[2] <= 6.541666746139526) {
                if (input[2] <= 5.708333253860474) {
                    if (input[8] <= 39.999998569488525) {
                        if (input[9] <= 1.6388888955116272) {
                            var31 = [0.0, 0.0, 1.0];
                        } else {
                            if (input[7] <= 31.0606050491333) {
                                if (input[9] <= 1.817460298538208) {
                                    var31 = [1.0, 0.0, 0.0];
                                } else {
                                    var31 = [0.0, 0.0, 1.0];
                                }
                            } else {
                                var31 = [1.0, 0.0, 0.0];
                            }
                        }
                    } else {
                        var31 = [1.0, 0.0, 0.0];
                    }
                } else {
                    var31 = [0.0, 0.0, 1.0];
                }
            } else {
                if (input[5] <= 1.3655142188072205) {
                    if (input[3] <= 6.410714268684387) {
                        var31 = [0.0, 0.0, 1.0];
                    } else {
                        var31 = [0.0, 1.0, 0.0];
                    }
                } else {
                    if (input[8] <= 7.142857074737549) {
                        var31 = [1.0, 0.0, 0.0];
                    } else {
                        if (input[12] <= 3.0) {
                            var31 = [1.0, 0.0, 0.0];
                        } else {
                            if (input[12] <= 4.5) {
                                var31 = [0.0, 1.0, 0.0];
                            } else {
                                var31 = [0.0, 0.0, 1.0];
                            }
                        }
                    }
                }
            }
        }
    }
    ;
    if (input[6] <= 7.499999761581421) {
        if (input[9] <= 2.5277777910232544) {
            if (input[2] <= 6.166666746139526) {
                if (input[10] <= 1.0) {
                    if (input[11] <= 2.5) {
                        if (input[1] <= 2.5) {
                            var32 = [0.0, 1.0, 0.0];
                        } else {
                            if (input[0] <= 3.5) {
                                if (input[2] <= 3.8333332538604736) {
                                    var32 = [0.0, 1.0, 0.0];
                                } else {
                                    var32 = [0.0, 0.0, 1.0];
                                }
                            } else {
                                var32 = [0.0, 0.0, 1.0];
                            }
                        }
                    } else {
                        var32 = [1.0, 0.0, 0.0];
                    }
                } else {
                    if (input[3] <= 1.8333333134651184) {
                        var32 = [0.0, 1.0, 0.0];
                    } else {
                        if (input[5] <= 0.25) {
                            var32 = [0.0, 1.0, 0.0];
                        } else {
                            var32 = [0.8, 0.2, 0.0];
                        }
                    }
                }
            } else {
                if (input[9] <= 2.25) {
                    if (input[2] <= 14.300000190734863) {
                        var32 = [0.0, 1.0, 0.0];
                    } else {
                        var32 = [1.0, 0.0, 0.0];
                    }
                } else {
                    var32 = [0.0, 0.0, 1.0];
                }
            }
        } else {
            if (input[11] <= 1.5) {
                if (input[7] <= 63.33333206176758) {
                    var32 = [0.0, 0.0, 1.0];
                } else {
                    var32 = [1.0, 0.0, 0.0];
                }
            } else {
                if (input[9] <= 4.267857074737549) {
                    var32 = [1.0, 0.0, 0.0];
                } else {
                    if (input[2] <= 16.39285707473755) {
                        var32 = [0.0, 0.0, 1.0];
                    } else {
                        var32 = [1.0, 0.0, 0.0];
                    }
                }
            }
        }
    } else {
        if (input[9] <= 1.5) {
            if (input[6] <= 18.333333015441895) {
                var32 = [1.0, 0.0, 0.0];
            } else {
                var32 = [0.0, 0.0, 1.0];
            }
        } else {
            if (input[1] <= 9.0) {
                var32 = [0.0, 0.0, 1.0];
            } else {
                var32 = [1.0, 0.0, 0.0];
            }
        }
    }
    ;
    if (input[11] <= 1.5) {
        if (input[4] <= 0.20000000298023224) {
            if (input[9] <= 3.5) {
                var33 = [0.0, 1.0, 0.0];
            } else {
                var33 = [1.0, 0.0, 0.0];
            }
        } else {
            if (input[6] <= 16.66666603088379) {
                if (input[9] <= 1.100000023841858) {
                    var33 = [0.0, 1.0, 0.0];
                } else {
                    if (input[7] <= 10.0) {
                        if (input[4] <= 0.6330126971006393) {
                            var33 = [0.0, 0.0, 1.0];
                        } else {
                            if (input[1] <= 4.5) {
                                var33 = [0.0, 1.0, 0.0];
                            } else {
                                var33 = [1.0, 0.0, 0.0];
                            }
                        }
                    } else {
                        if (input[8] <= 52.08333206176758) {
                            if (input[9] <= 1.5833333134651184) {
                                if (input[3] <= 8.041666507720947) {
                                    var33 = [0.0, 0.0, 1.0];
                                } else {
                                    var33 = [0.0, 1.0, 0.0];
                                }
                            } else {
                                var33 = [0.0, 0.0, 1.0];
                            }
                        } else {
                            var33 = [1.0, 0.0, 0.0];
                        }
                    }
                }
            } else {
                if (input[7] <= 45.0) {
                    var33 = [0.0, 0.0, 1.0];
                } else {
                    var33 = [0.0, 1.0, 0.0];
                }
            }
        }
    } else {
        if (input[9] <= 1.7333332896232605) {
            if (input[7] <= 55.0) {
                if (input[12] <= 1.5) {
                    if (input[3] <= 14.75) {
                        if (input[1] <= 3.0) {
                            if (input[2] <= 3.708333373069763) {
                                var33 = [1.0, 0.0, 0.0];
                            } else {
                                var33 = [0.0, 1.0, 0.0];
                            }
                        } else {
                            if (input[2] <= 3.614285707473755) {
                                var33 = [1.0, 0.0, 0.0];
                            } else {
                                var33 = [0.0, 0.0, 1.0];
                            }
                        }
                    } else {
                        var33 = [1.0, 0.0, 0.0];
                    }
                } else {
                    var33 = [0.0, 1.0, 0.0];
                }
            } else {
                var33 = [0.0, 0.0, 1.0];
            }
        } else {
            if (input[12] <= 4.5) {
                if (input[6] <= 7.499999761581421) {
                    var33 = [1.0, 0.0, 0.0];
                } else {
                    var33 = [0.0, 0.0, 1.0];
                }
            } else {
                var33 = [0.0, 0.0, 1.0];
            }
        }
    }
    ;
    if (input[4] <= 0.20000000298023224) {
        if (input[3] <= 4.8125) {
            if (input[10] <= 4.0) {
                if (input[10] <= 2.5) {
                    var34 = [0.0, 1.0, 0.0];
                } else {
                    var34 = [0.3333333333333333, 0.6666666666666666, 0.0];
                }
            } else {
                var34 = [0.0, 1.0, 0.0];
            }
        } else {
            if (input[8] <= 35.0) {
                if (input[10] <= 1.5) {
                    if (input[1] <= 5.5) {
                        var34 = [0.0, 1.0, 0.0];
                    } else {
                        var34 = [1.0, 0.0, 0.0];
                    }
                } else {
                    var34 = [1.0, 0.0, 0.0];
                }
            } else {
                var34 = [1.0, 0.0, 0.0];
            }
        }
    } else {
        if (input[2] <= 5.5) {
            if (input[4] <= 1.7146530747413635) {
                if (input[2] <= 3.547619104385376) {
                    if (input[5] <= 1.559189796447754) {
                        if (input[0] <= 3.5) {
                            var34 = [0.0, 1.0, 0.0];
                        } else {
                            var34 = [0.0, 0.0, 1.0];
                        }
                    } else {
                        var34 = [1.0, 0.0, 0.0];
                    }
                } else {
                    if (input[11] <= 2.5) {
                        var34 = [0.0, 0.0, 1.0];
                    } else {
                        var34 = [1.0, 0.0, 0.0];
                    }
                }
            } else {
                var34 = [0.0, 1.0, 0.0];
            }
        } else {
            if (input[3] <= 4.464285612106323) {
                var34 = [0.0, 0.0, 1.0];
            } else {
                if (input[0] <= 8.5) {
                    if (input[9] <= 1.6875) {
                        var34 = [0.0, 1.0, 0.0];
                    } else {
                        if (input[3] <= 10.886363506317139) {
                            if (input[1] <= 5.5) {
                                var34 = [0.0, 0.0, 1.0];
                            } else {
                                if (input[3] <= 9.940170764923096) {
                                    var34 = [1.0, 0.0, 0.0];
                                } else {
                                    var34 = [0.0, 0.0, 1.0];
                                }
                            }
                        } else {
                            var34 = [1.0, 0.0, 0.0];
                        }
                    }
                } else {
                    var34 = [0.0, 1.0, 0.0];
                }
            }
        }
    }
    ;
    if (input[5] <= 0.8859826326370239) {
        if (input[9] <= 2.166666626930237) {
            if (input[2] <= 4.399999976158142) {
                if (input[10] <= 1.0) {
                    if (input[3] <= 3.100000023841858) {
                        var35 = [0.0, 0.0, 1.0];
                    } else {
                        if (input[12] <= 1.5) {
                            var35 = [0.0, 0.0, 1.0];
                        } else {
                            var35 = [0.0, 1.0, 0.0];
                        }
                    }
                } else {
                    if (input[3] <= 1.75) {
                        var35 = [0.0, 1.0, 0.0];
                    } else {
                        var35 = [0.75, 0.25, 0.0];
                    }
                }
            } else {
                var35 = [0.0, 1.0, 0.0];
            }
        } else {
            if (input[4] <= 0.25) {
                var35 = [1.0, 0.0, 0.0];
            } else {
                var35 = [0.0, 0.0, 1.0];
            }
        }
    } else {
        if (input[7] <= 30.952380180358887) {
            if (input[11] <= 2.5) {
                if (input[2] <= 6.25) {
                    var35 = [0.0, 0.0, 1.0];
                } else {
                    if (input[11] <= 1.5) {
                        var35 = [1.0, 0.0, 0.0];
                    } else {
                        var35 = [0.0, 0.0, 1.0];
                    }
                }
            } else {
                if (input[5] <= 1.602495014667511) {
                    var35 = [1.0, 0.0, 0.0];
                } else {
                    if (input[8] <= 10.0) {
                        var35 = [1.0, 0.0, 0.0];
                    } else {
                        var35 = [0.0, 1.0, 0.0];
                    }
                }
            }
        } else {
            if (input[2] <= 4.833333253860474) {
                if (input[5] <= 2.2807763814926147) {
                    var35 = [0.0, 0.0, 1.0];
                } else {
                    if (input[1] <= 3.5) {
                        var35 = [0.0, 1.0, 0.0];
                    } else {
                        var35 = [0.0, 0.0, 1.0];
                    }
                }
            } else {
                if (input[10] <= 0.5) {
                    if (input[0] <= 6.5) {
                        if (input[0] <= 3.5) {
                            var35 = [0.0, 1.0, 0.0];
                        } else {
                            if (input[5] <= 2.198315143585205) {
                                var35 = [0.0, 0.0, 1.0];
                            } else {
                                var35 = [0.0, 1.0, 0.0];
                            }
                        }
                    } else {
                        var35 = [1.0, 0.0, 0.0];
                    }
                } else {
                    var35 = [1.0, 0.0, 0.0];
                }
            }
        }
    }
    ;
    if (input[9] <= 1.100000023841858) {
        if (input[2] <= 3.375) {
            if (input[3] <= 5.166666746139526) {
                if (input[5] <= 0.4857022613286972) {
                    var36 = [0.0, 1.0, 0.0];
                } else {
                    if (input[2] <= 2.5) {
                        var36 = [0.0, 1.0, 0.0];
                    } else {
                        var36 = [1.0, 0.0, 0.0];
                    }
                }
            } else {
                var36 = [0.0, 0.0, 1.0];
            }
        } else {
            var36 = [0.0, 1.0, 0.0];
        }
    } else {
        if (input[11] <= 2.5) {
            if (input[4] <= 0.3863389939069748) {
                if (input[10] <= 3.5) {
                    if (input[2] <= 10.550000190734863) {
                        var36 = [1.0, 0.0, 0.0];
                    } else {
                        var36 = [0.0, 1.0, 0.0];
                    }
                } else {
                    var36 = [0.0, 1.0, 0.0];
                }
            } else {
                if (input[9] <= 2.583333373069763) {
                    if (input[0] <= 11.0) {
                        if (input[1] <= 7.5) {
                            if (input[4] <= 1.1826265454292297) {
                                var36 = [0.0, 0.0, 1.0];
                            } else {
                                if (input[1] <= 5.0) {
                                    var36 = [0.0, 1.0, 0.0];
                                } else {
                                    var36 = [0.0, 0.0, 1.0];
                                }
                            }
                        } else {
                            var36 = [0.0, 1.0, 0.0];
                        }
                    } else {
                        if (input[6] <= 25.000000476837158) {
                            var36 = [0.0, 0.0, 1.0];
                        } else {
                            var36 = [0.0, 1.0, 0.0];
                        }
                    }
                } else {
                    if (input[4] <= 0.8726779818534851) {
                        var36 = [1.0, 0.0, 0.0];
                    } else {
                        if (input[8] <= 58.33333206176758) {
                            if (input[11] <= 1.5) {
                                var36 = [0.0, 0.0, 1.0];
                            } else {
                                if (input[5] <= 1.5247171819210052) {
                                    var36 = [0.0, 0.0, 1.0];
                                } else {
                                    var36 = [1.0, 0.0, 0.0];
                                }
                            }
                        } else {
                            var36 = [1.0, 0.0, 0.0];
                        }
                    }
                }
            }
        } else {
            var36 = [1.0, 0.0, 0.0];
        }
    }
    ;
    if (input[2] <= 6.166666746139526) {
        if (input[2] <= 2.549999952316284) {
            var37 = [0.0, 1.0, 0.0];
        } else {
            if (input[8] <= 5.0) {
                if (input[4] <= 1.0538886487483978) {
                    if (input[0] <= 2.0) {
                        var37 = [0.0, 1.0, 0.0];
                    } else {
                        if (input[4] <= 0.6449489742517471) {
                            if (input[1] <= 2.5) {
                                var37 = [1.0, 0.0, 0.0];
                            } else {
                                if (input[10] <= 0.5) {
                                    if (input[5] <= 1.095014065504074) {
                                        var37 = [0.0, 1.0, 0.0];
                                    } else {
                                        var37 = [0.0, 0.0, 1.0];
                                    }
                                } else {
                                    var37 = [1.0, 0.0, 0.0];
                                }
                            }
                        } else {
                            var37 = [1.0, 0.0, 0.0];
                        }
                    }
                } else {
                    var37 = [0.0, 0.0, 1.0];
                }
            } else {
                if (input[8] <= 58.33333206176758) {
                    if (input[1] <= 2.5) {
                        var37 = [0.0, 1.0, 0.0];
                    } else {
                        var37 = [0.0, 0.0, 1.0];
                    }
                } else {
                    var37 = [1.0, 0.0, 0.0];
                }
            }
        }
    } else {
        if (input[9] <= 1.8333333134651184) {
            if (input[7] <= 41.66666603088379) {
                var37 = [0.0, 1.0, 0.0];
            } else {
                if (input[10] <= 1.5) {
                    var37 = [0.0, 1.0, 0.0];
                } else {
                    var37 = [1.0, 0.0, 0.0];
                }
            }
        } else {
            if (input[5] <= 0.7071067839860916) {
                if (input[10] <= 8.5) {
                    var37 = [0.0, 1.0, 0.0];
                } else {
                    var37 = [1.0, 0.0, 0.0];
                }
            } else {
                var37 = [1.0, 0.0, 0.0];
            }
        }
    }
    ;
    if (input[0] <= 2.5) {
        if (input[1] <= 4.5) {
            if (input[3] <= 9.166666746139526) {
                if (input[5] <= 0.7214045226573944) {
                    var38 = [0.0, 1.0, 0.0];
                } else {
                    var38 = [1.0, 0.0, 0.0];
                }
            } else {
                var38 = [1.0, 0.0, 0.0];
            }
        } else {
            var38 = [1.0, 0.0, 0.0];
        }
    } else {
        if (input[2] <= 6.541666746139526) {
            if (input[4] <= 2.179014563560486) {
                if (input[1] <= 2.5) {
                    var38 = [0.0, 1.0, 0.0];
                } else {
                    if (input[1] <= 3.5) {
                        if (input[5] <= 2.3397369384765625) {
                            if (input[9] <= 1.100000023841858) {
                                if (input[0] <= 4.0) {
                                    var38 = [0.0, 1.0, 0.0];
                                } else {
                                    var38 = [0.0, 0.0, 1.0];
                                }
                            } else {
                                var38 = [0.0, 0.0, 1.0];
                            }
                        } else {
                            var38 = [1.0, 0.0, 0.0];
                        }
                    } else {
                        if (input[0] <= 6.5) {
                            if (input[5] <= 0.5499271005392075) {
                                if (input[1] <= 6.0) {
                                    var38 = [0.0, 1.0, 0.0];
                                } else {
                                    var38 = [0.0, 0.0, 1.0];
                                }
                            } else {
                                var38 = [0.0, 0.0, 1.0];
                            }
                        } else {
                            if (input[0] <= 9.5) {
                                var38 = [1.0, 0.0, 0.0];
                            } else {
                                var38 = [0.0, 0.0, 1.0];
                            }
                        }
                    }
                }
            } else {
                var38 = [1.0, 0.0, 0.0];
            }
        } else {
            if (input[9] <= 1.8333333134651184) {
                var38 = [0.0, 1.0, 0.0];
            } else {
                if (input[2] <= 8.642857074737549) {
                    var38 = [1.0, 0.0, 0.0];
                } else {
                    var38 = [0.0, 0.0, 1.0];
                }
            }
        }
    }
    ;
    if (input[11] <= 2.5) {
        if (input[10] <= 1.0) {
            if (input[2] <= 6.166666746139526) {
                if (input[9] <= 1.324999988079071) {
                    if (input[11] <= 1.5) {
                        if (input[8] <= 10.0) {
                            var39 = [0.0, 1.0, 0.0];
                        } else {
                            var39 = [0.0, 0.0, 1.0];
                        }
                    } else {
                        if (input[1] <= 2.5) {
                            var39 = [0.0, 1.0, 0.0];
                        } else {
                            var39 = [0.0, 0.0, 1.0];
                        }
                    }
                } else {
                    if (input[1] <= 10.0) {
                        if (input[3] <= 4.016666769981384) {
                            var39 = [0.0, 1.0, 0.0];
                        } else {
                            var39 = [0.0, 0.0, 1.0];
                        }
                    } else {
                        var39 = [1.0, 0.0, 0.0];
                    }
                }
            } else {
                if (input[7] <= 15.340909004211426) {
                    if (input[9] <= 2.1666666865348816) {
                        var39 = [0.0, 1.0, 0.0];
                    } else {
                        var39 = [1.0, 0.0, 0.0];
                    }
                } else {
                    if (input[1] <= 6.5) {
                        if (input[11] <= 1.5) {
                            if (input[9] <= 2.0) {
                                var39 = [0.0, 1.0, 0.0];
                            } else {
                                var39 = [0.0, 0.0, 1.0];
                            }
                        } else {
                            if (input[9] <= 2.100000023841858) {
                                var39 = [0.0, 1.0, 0.0];
                            } else {
                                var39 = [1.0, 0.0, 0.0];
                            }
                        }
                    } else {
                        if (input[11] <= 1.5) {
                            var39 = [0.0, 0.0, 1.0];
                        } else {
                            if (input[0] <= 7.5) {
                                var39 = [0.0, 0.0, 1.0];
                            } else {
                                var39 = [1.0, 0.0, 0.0];
                            }
                        }
                    }
                }
            }
        } else {
            if (input[0] <= 1.5) {
                if (input[2] <= 2.5) {
                    var39 = [0.0, 1.0, 0.0];
                } else {
                    if (input[3] <= 2.25) {
                        if (input[10] <= 4.0) {
                            var39 = [1.0, 0.0, 0.0];
                        } else {
                            if (input[9] <= 3.5) {
                                var39 = [0.0, 1.0, 0.0];
                            } else {
                                var39 = [1.0, 0.0, 0.0];
                            }
                        }
                    } else {
                        var39 = [0.0, 1.0, 0.0];
                    }
                }
            } else {
                var39 = [1.0, 0.0, 0.0];
            }
        }
    } else {
        var39 = [1.0, 0.0, 0.0];
    }
    ;
    if (input[11] <= 1.5) {
        if (input[3] <= 6.583333253860474) {
            if (input[8] <= 25.0) {
                if (input[3] <= 5.083333253860474) {
                    if (input[5] <= 0.4857022613286972) {
                        var40 = [0.0, 1.0, 0.0];
                    } else {
                        if (input[2] <= 2.5) {
                            var40 = [0.0, 1.0, 0.0];
                        } else {
                            if (input[0] <= 2.0) {
                                var40 = [0.3333333333333333, 0.6666666666666666, 0.0];
                            } else {
                                var40 = [0.0, 1.0, 0.0];
                            }
                        }
                    }
                } else {
                    if (input[3] <= 5.916666746139526) {
                        var40 = [0.0, 0.0, 1.0];
                    } else {
                        var40 = [0.0, 1.0, 0.0];
                    }
                }
            } else {
                if (input[8] <= 75.0) {
                    var40 = [0.0, 0.0, 1.0];
                } else {
                    var40 = [1.0, 0.0, 0.0];
                }
            }
        } else {
            if (input[2] <= 6.375) {
                if (input[5] <= 2.1924078464508057) {
                    var40 = [0.0, 0.0, 1.0];
                } else {
                    var40 = [0.0, 1.0, 0.0];
                }
            } else {
                if (input[4] <= 1.1725226938724518) {
                    var40 = [1.0, 0.0, 0.0];
                } else {
                    var40 = [0.0, 1.0, 0.0];
                }
            }
        }
    } else {
        if (input[9] <= 1.2428571581840515) {
            if (input[5] <= 1.25) {
                var40 = [1.0, 0.0, 0.0];
            } else {
                var40 = [0.0, 1.0, 0.0];
            }
        } else {
            if (input[3] <= 6.416666746139526) {
                var40 = [0.0, 0.0, 1.0];
            } else {
                if (input[9] <= 1.8660714030265808) {
                    if (input[1] <= 7.5) {
                        if (input[1] <= 5.0) {
                            if (input[8] <= 8.333333015441895) {
                                var40 = [1.0, 0.0, 0.0];
                            } else {
                                var40 = [0.0, 0.0, 1.0];
                            }
                        } else {
                            var40 = [0.0, 0.0, 1.0];
                        }
                    } else {
                        var40 = [0.0, 1.0, 0.0];
                    }
                } else {
                    if (input[7] <= 21.590909004211426) {
                        if (input[5] <= 1.7382375001907349) {
                            var40 = [1.0, 0.0, 0.0];
                        } else {
                            var40 = [0.0, 0.0, 1.0];
                        }
                    } else {
                        var40 = [1.0, 0.0, 0.0];
                    }
                }
            }
        }
    }
    ;
    if (input[1] <= 2.5) {
        if (input[2] <= 2.5) {
            var41 = [0.0, 1.0, 0.0];
        } else {
            if (input[0] <= 2.0) {
                if (input[10] <= 4.0) {
                    var41 = [0.25, 0.75, 0.0];
                } else {
                    var41 = [0.0, 1.0, 0.0];
                }
            } else {
                var41 = [0.0, 1.0, 0.0];
            }
        }
    } else {
        if (input[3] <= 3.5) {
            var41 = [0.0, 1.0, 0.0];
        } else {
            if (input[2] <= 6.541666746139526) {
                if (input[5] <= 2.2951011657714844) {
                    if (input[1] <= 10.0) {
                        if (input[4] <= 0.6352613419294357) {
                            var41 = [0.0, 0.0, 1.0];
                        } else {
                            if (input[7] <= 8.333333015441895) {
                                if (input[4] <= 0.9239060878753662) {
                                    var41 = [1.0, 0.0, 0.0];
                                } else {
                                    if (input[0] <= 4.5) {
                                        var41 = [0.0, 1.0, 0.0];
                                    } else {
                                        var41 = [0.0, 0.0, 1.0];
                                    }
                                }
                            } else {
                                if (input[1] <= 4.5) {
                                    if (input[11] <= 1.5) {
                                        var41 = [0.0, 0.0, 1.0];
                                    } else {
                                        var41 = [1.0, 0.0, 0.0];
                                    }
                                } else {
                                    var41 = [0.0, 0.0, 1.0];
                                }
                            }
                        }
                    } else {
                        var41 = [1.0, 0.0, 0.0];
                    }
                } else {
                    if (input[6] <= 29.166666984558105) {
                        if (input[2] <= 5.166666746139526) {
                            var41 = [1.0, 0.0, 0.0];
                        } else {
                            var41 = [0.0, 0.0, 1.0];
                        }
                    } else {
                        var41 = [0.0, 1.0, 0.0];
                    }
                }
            } else {
                if (input[10] <= 0.5) {
                    if (input[9] <= 1.75) {
                        var41 = [0.0, 1.0, 0.0];
                    } else {
                        if (input[2] <= 7.5) {
                            var41 = [1.0, 0.0, 0.0];
                        } else {
                            var41 = [0.0, 0.0, 1.0];
                        }
                    }
                } else {
                    var41 = [1.0, 0.0, 0.0];
                }
            }
        }
    }
    ;
    if (input[0] <= 3.5) {
        if (input[1] <= 4.5) {
            if (input[2] <= 13.0) {
                if (input[4] <= 0.2357022613286972) {
                    if (input[3] <= 6.166666746139526) {
                        if (input[1] <= 2.5) {
                            if (input[3] <= 1.5) {
                                var42 = [0.0, 1.0, 0.0];
                            } else {
                                if (input[5] <= 0.25) {
                                    var42 = [1.0, 0.0, 0.0];
                                } else {
                                    var42 = [0.5, 0.5, 0.0];
                                }
                            }
                        } else {
                            var42 = [0.0, 1.0, 0.0];
                        }
                    } else {
                        var42 = [0.0, 1.0, 0.0];
                    }
                } else {
                    if (input[9] <= 1.5) {
                        var42 = [0.0, 1.0, 0.0];
                    } else {
                        var42 = [0.0, 0.0, 1.0];
                    }
                }
            } else {
                var42 = [1.0, 0.0, 0.0];
            }
        } else {
            if (input[10] <= 5.0) {
                if (input[12] <= 1.5) {
                    var42 = [0.0, 0.0, 1.0];
                } else {
                    if (input[3] <= 3.5) {
                        var42 = [0.0, 1.0, 0.0];
                    } else {
                        var42 = [0.0, 0.0, 1.0];
                    }
                }
            } else {
                var42 = [1.0, 0.0, 0.0];
            }
        }
    } else {
        if (input[1] <= 7.0) {
            if (input[1] <= 2.5) {
                var42 = [0.0, 1.0, 0.0];
            } else {
                if (input[7] <= 22.5) {
                    if (input[0] <= 7.5) {
                        var42 = [0.0, 0.0, 1.0];
                    } else {
                        if (input[6] <= 3.3333332538604736) {
                            var42 = [1.0, 0.0, 0.0];
                        } else {
                            var42 = [0.0, 0.0, 1.0];
                        }
                    }
                } else {
                    if (input[8] <= 5.0) {
                        if (input[2] <= 7.208333253860474) {
                            if (input[7] <= 41.66666603088379) {
                                var42 = [1.0, 0.0, 0.0];
                            } else {
                                if (input[10] <= 0.5) {
                                    if (input[5] <= 3.4350723028182983) {
                                        if (input[5] <= 1.8394836783409119) {
                                            if (input[5] <= 1.2910843193531036) {
                                                var42 = [0.0, 0.0, 1.0];
                                            } else {
                                                var42 = [1.0, 0.0, 0.0];
                                            }
                                        } else {
                                            var42 = [0.0, 0.0, 1.0];
                                        }
                                    } else {
                                        var42 = [1.0, 0.0, 0.0];
                                    }
                                } else {
                                    var42 = [1.0, 0.0, 0.0];
                                }
                            }
                        } else {
                            var42 = [0.0, 1.0, 0.0];
                        }
                    } else {
                        if (input[3] <= 8.916666507720947) {
                            var42 = [0.0, 0.0, 1.0];
                        } else {
                            if (input[5] <= 2.7147403955459595) {
                                var42 = [0.0, 1.0, 0.0];
                            } else {
                                var42 = [0.0, 0.0, 1.0];
                            }
                        }
                    }
                }
            }
        } else {
            if (input[5] <= 0.7997394800186157) {
                var42 = [0.0, 1.0, 0.0];
            } else {
                if (input[4] <= 1.671759843826294) {
                    var42 = [1.0, 0.0, 0.0];
                } else {
                    if (input[6] <= 20.83333396911621) {
                        var42 = [1.0, 0.0, 0.0];
                    } else {
                        var42 = [0.0, 1.0, 0.0];
                    }
                }
            }
        }
    }
    ;
    if (input[10] <= 0.5) {
        if (input[5] <= 0.6935192346572876) {
            if (input[12] <= 1.5) {
                if (input[11] <= 1.5) {
                    var43 = [0.0, 0.0, 1.0];
                } else {
                    var43 = [1.0, 0.0, 0.0];
                }
            } else {
                var43 = [0.0, 1.0, 0.0];
            }
        } else {
            if (input[1] <= 2.5) {
                var43 = [0.0, 1.0, 0.0];
            } else {
                if (input[5] <= 2.3472421169281006) {
                    if (input[9] <= 2.520833373069763) {
                        if (input[12] <= 3.0) {
                            if (input[2] <= 6.791666746139526) {
                                if (input[2] <= 3.200000047683716) {
                                    if (input[4] <= 0.6502803713083267) {
                                        var43 = [0.0, 1.0, 0.0];
                                    } else {
                                        var43 = [0.0, 0.0, 1.0];
                                    }
                                } else {
                                    if (input[11] <= 1.5) {
                                        if (input[8] <= 10.0) {
                                            if (input[7] <= 10.0) {
                                                var43 = [0.0, 1.0, 0.0];
                                            } else {
                                                var43 = [0.0, 0.0, 1.0];
                                            }
                                        } else {
                                            var43 = [0.0, 0.0, 1.0];
                                        }
                                    } else {
                                        var43 = [0.0, 0.0, 1.0];
                                    }
                                }
                            } else {
                                var43 = [0.0, 1.0, 0.0];
                            }
                        } else {
                            var43 = [0.0, 1.0, 0.0];
                        }
                    } else {
                        if (input[2] <= 8.392857074737549) {
                            var43 = [1.0, 0.0, 0.0];
                        } else {
                            var43 = [0.0, 0.0, 1.0];
                        }
                    }
                } else {
                    if (input[2] <= 4.388888835906982) {
                        var43 = [0.0, 0.0, 1.0];
                    } else {
                        if (input[4] <= 0.6494438350200653) {
                            var43 = [0.0, 0.0, 1.0];
                        } else {
                            var43 = [1.0, 0.0, 0.0];
                        }
                    }
                }
            }
        }
    } else {
        if (input[9] <= 2.5) {
            if (input[5] <= 0.7214045226573944) {
                if (input[7] <= 58.33333206176758) {
                    var43 = [0.5, 0.5, 0.0];
                } else {
                    var43 = [0.0, 1.0, 0.0];
                }
            } else {
                var43 = [1.0, 0.0, 0.0];
            }
        } else {
            var43 = [1.0, 0.0, 0.0];
        }
    }
    ;
    if (input[4] <= 0.45220860838890076) {
        if (input[1] <= 5.5) {
            if (input[7] <= 10.0) {
                var44 = [0.0, 0.0, 1.0];
            } else {
                if (input[9] <= 2.333333373069763) {
                    if (input[5] <= 0.49494896829128265) {
                        var44 = [0.0, 1.0, 0.0];
                    } else {
                        if (input[5] <= 1.25) {
                            if (input[5] <= 0.8859826326370239) {
                                if (input[8] <= 20.0) {
                                    if (input[3] <= 1.75) {
                                        var44 = [0.0, 1.0, 0.0];
                                    } else {
                                        var44 = [0.5, 0.5, 0.0];
                                    }
                                } else {
                                    var44 = [0.0, 0.0, 1.0];
                                }
                            } else {
                                var44 = [1.0, 0.0, 0.0];
                            }
                        } else {
                            if (input[0] <= 5.5) {
                                var44 = [0.0, 1.0, 0.0];
                            } else {
                                if (input[8] <= 8.333333015441895) {
                                    var44 = [1.0, 0.0, 0.0];
                                } else {
                                    var44 = [0.0, 1.0, 0.0];
                                }
                            }
                        }
                    }
                } else {
                    var44 = [1.0, 0.0, 0.0];
                }
            }
        } else {
            var44 = [1.0, 0.0, 0.0];
        }
    } else {
        if (input[5] <= 2.3973488807678223) {
            if (input[4] <= 1.446616768836975) {
                if (input[11] <= 2.5) {
                    if (input[2] <= 15.75) {
                        if (input[4] <= 0.9082483053207397) {
                            if (input[1] <= 5.5) {
                                if (input[2] <= 2.399999976158142) {
                                    var44 = [0.0, 1.0, 0.0];
                                } else {
                                    if (input[0] <= 4.0) {
                                        if (input[1] <= 4.0) {
                                            var44 = [0.0, 1.0, 0.0];
                                        } else {
                                            var44 = [0.0, 0.0, 1.0];
                                        }
                                    } else {
                                        var44 = [0.0, 0.0, 1.0];
                                    }
                                }
                            } else {
                                var44 = [1.0, 0.0, 0.0];
                            }
                        } else {
                            if (input[3] <= 7.550000190734863) {
                                if (input[7] <= 28.571428298950195) {
                                    var44 = [0.0, 1.0, 0.0];
                                } else {
                                    var44 = [0.0, 0.0, 1.0];
                                }
                            } else {
                                var44 = [0.0, 0.0, 1.0];
                            }
                        }
                    } else {
                        var44 = [1.0, 0.0, 0.0];
                    }
                } else {
                    var44 = [1.0, 0.0, 0.0];
                }
            } else {
                if (input[3] <= 7.083333253860474) {
                    var44 = [0.0, 0.0, 1.0];
                } else {
                    if (input[4] <= 2.2254637479782104) {
                        var44 = [0.0, 1.0, 0.0];
                    } else {
                        if (input[0] <= 7.5) {
                            var44 = [0.0, 0.0, 1.0];
                        } else {
                            var44 = [1.0, 0.0, 0.0];
                        }
                    }
                }
            }
        } else {
            var44 = [1.0, 0.0, 0.0];
        }
    }
    ;
    if (input[3] <= 9.633333683013916) {
        if (input[4] <= 0.45220860838890076) {
            if (input[9] <= 3.125) {
                if (input[2] <= 4.399999976158142) {
                    if (input[2] <= 3.774999976158142) {
                        if (input[11] <= 1.5) {
                            if (input[7] <= 25.0) {
                                var45 = [0.0, 0.0, 1.0];
                            } else {
                                var45 = [0.0, 1.0, 0.0];
                            }
                        } else {
                            if (input[9] <= 1.1666666865348816) {
                                if (input[8] <= 12.5) {
                                    var45 = [1.0, 0.0, 0.0];
                                } else {
                                    var45 = [0.0, 1.0, 0.0];
                                }
                            } else {
                                var45 = [1.0, 0.0, 0.0];
                            }
                        }
                    } else {
                        var45 = [0.0, 0.0, 1.0];
                    }
                } else {
                    var45 = [0.0, 1.0, 0.0];
                }
            } else {
                var45 = [1.0, 0.0, 0.0];
            }
        } else {
            if (input[12] <= 3.0) {
                if (input[8] <= 22.5) {
                    if (input[3] <= 4.75) {
                        if (input[12] <= 1.5) {
                            if (input[9] <= 1.5) {
                                var45 = [0.0, 1.0, 0.0];
                            } else {
                                var45 = [0.0, 0.0, 1.0];
                            }
                        } else {
                            var45 = [0.0, 0.0, 1.0];
                        }
                    } else {
                        var45 = [0.0, 0.0, 1.0];
                    }
                } else {
                    if (input[0] <= 3.5) {
                        if (input[2] <= 3.0) {
                            var45 = [0.0, 1.0, 0.0];
                        } else {
                            var45 = [0.0, 0.0, 1.0];
                        }
                    } else {
                        var45 = [0.0, 1.0, 0.0];
                    }
                }
            } else {
                var45 = [1.0, 0.0, 0.0];
            }
        }
    } else {
        if (input[7] <= 21.590909004211426) {
            if (input[7] <= 15.476190090179443) {
                if (input[5] <= 4.176982641220093) {
                    if (input[7] <= 6.25) {
                        var45 = [1.0, 0.0, 0.0];
                    } else {
                        if (input[11] <= 2.5) {
                            var45 = [0.0, 1.0, 0.0];
                        } else {
                            if (input[0] <= 9.5) {
                                var45 = [1.0, 0.0, 0.0];
                            } else {
                                var45 = [0.0, 1.0, 0.0];
                            }
                        }
                    }
                } else {
                    var45 = [0.0, 0.0, 1.0];
                }
            } else {
                var45 = [0.0, 0.0, 1.0];
            }
        } else {
            if (input[8] <= 31.25) {
                if (input[9] <= 1.1428571343421936) {
                    if (input[11] <= 3.5) {
                        if (input[2] <= 11.5) {
                            var45 = [0.0, 1.0, 0.0];
                        } else {
                            var45 = [1.0, 0.0, 0.0];
                        }
                    } else {
                        var45 = [0.0, 1.0, 0.0];
                    }
                } else {
                    var45 = [1.0, 0.0, 0.0];
                }
            } else {
                var45 = [0.0, 0.0, 1.0];
            }
        }
    }
    ;
    if (input[2] <= 6.166666746139526) {
        if (input[9] <= 1.100000023841858) {
            if (input[8] <= 20.0) {
                if (input[6] <= 25.0) {
                    if (input[4] <= 0.2357022613286972) {
                        if (input[3] <= 1.5) {
                            var46 = [0.0, 1.0, 0.0];
                        } else {
                            if (input[5] <= 0.25) {
                                if (input[11] <= 1.5) {
                                    var46 = [0.0, 1.0, 0.0];
                                } else {
                                    var46 = [1.0, 0.0, 0.0];
                                }
                            } else {
                                var46 = [1.0, 0.0, 0.0];
                            }
                        }
                    } else {
                        var46 = [0.0, 1.0, 0.0];
                    }
                } else {
                    var46 = [0.0, 1.0, 0.0];
                }
            } else {
                var46 = [0.0, 0.0, 1.0];
            }
        } else {
            if (input[8] <= 6.666666507720947) {
                if (input[9] <= 1.9375) {
                    if (input[6] <= 8.333333015441895) {
                        if (input[0] <= 7.0) {
                            var46 = [0.0, 0.0, 1.0];
                        } else {
                            var46 = [1.0, 0.0, 0.0];
                        }
                    } else {
                        var46 = [1.0, 0.0, 0.0];
                    }
                } else {
                    if (input[12] <= 1.5) {
                        var46 = [0.0, 0.0, 1.0];
                    } else {
                        if (input[5] <= 1.5585190951824188) {
                            var46 = [0.0, 0.0, 1.0];
                        } else {
                            var46 = [1.0, 0.0, 0.0];
                        }
                    }
                }
            } else {
                if (input[3] <= 24.369047164916992) {
                    var46 = [0.0, 0.0, 1.0];
                } else {
                    var46 = [1.0, 0.0, 0.0];
                }
            }
        }
    } else {
        if (input[1] <= 4.5) {
            if (input[5] <= 0.8859826326370239) {
                var46 = [0.0, 1.0, 0.0];
            } else {
                if (input[10] <= 1.0) {
                    var46 = [0.0, 1.0, 0.0];
                } else {
                    var46 = [1.0, 0.0, 0.0];
                }
            }
        } else {
            if (input[9] <= 1.5) {
                var46 = [0.0, 1.0, 0.0];
            } else {
                var46 = [1.0, 0.0, 0.0];
            }
        }
    }
    ;
    if (input[3] <= 10.545454502105713) {
        if (input[11] <= 2.5) {
            if (input[2] <= 6.166666746139526) {
                if (input[4] <= 0.20000000298023224) {
                    if (input[8] <= 20.0) {
                        if (input[3] <= 2.5) {
                            if (input[3] <= 1.8333333134651184) {
                                var47 = [0.0, 1.0, 0.0];
                            } else {
                                var47 = [0.5, 0.5, 0.0];
                            }
                        } else {
                            var47 = [0.0, 1.0, 0.0];
                        }
                    } else {
                        var47 = [0.0, 0.0, 1.0];
                    }
                } else {
                    if (input[2] <= 3.4142857789993286) {
                        var47 = [0.0, 0.0, 1.0];
                    } else {
                        if (input[8] <= 58.33333206176758) {
                            if (input[2] <= 3.547619104385376) {
                                var47 = [1.0, 0.0, 0.0];
                            } else {
                                var47 = [0.0, 0.0, 1.0];
                            }
                        } else {
                            var47 = [1.0, 0.0, 0.0];
                        }
                    }
                }
            } else {
                if (input[7] <= 9.090909004211426) {
                    var47 = [0.0, 1.0, 0.0];
                } else {
                    if (input[1] <= 4.5) {
                        if (input[8] <= 25.0) {
                            var47 = [0.0, 1.0, 0.0];
                        } else {
                            var47 = [1.0, 0.0, 0.0];
                        }
                    } else {
                        if (input[9] <= 1.9166666269302368) {
                            var47 = [0.0, 1.0, 0.0];
                        } else {
                            if (input[5] <= 0.3863389939069748) {
                                var47 = [1.0, 0.0, 0.0];
                            } else {
                                var47 = [0.0, 0.0, 1.0];
                            }
                        }
                    }
                }
            }
        } else {
            var47 = [1.0, 0.0, 0.0];
        }
    } else {
        if (input[7] <= 20.09803867340088) {
            if (input[9] <= 1.4785714149475098) {
                var47 = [0.0, 1.0, 0.0];
            } else {
                if (input[7] <= 8.333333015441895) {
                    var47 = [1.0, 0.0, 0.0];
                } else {
                    var47 = [0.0, 0.0, 1.0];
                }
            }
        } else {
            if (input[3] <= 22.89215660095215) {
                if (input[5] <= 2.857627511024475) {
                    var47 = [1.0, 0.0, 0.0];
                } else {
                    if (input[9] <= 1.800000011920929) {
                        var47 = [0.0, 0.0, 1.0];
                    } else {
                        var47 = [1.0, 0.0, 0.0];
                    }
                }
            } else {
                var47 = [0.0, 1.0, 0.0];
            }
        }
    }
    ;
    if (input[9] <= 1.2678571343421936) {
        if (input[7] <= 10.0) {
            if (input[8] <= 10.0) {
                if (input[1] <= 2.5) {
                    var48 = [1.0, 0.0, 0.0];
                } else {
                    var48 = [0.0, 1.0, 0.0];
                }
            } else {
                var48 = [0.0, 0.0, 1.0];
            }
        } else {
            if (input[11] <= 1.5) {
                if (input[10] <= 2.5) {
                    var48 = [0.0, 1.0, 0.0];
                } else {
                    if (input[3] <= 2.25) {
                        var48 = [0.5, 0.5, 0.0];
                    } else {
                        var48 = [0.0, 1.0, 0.0];
                    }
                }
            } else {
                if (input[8] <= 5.55555534362793) {
                    if (input[12] <= 1.5) {
                        if (input[10] <= 1.5) {
                            var48 = [0.0, 0.0, 1.0];
                        } else {
                            var48 = [1.0, 0.0, 0.0];
                        }
                    } else {
                        var48 = [0.0, 1.0, 0.0];
                    }
                } else {
                    var48 = [0.0, 1.0, 0.0];
                }
            }
        }
    } else {
        if (input[11] <= 2.5) {
            if (input[5] <= 2.3861664533615112) {
                if (input[1] <= 3.5) {
                    if (input[11] <= 1.5) {
                        var48 = [0.0, 1.0, 0.0];
                    } else {
                        var48 = [1.0, 0.0, 0.0];
                    }
                } else {
                    if (input[9] <= 4.642857074737549) {
                        if (input[4] <= 2.4203792810440063) {
                            if (input[7] <= 14.583333015441895) {
                                if (input[7] <= 6.25) {
                                    var48 = [1.0, 0.0, 0.0];
                                } else {
                                    var48 = [0.0, 1.0, 0.0];
                                }
                            } else {
                                if (input[2] <= 9.392857074737549) {
                                    if (input[3] <= 9.375) {
                                        var48 = [0.0, 0.0, 1.0];
                                    } else {
                                        if (input[4] <= 1.0538886487483978) {
                                            var48 = [1.0, 0.0, 0.0];
                                        } else {
                                            var48 = [0.0, 0.0, 1.0];
                                        }
                                    }
                                } else {
                                    var48 = [0.0, 1.0, 0.0];
                                }
                            }
                        } else {
                            var48 = [1.0, 0.0, 0.0];
                        }
                    } else {
                        var48 = [1.0, 0.0, 0.0];
                    }
                }
            } else {
                var48 = [1.0, 0.0, 0.0];
            }
        } else {
            var48 = [1.0, 0.0, 0.0];
        }
    }
    ;
    if (input[5] <= 0.6935192346572876) {
        if (input[12] <= 3.0) {
            if (input[11] <= 2.5) {
                if (input[9] <= 3.5) {
                    var49 = [0.0, 1.0, 0.0];
                } else {
                    var49 = [0.0, 0.0, 1.0];
                }
            } else {
                var49 = [1.0, 0.0, 0.0];
            }
        } else {
            var49 = [1.0, 0.0, 0.0];
        }
    } else {
        if (input[8] <= 45.0) {
            if (input[2] <= 6.604166746139526) {
                if (input[2] <= 2.583333373069763) {
                    var49 = [0.0, 1.0, 0.0];
                } else {
                    if (input[11] <= 3.0) {
                        if (input[6] <= 15.476190090179443) {
                            if (input[2] <= 3.774999976158142) {
                                if (input[8] <= 22.5) {
                                    var49 = [0.0, 0.0, 1.0];
                                } else {
                                    var49 = [0.0, 1.0, 0.0];
                                }
                            } else {
                                var49 = [0.0, 0.0, 1.0];
                            }
                        } else {
                            if (input[5] <= 2.117890954017639) {
                                var49 = [0.0, 0.0, 1.0];
                            } else {
                                var49 = [1.0, 0.0, 0.0];
                            }
                        }
                    } else {
                        var49 = [1.0, 0.0, 0.0];
                    }
                }
            } else {
                if (input[12] <= 1.5) {
                    var49 = [1.0, 0.0, 0.0];
                } else {
                    if (input[1] <= 9.0) {
                        var49 = [0.0, 1.0, 0.0];
                    } else {
                        if (input[9] <= 3.642857074737549) {
                            var49 = [1.0, 0.0, 0.0];
                        } else {
                            var49 = [0.0, 0.0, 1.0];
                        }
                    }
                }
            }
        } else {
            var49 = [1.0, 0.0, 0.0];
        }
    }
    ;
    if (input[9] <= 2.520833373069763) {
        if (input[0] <= 2.5) {
            if (input[7] <= 58.33333206176758) {
                if (input[8] <= 25.0) {
                    if (input[7] <= 41.66666603088379) {
                        var50 = [0.0, 1.0, 0.0];
                    } else {
                        if (input[11] <= 1.5) {
                            if (input[10] <= 4.0) {
                                if (input[3] <= 1.75) {
                                    var50 = [0.0, 1.0, 0.0];
                                } else {
                                    var50 = [0.75, 0.25, 0.0];
                                }
                            } else {
                                var50 = [0.0, 1.0, 0.0];
                            }
                        } else {
                            var50 = [1.0, 0.0, 0.0];
                        }
                    }
                } else {
                    var50 = [1.0, 0.0, 0.0];
                }
            } else {
                var50 = [0.0, 1.0, 0.0];
            }
        } else {
            if (input[9] <= 1.3666666746139526) {
                if (input[12] <= 1.5) {
                    if (input[8] <= 10.0) {
                        if (input[3] <= 6.916666746139526) {
                            var50 = [0.0, 1.0, 0.0];
                        } else {
                            var50 = [0.0, 0.0, 1.0];
                        }
                    } else {
                        var50 = [0.0, 0.0, 1.0];
                    }
                } else {
                    var50 = [0.0, 1.0, 0.0];
                }
            } else {
                if (input[11] <= 2.5) {
                    if (input[5] <= 0.7254734337329865) {
                        if (input[4] <= 0.643950566649437) {
                            var50 = [0.0, 0.0, 1.0];
                        } else {
                            if (input[5] <= 0.37496355175971985) {
                                var50 = [0.0, 0.0, 1.0];
                            } else {
                                var50 = [0.0, 1.0, 0.0];
                            }
                        }
                    } else {
                        if (input[2] <= 6.375) {
                            var50 = [0.0, 0.0, 1.0];
                        } else {
                            var50 = [1.0, 0.0, 0.0];
                        }
                    }
                } else {
                    var50 = [1.0, 0.0, 0.0];
                }
            }
        }
    } else {
        if (input[0] <= 4.5) {
            if (input[2] <= 8.75) {
                var50 = [0.0, 0.0, 1.0];
            } else {
                var50 = [1.0, 0.0, 0.0];
            }
        } else {
            var50 = [1.0, 0.0, 0.0];
        }
    }
    ;
    if (input[8] <= 58.33333206176758) {
        if (input[2] <= 8.027777671813965) {
            if (input[9] <= 1.3666666746139526) {
                if (input[5] <= 0.2357022613286972) {
                    var51 = [1.0, 0.0, 0.0];
                } else {
                    if (input[5] <= 1.5696797966957092) {
                        if (input[10] <= 2.5) {
                            if (input[0] <= 4.5) {
                                var51 = [0.0, 1.0, 0.0];
                            } else {
                                var51 = [0.0, 0.0, 1.0];
                            }
                        } else {
                            var51 = [0.6, 0.4, 0.0];
                        }
                    } else {
                        if (input[2] <= 2.583333373069763) {
                            var51 = [0.0, 1.0, 0.0];
                        } else {
                            if (input[9] <= 1.2428571581840515) {
                                var51 = [0.0, 0.0, 1.0];
                            } else {
                                var51 = [1.0, 0.0, 0.0];
                            }
                        }
                    }
                }
            } else {
                if (input[3] <= 10.480519771575928) {
                    if (input[9] <= 5.200000047683716) {
                        if (input[0] <= 1.5) {
                            var51 = [0.0, 1.0, 0.0];
                        } else {
                            if (input[1] <= 3.5) {
                                if (input[9] <= 1.8333333134651184) {
                                    var51 = [0.0, 0.0, 1.0];
                                } else {
                                    var51 = [1.0, 0.0, 0.0];
                                }
                            } else {
                                var51 = [0.0, 0.0, 1.0];
                            }
                        }
                    } else {
                        var51 = [1.0, 0.0, 0.0];
                    }
                } else {
                    if (input[9] <= 1.6888889074325562) {
                        var51 = [0.0, 0.0, 1.0];
                    } else {
                        if (input[12] <= 1.5) {
                            if (input[3] <= 15.666666984558105) {
                                if (input[9] <= 1.817460298538208) {
                                    var51 = [1.0, 0.0, 0.0];
                                } else {
                                    if (input[0] <= 7.5) {
                                        var51 = [0.0, 0.0, 1.0];
                                    } else {
                                        var51 = [1.0, 0.0, 0.0];
                                    }
                                }
                            } else {
                                var51 = [0.0, 0.0, 1.0];
                            }
                        } else {
                            var51 = [1.0, 0.0, 0.0];
                        }
                    }
                }
            }
        } else {
            var51 = [0.0, 1.0, 0.0];
        }
    } else {
        var51 = [1.0, 0.0, 0.0];
    }
    ;
    if (input[0] <= 1.5) {
        if (input[9] <= 1.5) {
            if (input[2] <= 2.5) {
                var52 = [0.0, 1.0, 0.0];
            } else {
                if (input[3] <= 2.25) {
                    var52 = [1.0, 0.0, 0.0];
                } else {
                    var52 = [0.0, 1.0, 0.0];
                }
            }
        } else {
            var52 = [0.0, 1.0, 0.0];
        }
    } else {
        if (input[9] <= 1.4166666865348816) {
            if (input[5] <= 0.2357022613286972) {
                var52 = [1.0, 0.0, 0.0];
            } else {
                if (input[5] <= 2.562334656715393) {
                    if (input[10] <= 1.5) {
                        if (input[4] <= 1.1572032570838928) {
                            if (input[1] <= 3.5) {
                                if (input[5] <= 1.2214045226573944) {
                                    if (input[3] <= 6.666666746139526) {
                                        var52 = [0.0, 1.0, 0.0];
                                    } else {
                                        var52 = [0.0, 0.0, 1.0];
                                    }
                                } else {
                                    var52 = [0.0, 1.0, 0.0];
                                }
                            } else {
                                var52 = [0.0, 0.0, 1.0];
                            }
                        } else {
                            var52 = [0.0, 1.0, 0.0];
                        }
                    } else {
                        var52 = [1.0, 0.0, 0.0];
                    }
                } else {
                    if (input[9] <= 1.2666667103767395) {
                        if (input[1] <= 6.5) {
                            var52 = [0.0, 0.0, 1.0];
                        } else {
                            var52 = [0.0, 1.0, 0.0];
                        }
                    } else {
                        var52 = [1.0, 0.0, 0.0];
                    }
                }
            }
        } else {
            if (input[12] <= 1.5) {
                if (input[5] <= 2.3302865028381348) {
                    if (input[1] <= 7.5) {
                        if (input[10] <= 1.0) {
                            if (input[5] <= 1.3566257953643799) {
                                if (input[0] <= 5.5) {
                                    if (input[8] <= 58.33333206176758) {
                                        var52 = [0.0, 0.0, 1.0];
                                    } else {
                                        var52 = [1.0, 0.0, 0.0];
                                    }
                                } else {
                                    var52 = [1.0, 0.0, 0.0];
                                }
                            } else {
                                var52 = [0.0, 0.0, 1.0];
                            }
                        } else {
                            var52 = [1.0, 0.0, 0.0];
                        }
                    } else {
                        var52 = [1.0, 0.0, 0.0];
                    }
                } else {
                    var52 = [1.0, 0.0, 0.0];
                }
            } else {
                if (input[7] <= 74.61538314819336) {
                    if (input[2] <= 4.555555582046509) {
                        var52 = [0.0, 0.0, 1.0];
                    } else {
                        if (input[11] <= 1.5) {
                            if (input[9] <= 2.25) {
                                var52 = [1.0, 0.0, 0.0];
                            } else {
                                var52 = [0.0, 0.0, 1.0];
                            }
                        } else {
                            var52 = [1.0, 0.0, 0.0];
                        }
                    }
                } else {
                    var52 = [0.0, 1.0, 0.0];
                }
            }
        }
    }
    ;
    if (input[9] <= 1.2678571343421936) {
        if (input[7] <= 7.142857074737549) {
            if (input[0] <= 3.5) {
                var53 = [0.0, 1.0, 0.0];
            } else {
                var53 = [0.0, 0.0, 1.0];
            }
        } else {
            if (input[0] <= 4.5) {
                if (input[0] <= 3.0) {
                    if (input[11] <= 1.5) {
                        if (input[5] <= 0.4857022613286972) {
                            var53 = [0.0, 1.0, 0.0];
                        } else {
                            var53 = [0.3333333333333333, 0.6666666666666666, 0.0];
                        }
                    } else {
                        var53 = [1.0, 0.0, 0.0];
                    }
                } else {
                    var53 = [0.0, 1.0, 0.0];
                }
            } else {
                if (input[11] <= 2.5) {
                    var53 = [0.0, 0.0, 1.0];
                } else {
                    var53 = [0.0, 1.0, 0.0];
                }
            }
        }
    } else {
        if (input[0] <= 7.5) {
            if (input[2] <= 9.392857074737549) {
                if (input[3] <= 11.041666507720947) {
                    if (input[7] <= 63.33333206176758) {
                        if (input[4] <= 0.42204125225543976) {
                            var53 = [1.0, 0.0, 0.0];
                        } else {
                            if (input[2] <= 3.547619104385376) {
                                if (input[3] <= 8.5) {
                                    var53 = [0.0, 0.0, 1.0];
                                } else {
                                    var53 = [1.0, 0.0, 0.0];
                                }
                            } else {
                                if (input[1] <= 4.5) {
                                    if (input[11] <= 1.5) {
                                        var53 = [0.0, 1.0, 0.0];
                                    } else {
                                        var53 = [0.0, 0.0, 1.0];
                                    }
                                } else {
                                    if (input[7] <= 14.583333015441895) {
                                        if (input[5] <= 1.422236680984497) {
                                            var53 = [0.0, 1.0, 0.0];
                                        } else {
                                            var53 = [0.0, 0.0, 1.0];
                                        }
                                    } else {
                                        if (input[8] <= 58.33333206176758) {
                                            var53 = [0.0, 0.0, 1.0];
                                        } else {
                                            var53 = [1.0, 0.0, 0.0];
                                        }
                                    }
                                }
                            }
                        }
                    } else {
                        var53 = [0.0, 1.0, 0.0];
                    }
                } else {
                    var53 = [1.0, 0.0, 0.0];
                }
            } else {
                if (input[2] <= 17.25) {
                    var53 = [0.0, 1.0, 0.0];
                } else {
                    var53 = [1.0, 0.0, 0.0];
                }
            }
        } else {
            if (input[5] <= 3.2436320781707764) {
                if (input[4] <= 1.33071631193161) {
                    if (input[7] <= 15.476190090179443) {
                        var53 = [1.0, 0.0, 0.0];
                    } else {
                        var53 = [0.0, 0.0, 1.0];
                    }
                } else {
                    var53 = [1.0, 0.0, 0.0];
                }
            } else {
                var53 = [1.0, 0.0, 0.0];
            }
        }
    }
    ;
    if (input[11] <= 1.5) {
        if (input[0] <= 1.5) {
            var54 = [0.0, 1.0, 0.0];
        } else {
            if (input[8] <= 58.33333206176758) {
                if (input[5] <= 2.1924078464508057) {
                    if (input[9] <= 1.4166666865348816) {
                        if (input[8] <= 10.0) {
                            var54 = [0.0, 1.0, 0.0];
                        } else {
                            var54 = [0.0, 0.0, 1.0];
                        }
                    } else {
                        if (input[2] <= 8.75) {
                            var54 = [0.0, 0.0, 1.0];
                        } else {
                            var54 = [0.0, 1.0, 0.0];
                        }
                    }
                } else {
                    if (input[0] <= 10.0) {
                        var54 = [1.0, 0.0, 0.0];
                    } else {
                        var54 = [0.0, 1.0, 0.0];
                    }
                }
            } else {
                var54 = [1.0, 0.0, 0.0];
            }
        }
    } else {
        if (input[0] <= 4.5) {
            if (input[4] <= 0.21650634706020355) {
                var54 = [1.0, 0.0, 0.0];
            } else {
                if (input[0] <= 3.0) {
                    var54 = [1.0, 0.0, 0.0];
                } else {
                    var54 = [0.0, 1.0, 0.0];
                }
            }
        } else {
            if (input[11] <= 2.5) {
                if (input[2] <= 11.442857265472412) {
                    if (input[8] <= 19.64285707473755) {
                        if (input[2] <= 3.714285731315613) {
                            if (input[9] <= 1.1428571343421936) {
                                var54 = [0.0, 0.0, 1.0];
                            } else {
                                var54 = [1.0, 0.0, 0.0];
                            }
                        } else {
                            if (input[5] <= 2.4438955783843994) {
                                var54 = [0.0, 0.0, 1.0];
                            } else {
                                if (input[2] <= 6.111111164093018) {
                                    var54 = [0.0, 0.0, 1.0];
                                } else {
                                    var54 = [1.0, 0.0, 0.0];
                                }
                            }
                        }
                    } else {
                        var54 = [1.0, 0.0, 0.0];
                    }
                } else {
                    var54 = [0.0, 1.0, 0.0];
                }
            } else {
                if (input[9] <= 1.4388889074325562) {
                    var54 = [0.0, 1.0, 0.0];
                } else {
                    var54 = [1.0, 0.0, 0.0];
                }
            }
        }
    }
    ;
    if (input[1] <= 4.5) {
        if (input[4] <= 0.18633899092674255) {
            if (input[9] <= 2.333333373069763) {
                if (input[2] <= 14.300000190734863) {
                    if (input[1] <= 3.5) {
                        if (input[5] <= 0.7214045226573944) {
                            var55 = [0.0, 1.0, 0.0];
                        } else {
                            if (input[0] <= 2.5) {
                                var55 = [1.0, 0.0, 0.0];
                            } else {
                                var55 = [0.0, 1.0, 0.0];
                            }
                        }
                    } else {
                        var55 = [0.0, 0.0, 1.0];
                    }
                } else {
                    var55 = [1.0, 0.0, 0.0];
                }
            } else {
                var55 = [1.0, 0.0, 0.0];
            }
        } else {
            if (input[3] <= 7.833333253860474) {
                if (input[0] <= 4.0) {
                    if (input[9] <= 1.5) {
                        var55 = [0.0, 1.0, 0.0];
                    } else {
                        var55 = [0.0, 0.0, 1.0];
                    }
                } else {
                    var55 = [0.0, 0.0, 1.0];
                }
            } else {
                if (input[2] <= 6.625) {
                    var55 = [1.0, 0.0, 0.0];
                } else {
                    var55 = [0.0, 1.0, 0.0];
                }
            }
        }
    } else {
        if (input[4] <= 2.4203792810440063) {
            if (input[9] <= 1.1500000357627869) {
                var55 = [0.0, 1.0, 0.0];
            } else {
                if (input[11] <= 2.5) {
                    if (input[7] <= 70.0) {
                        if (input[8] <= 75.0) {
                            if (input[2] <= 3.25) {
                                var55 = [0.0, 1.0, 0.0];
                            } else {
                                if (input[4] <= 0.8726779818534851) {
                                    if (input[8] <= 5.0) {
                                        var55 = [1.0, 0.0, 0.0];
                                    } else {
                                        var55 = [0.0, 0.0, 1.0];
                                    }
                                } else {
                                    if (input[8] <= 7.142857074737549) {
                                        if (input[5] <= 2.4269399642944336) {
                                            var55 = [0.0, 0.0, 1.0];
                                        } else {
                                            var55 = [1.0, 0.0, 0.0];
                                        }
                                    } else {
                                        var55 = [0.0, 0.0, 1.0];
                                    }
                                }
                            }
                        } else {
                            var55 = [1.0, 0.0, 0.0];
                        }
                    } else {
                        if (input[8] <= 16.66666603088379) {
                            var55 = [0.0, 0.0, 1.0];
                        } else {
                            var55 = [0.0, 1.0, 0.0];
                        }
                    }
                } else {
                    var55 = [1.0, 0.0, 0.0];
                }
            }
        } else {
            var55 = [1.0, 0.0, 0.0];
        }
    }
    ;
    if (input[4] <= 0.20000000298023224) {
        if (input[9] <= 2.333333373069763) {
            if (input[1] <= 3.5) {
                if (input[0] <= 4.0) {
                    if (input[5] <= 0.7214045226573944) {
                        if (input[10] <= 4.0) {
                            if (input[6] <= 25.0) {
                                if (input[10] <= 1.0) {
                                    var56 = [1.0, 0.0, 0.0];
                                } else {
                                    if (input[10] <= 2.5) {
                                        var56 = [0.0, 1.0, 0.0];
                                    } else {
                                        var56 = [0.5, 0.5, 0.0];
                                    }
                                }
                            } else {
                                var56 = [0.0, 1.0, 0.0];
                            }
                        } else {
                            var56 = [0.0, 1.0, 0.0];
                        }
                    } else {
                        var56 = [1.0, 0.0, 0.0];
                    }
                } else {
                    var56 = [0.0, 1.0, 0.0];
                }
            } else {
                var56 = [0.0, 0.0, 1.0];
            }
        } else {
            var56 = [1.0, 0.0, 0.0];
        }
    } else {
        if (input[4] <= 2.6552042961120605) {
            if (input[9] <= 4.642857074737549) {
                if (input[11] <= 2.5) {
                    if (input[0] <= 4.5) {
                        if (input[7] <= 26.785714149475098) {
                            var56 = [0.0, 1.0, 0.0];
                        } else {
                            if (input[12] <= 1.5) {
                                var56 = [0.0, 0.0, 1.0];
                            } else {
                                if (input[3] <= 3.814285635948181) {
                                    var56 = [0.0, 1.0, 0.0];
                                } else {
                                    var56 = [0.0, 0.0, 1.0];
                                }
                            }
                        }
                    } else {
                        if (input[5] <= 0.7711440026760101) {
                            var56 = [0.0, 1.0, 0.0];
                        } else {
                            if (input[0] <= 11.0) {
                                var56 = [0.0, 0.0, 1.0];
                            } else {
                                var56 = [0.0, 1.0, 0.0];
                            }
                        }
                    }
                } else {
                    if (input[8] <= 5.55555534362793) {
                        var56 = [1.0, 0.0, 0.0];
                    } else {
                        var56 = [0.0, 1.0, 0.0];
                    }
                }
            } else {
                var56 = [1.0, 0.0, 0.0];
            }
        } else {
            var56 = [1.0, 0.0, 0.0];
        }
    }
    ;
    if (input[0] <= 1.5) {
        var57 = [0.0, 1.0, 0.0];
    } else {
        if (input[5] <= 1.1684719324111938) {
            if (input[2] <= 10.300000190734863) {
                if (input[4] <= 0.21650634706020355) {
                    if (input[0] <= 2.5) {
                        if (input[5] <= 0.7071067839860916) {
                            var57 = [0.0, 1.0, 0.0];
                        } else {
                            var57 = [1.0, 0.0, 0.0];
                        }
                    } else {
                        var57 = [1.0, 0.0, 0.0];
                    }
                } else {
                    if (input[3] <= 7.53333306312561) {
                        if (input[8] <= 58.33333206176758) {
                            if (input[7] <= 65.0) {
                                if (input[1] <= 4.5) {
                                    var57 = [0.0, 1.0, 0.0];
                                } else {
                                    var57 = [0.0, 0.0, 1.0];
                                }
                            } else {
                                if (input[8] <= 16.66666603088379) {
                                    var57 = [0.0, 0.0, 1.0];
                                } else {
                                    var57 = [0.0, 1.0, 0.0];
                                }
                            }
                        } else {
                            var57 = [1.0, 0.0, 0.0];
                        }
                    } else {
                        var57 = [0.0, 1.0, 0.0];
                    }
                }
            } else {
                var57 = [1.0, 0.0, 0.0];
            }
        } else {
            if (input[3] <= 23.797618865966797) {
                if (input[9] <= 1.100000023841858) {
                    if (input[7] <= 58.33333206176758) {
                        var57 = [0.0, 1.0, 0.0];
                    } else {
                        var57 = [0.0, 0.0, 1.0];
                    }
                } else {
                    if (input[9] <= 1.9285714030265808) {
                        if (input[12] <= 1.5) {
                            if (input[6] <= 15.476190090179443) {
                                var57 = [0.0, 0.0, 1.0];
                            } else {
                                if (input[8] <= 8.333333015441895) {
                                    var57 = [1.0, 0.0, 0.0];
                                } else {
                                    var57 = [0.0, 0.0, 1.0];
                                }
                            }
                        } else {
                            var57 = [0.0, 0.0, 1.0];
                        }
                    } else {
                        if (input[12] <= 3.5) {
                            if (input[8] <= 34.375) {
                                if (input[5] <= 1.5277585983276367) {
                                    var57 = [0.0, 0.0, 1.0];
                                } else {
                                    if (input[2] <= 6.208333253860474) {
                                        if (input[4] <= 1.9146039485931396) {
                                            var57 = [0.0, 0.0, 1.0];
                                        } else {
                                            var57 = [1.0, 0.0, 0.0];
                                        }
                                    } else {
                                        var57 = [1.0, 0.0, 0.0];
                                    }
                                }
                            } else {
                                var57 = [0.0, 0.0, 1.0];
                            }
                        } else {
                            var57 = [0.0, 0.0, 1.0];
                        }
                    }
                }
            } else {
                var57 = [0.0, 1.0, 0.0];
            }
        }
    }
    ;
    if (input[1] <= 3.5) {
        if (input[4] <= 0.4614553153514862) {
            if (input[11] <= 1.5) {
                if (input[3] <= 2.25) {
                    if (input[5] <= 0.25) {
                        var58 = [0.0, 1.0, 0.0];
                    } else {
                        var58 = [1.0, 0.0, 0.0];
                    }
                } else {
                    var58 = [0.0, 1.0, 0.0];
                }
            } else {
                if (input[3] <= 8.916666507720947) {
                    var58 = [1.0, 0.0, 0.0];
                } else {
                    if (input[2] <= 9.527777671813965) {
                        var58 = [0.0, 1.0, 0.0];
                    } else {
                        var58 = [1.0, 0.0, 0.0];
                    }
                }
            }
        } else {
            var58 = [0.0, 0.0, 1.0];
        }
    } else {
        if (input[9] <= 1.2678571343421936) {
            if (input[6] <= 3.3333332538604736) {
                if (input[8] <= 30.0) {
                    var58 = [0.0, 1.0, 0.0];
                } else {
                    var58 = [0.0, 0.0, 1.0];
                }
            } else {
                var58 = [0.0, 0.0, 1.0];
            }
        } else {
            if (input[3] <= 5.5625) {
                if (input[0] <= 1.5) {
                    var58 = [1.0, 0.0, 0.0];
                } else {
                    if (input[5] <= 0.8213316202163696) {
                        var58 = [0.0, 0.0, 1.0];
                    } else {
                        if (input[0] <= 3.5) {
                            var58 = [1.0, 0.0, 0.0];
                        } else {
                            var58 = [0.0, 0.0, 1.0];
                        }
                    }
                }
            } else {
                if (input[11] <= 2.5) {
                    if (input[9] <= 1.3809524178504944) {
                        if (input[9] <= 1.3095238208770752) {
                            var58 = [1.0, 0.0, 0.0];
                        } else {
                            var58 = [0.0, 1.0, 0.0];
                        }
                    } else {
                        if (input[5] <= 1.0497394800186157) {
                            var58 = [0.0, 1.0, 0.0];
                        } else {
                            if (input[7] <= 8.333333015441895) {
                                var58 = [1.0, 0.0, 0.0];
                            } else {
                                if (input[4] <= 1.399632453918457) {
                                    var58 = [0.0, 0.0, 1.0];
                                } else {
                                    if (input[8] <= 7.142857074737549) {
                                        var58 = [1.0, 0.0, 0.0];
                                    } else {
                                        var58 = [0.0, 0.0, 1.0];
                                    }
                                }
                            }
                        }
                    }
                } else {
                    var58 = [1.0, 0.0, 0.0];
                }
            }
        }
    }
    ;
    if (input[4] <= 0.45220860838890076) {
        if (input[9] <= 1.100000023841858) {
            if (input[2] <= 2.75) {
                var59 = [0.0, 1.0, 0.0];
            } else {
                if (input[2] <= 3.708333373069763) {
                    var59 = [1.0, 0.0, 0.0];
                } else {
                    if (input[0] <= 2.5) {
                        if (input[3] <= 7.25) {
                            var59 = [0.0, 1.0, 0.0];
                        } else {
                            var59 = [1.0, 0.0, 0.0];
                        }
                    } else {
                        var59 = [0.0, 1.0, 0.0];
                    }
                }
            }
        } else {
            if (input[0] <= 1.5) {
                if (input[3] <= 2.2500000596046448) {
                    var59 = [1.0, 0.0, 0.0];
                } else {
                    var59 = [0.0, 1.0, 0.0];
                }
            } else {
                if (input[11] <= 1.5) {
                    var59 = [0.0, 0.0, 1.0];
                } else {
                    var59 = [1.0, 0.0, 0.0];
                }
            }
        }
    } else {
        if (input[3] <= 11.416666507720947) {
            if (input[5] <= 1.1684719324111938) {
                if (input[2] <= 16.550000190734863) {
                    if (input[3] <= 5.5) {
                        if (input[5] <= 0.8213316202163696) {
                            if (input[6] <= 16.66666603088379) {
                                var59 = [0.0, 0.0, 1.0];
                            } else {
                                if (input[3] <= 3.100000023841858) {
                                    var59 = [0.0, 0.0, 1.0];
                                } else {
                                    var59 = [0.0, 1.0, 0.0];
                                }
                            }
                        } else {
                            var59 = [1.0, 0.0, 0.0];
                        }
                    } else {
                        if (input[2] <= 4.4666666984558105) {
                            var59 = [0.0, 0.0, 1.0];
                        } else {
                            var59 = [0.0, 1.0, 0.0];
                        }
                    }
                } else {
                    var59 = [1.0, 0.0, 0.0];
                }
            } else {
                if (input[9] <= 2.0396825671195984) {
                    var59 = [0.0, 0.0, 1.0];
                } else {
                    if (input[3] <= 9.940170764923096) {
                        var59 = [1.0, 0.0, 0.0];
                    } else {
                        if (input[6] <= 11.11111068725586) {
                            var59 = [0.0, 0.0, 1.0];
                        } else {
                            var59 = [1.0, 0.0, 0.0];
                        }
                    }
                }
            }
        } else {
            if (input[3] <= 14.650000095367432) {
                var59 = [1.0, 0.0, 0.0];
            } else {
                if (input[8] <= 22.291666507720947) {
                    if (input[9] <= 1.100000023841858) {
                        var59 = [0.0, 1.0, 0.0];
                    } else {
                        var59 = [0.0, 0.0, 1.0];
                    }
                } else {
                    var59 = [1.0, 0.0, 0.0];
                }
            }
        }
    }
    ;
    if (input[3] <= 6.583333253860474) {
        if (input[2] <= 2.75) {
            var60 = [0.0, 1.0, 0.0];
        } else {
            if (input[4] <= 0.2357022613286972) {
                if (input[2] <= 4.0) {
                    var60 = [0.6, 0.4, 0.0];
                } else {
                    var60 = [0.0, 1.0, 0.0];
                }
            } else {
                if (input[7] <= 36.66666603088379) {
                    if (input[9] <= 1.9166666865348816) {
                        var60 = [0.0, 1.0, 0.0];
                    } else {
                        var60 = [0.0, 0.0, 1.0];
                    }
                } else {
                    var60 = [0.0, 0.0, 1.0];
                }
            }
        }
    } else {
        if (input[7] <= 21.764705657958984) {
            if (input[2] <= 6.25) {
                if (input[1] <= 6.5) {
                    var60 = [0.0, 0.0, 1.0];
                } else {
                    var60 = [1.0, 0.0, 0.0];
                }
            } else {
                if (input[3] <= 9.03333330154419) {
                    var60 = [0.0, 1.0, 0.0];
                } else {
                    var60 = [1.0, 0.0, 0.0];
                }
            }
        } else {
            if (input[0] <= 2.5) {
                var60 = [1.0, 0.0, 0.0];
            } else {
                if (input[2] <= 5.055555582046509) {
                    if (input[6] <= 7.142857074737549) {
                        if (input[1] <= 2.5) {
                            var60 = [0.0, 1.0, 0.0];
                        } else {
                            var60 = [0.0, 0.0, 1.0];
                        }
                    } else {
                        if (input[3] <= 11.75) {
                            if (input[9] <= 1.5) {
                                var60 = [1.0, 0.0, 0.0];
                            } else {
                                var60 = [0.0, 0.0, 1.0];
                            }
                        } else {
                            var60 = [0.0, 1.0, 0.0];
                        }
                    }
                } else {
                    if (input[1] <= 3.5) {
                        var60 = [0.0, 1.0, 0.0];
                    } else {
                        var60 = [1.0, 0.0, 0.0];
                    }
                }
            }
        }
    }
    ;
    if (input[0] <= 5.5) {
        if (input[4] <= 0.45220860838890076) {
            if (input[2] <= 2.75) {
                var61 = [0.0, 1.0, 0.0];
            } else {
                if (input[7] <= 10.0) {
                    var61 = [1.0, 0.0, 0.0];
                } else {
                    if (input[3] <= 7.03333306312561) {
                        if (input[10] <= 2.5) {
                            var61 = [1.0, 0.0, 0.0];
                        } else {
                            if (input[3] <= 2.25) {
                                if (input[7] <= 58.33333206176758) {
                                    var61 = [0.5, 0.5, 0.0];
                                } else {
                                    var61 = [1.0, 0.0, 0.0];
                                }
                            } else {
                                var61 = [0.0, 1.0, 0.0];
                            }
                        }
                    } else {
                        if (input[3] <= 9.0) {
                            if (input[2] <= 5.399999976158142) {
                                var61 = [0.0, 0.0, 1.0];
                            } else {
                                var61 = [0.0, 1.0, 0.0];
                            }
                        } else {
                            var61 = [0.0, 1.0, 0.0];
                        }
                    }
                }
            }
        } else {
            if (input[7] <= 26.785714149475098) {
                if (input[4] <= 0.7308058738708496) {
                    var61 = [0.0, 0.0, 1.0];
                } else {
                    var61 = [0.0, 1.0, 0.0];
                }
            } else {
                if (input[8] <= 58.33333206176758) {
                    if (input[2] <= 7.75) {
                        if (input[5] <= 0.4258769750595093) {
                            var61 = [0.0, 1.0, 0.0];
                        } else {
                            var61 = [0.0, 0.0, 1.0];
                        }
                    } else {
                        if (input[5] <= 1.1642439663410187) {
                            var61 = [0.0, 1.0, 0.0];
                        } else {
                            var61 = [1.0, 0.0, 0.0];
                        }
                    }
                } else {
                    var61 = [1.0, 0.0, 0.0];
                }
            }
        }
    } else {
        if (input[11] <= 2.5) {
            if (input[2] <= 3.547619104385376) {
                var61 = [1.0, 0.0, 0.0];
            } else {
                if (input[12] <= 1.5) {
                    var61 = [0.0, 0.0, 1.0];
                } else {
                    if (input[4] <= 1.3137825727462769) {
                        var61 = [0.0, 0.0, 1.0];
                    } else {
                        var61 = [1.0, 0.0, 0.0];
                    }
                }
            }
        } else {
            var61 = [1.0, 0.0, 0.0];
        }
    }
    ;
    if (input[9] <= 1.2678571343421936) {
        if (input[0] <= 12.5) {
            if (input[10] <= 2.5) {
                if (input[5] <= 0.8859826326370239) {
                    if (input[11] <= 1.5) {
                        var62 = [0.0, 1.0, 0.0];
                    } else {
                        var62 = [0.0, 0.0, 1.0];
                    }
                } else {
                    if (input[8] <= 5.55555534362793) {
                        if (input[2] <= 2.899999976158142) {
                            var62 = [0.0, 0.0, 1.0];
                        } else {
                            var62 = [0.0, 1.0, 0.0];
                        }
                    } else {
                        var62 = [0.0, 1.0, 0.0];
                    }
                }
            } else {
                if (input[2] <= 7.0) {
                    var62 = [0.0, 1.0, 0.0];
                } else {
                    var62 = [1.0, 0.0, 0.0];
                }
            }
        } else {
            var62 = [0.0, 0.0, 1.0];
        }
    } else {
        if (input[2] <= 6.166666746139526) {
            if (input[7] <= 63.33333206176758) {
                if (input[1] <= 10.0) {
                    if (input[11] <= 2.5) {
                        if (input[3] <= 4.666666746139526) {
                            var62 = [1.0, 0.0, 0.0];
                        } else {
                            if (input[9] <= 1.3095238208770752) {
                                var62 = [1.0, 0.0, 0.0];
                            } else {
                                var62 = [0.0, 0.0, 1.0];
                            }
                        }
                    } else {
                        var62 = [1.0, 0.0, 0.0];
                    }
                } else {
                    var62 = [1.0, 0.0, 0.0];
                }
            } else {
                if (input[4] <= 1.1153550744056702) {
                    var62 = [0.0, 1.0, 0.0];
                } else {
                    var62 = [0.0, 0.0, 1.0];
                }
            }
        } else {
            if (input[3] <= 11.0) {
                if (input[2] <= 7.25) {
                    var62 = [0.0, 1.0, 0.0];
                } else {
                    if (input[0] <= 6.5) {
                        if (input[2] <= 8.166666507720947) {
                            if (input[5] <= 0.6972814947366714) {
                                var62 = [0.0, 0.0, 1.0];
                            } else {
                                var62 = [1.0, 0.0, 0.0];
                            }
                        } else {
                            if (input[0] <= 2.5) {
                                var62 = [1.0, 0.0, 0.0];
                            } else {
                                var62 = [0.0, 1.0, 0.0];
                            }
                        }
                    } else {
                        var62 = [0.0, 0.0, 1.0];
                    }
                }
            } else {
                var62 = [1.0, 0.0, 0.0];
            }
        }
    }
    ;
    if (input[0] <= 1.5) {
        var63 = [0.0, 1.0, 0.0];
    } else {
        if (input[12] <= 2.5) {
            if (input[9] <= 1.100000023841858) {
                if (input[11] <= 1.5) {
                    var63 = [0.0, 1.0, 0.0];
                } else {
                    if (input[4] <= 0.21650634706020355) {
                        var63 = [1.0, 0.0, 0.0];
                    } else {
                        var63 = [0.0, 1.0, 0.0];
                    }
                }
            } else {
                if (input[9] <= 2.583333373069763) {
                    if (input[11] <= 3.0) {
                        if (input[1] <= 3.5) {
                            if (input[11] <= 1.5) {
                                var63 = [0.0, 0.0, 1.0];
                            } else {
                                var63 = [1.0, 0.0, 0.0];
                            }
                        } else {
                            if (input[7] <= 8.333333015441895) {
                                if (input[1] <= 4.5) {
                                    var63 = [0.0, 1.0, 0.0];
                                } else {
                                    if (input[8] <= 6.666666507720947) {
                                        var63 = [1.0, 0.0, 0.0];
                                    } else {
                                        var63 = [0.0, 0.0, 1.0];
                                    }
                                }
                            } else {
                                if (input[9] <= 1.3571428656578064) {
                                    var63 = [1.0, 0.0, 0.0];
                                } else {
                                    if (input[6] <= 18.253967761993408) {
                                        if (input[8] <= 19.64285707473755) {
                                            var63 = [0.0, 0.0, 1.0];
                                        } else {
                                            if (input[7] <= 36.66666603088379) {
                                                if (input[3] <= 9.722221851348877) {
                                                    var63 = [0.0, 1.0, 0.0];
                                                } else {
                                                    var63 = [0.0, 0.0, 1.0];
                                                }
                                            } else {
                                                var63 = [0.0, 0.0, 1.0];
                                            }
                                        }
                                    } else {
                                        if (input[12] <= 1.5) {
                                            var63 = [0.0, 0.0, 1.0];
                                        } else {
                                            if (input[1] <= 8.0) {
                                                var63 = [0.0, 1.0, 0.0];
                                            } else {
                                                var63 = [1.0, 0.0, 0.0];
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    } else {
                        var63 = [1.0, 0.0, 0.0];
                    }
                } else {
                    if (input[0] <= 2.5) {
                        var63 = [0.0, 0.0, 1.0];
                    } else {
                        if (input[12] <= 1.5) {
                            var63 = [1.0, 0.0, 0.0];
                        } else {
                            if (input[0] <= 4.5) {
                                var63 = [0.0, 0.0, 1.0];
                            } else {
                                if (input[3] <= 9.68461561203003) {
                                    if (input[10] <= 0.5) {
                                        var63 = [0.0, 0.0, 1.0];
                                    } else {
                                        var63 = [1.0, 0.0, 0.0];
                                    }
                                } else {
                                    var63 = [1.0, 0.0, 0.0];
                                }
                            }
                        }
                    }
                }
            }
        } else {
            var63 = [0.0, 1.0, 0.0];
        }
    }
    ;
    if (input[9] <= 1.3666666746139526) {
        if (input[5] <= 0.2357022613286972) {
            var64 = [1.0, 0.0, 0.0];
        } else {
            if (input[7] <= 58.33333206176758) {
                if (input[8] <= 12.222221851348877) {
                    if (input[2] <= 4.880952477455139) {
                        if (input[9] <= 1.1428571343421936) {
                            if (input[10] <= 1.5) {
                                var64 = [0.0, 1.0, 0.0];
                            } else {
                                var64 = [0.5, 0.5, 0.0];
                            }
                        } else {
                            var64 = [1.0, 0.0, 0.0];
                        }
                    } else {
                        if (input[3] <= 11.125) {
                            var64 = [0.0, 1.0, 0.0];
                        } else {
                            if (input[0] <= 2.5) {
                                var64 = [1.0, 0.0, 0.0];
                            } else {
                                var64 = [0.0, 1.0, 0.0];
                            }
                        }
                    }
                } else {
                    if (input[7] <= 16.66666603088379) {
                        var64 = [0.0, 0.0, 1.0];
                    } else {
                        var64 = [0.0, 1.0, 0.0];
                    }
                }
            } else {
                if (input[0] <= 3.5) {
                    var64 = [0.0, 1.0, 0.0];
                } else {
                    var64 = [0.0, 0.0, 1.0];
                }
            }
        }
    } else {
        if (input[4] <= 2.387073278427124) {
            if (input[8] <= 58.33333206176758) {
                if (input[2] <= 7.916666507720947) {
                    if (input[5] <= 2.255521297454834) {
                        if (input[4] <= 0.2357022613286972) {
                            if (input[5] <= 0.7357022613286972) {
                                var64 = [0.0, 1.0, 0.0];
                            } else {
                                var64 = [1.0, 0.0, 0.0];
                            }
                        } else {
                            if (input[3] <= 12.666666507720947) {
                                var64 = [0.0, 0.0, 1.0];
                            } else {
                                var64 = [1.0, 0.0, 0.0];
                            }
                        }
                    } else {
                        var64 = [1.0, 0.0, 0.0];
                    }
                } else {
                    var64 = [0.0, 1.0, 0.0];
                }
            } else {
                var64 = [1.0, 0.0, 0.0];
            }
        } else {
            var64 = [1.0, 0.0, 0.0];
        }
    }
    ;
    if (input[1] <= 3.5) {
        if (input[2] <= 9.527777671813965) {
            if (input[5] <= 1.095014065504074) {
                if (input[10] <= 1.0) {
                    if (input[3] <= 5.333333253860474) {
                        var65 = [0.0, 1.0, 0.0];
                    } else {
                        var65 = [1.0, 0.0, 0.0];
                    }
                } else {
                    var65 = [0.0, 1.0, 0.0];
                }
            } else {
                if (input[5] <= 1.3736095428466797) {
                    var65 = [0.0, 0.0, 1.0];
                } else {
                    var65 = [0.0, 1.0, 0.0];
                }
            }
        } else {
            var65 = [1.0, 0.0, 0.0];
        }
    } else {
        if (input[6] <= 7.499999761581421) {
            if (input[9] <= 2.4652777910232544) {
                if (input[5] <= 3.2592287063598633) {
                    if (input[2] <= 6.166666746139526) {
                        var65 = [0.0, 0.0, 1.0];
                    } else {
                        if (input[2] <= 6.555555582046509) {
                            if (input[1] <= 5.5) {
                                var65 = [0.0, 1.0, 0.0];
                            } else {
                                var65 = [0.0, 0.0, 1.0];
                            }
                        } else {
                            var65 = [0.0, 1.0, 0.0];
                        }
                    }
                } else {
                    var65 = [1.0, 0.0, 0.0];
                }
            } else {
                if (input[4] <= 1.8498365879058838) {
                    if (input[1] <= 5.5) {
                        if (input[4] <= 0.6066758036613464) {
                            var65 = [1.0, 0.0, 0.0];
                        } else {
                            var65 = [0.0, 0.0, 1.0];
                        }
                    } else {
                        var65 = [1.0, 0.0, 0.0];
                    }
                } else {
                    if (input[8] <= 19.64285707473755) {
                        var65 = [0.0, 0.0, 1.0];
                    } else {
                        var65 = [1.0, 0.0, 0.0];
                    }
                }
            }
        } else {
            if (input[4] <= 1.7146530747413635) {
                if (input[5] <= 1.506864070892334) {
                    var65 = [0.0, 0.0, 1.0];
                } else {
                    if (input[5] <= 1.850456178188324) {
                        var65 = [1.0, 0.0, 0.0];
                    } else {
                        var65 = [0.0, 0.0, 1.0];
                    }
                }
            } else {
                var65 = [0.0, 1.0, 0.0];
            }
        }
    }
    ;
    if (input[4] <= 0.45220860838890076) {
        if (input[3] <= 4.145833373069763) {
            if (input[9] <= 3.5) {
                if (input[2] <= 4.0) {
                    if (input[3] <= 1.75) {
                        var66 = [0.0, 1.0, 0.0];
                    } else {
                        var66 = [0.3333333333333333, 0.6666666666666666, 0.0];
                    }
                } else {
                    var66 = [0.0, 1.0, 0.0];
                }
            } else {
                var66 = [1.0, 0.0, 0.0];
            }
        } else {
            if (input[12] <= 1.5) {
                if (input[11] <= 1.5) {
                    var66 = [0.0, 0.0, 1.0];
                } else {
                    if (input[4] <= 0.4028453379869461) {
                        if (input[8] <= 20.0) {
                            if (input[5] <= 1.25) {
                                var66 = [1.0, 0.0, 0.0];
                            } else {
                                if (input[9] <= 1.1666666865348816) {
                                    var66 = [0.0, 1.0, 0.0];
                                } else {
                                    var66 = [1.0, 0.0, 0.0];
                                }
                            }
                        } else {
                            var66 = [0.0, 0.0, 1.0];
                        }
                    } else {
                        var66 = [0.0, 1.0, 0.0];
                    }
                }
            } else {
                var66 = [0.0, 1.0, 0.0];
            }
        }
    } else {
        if (input[9] <= 1.100000023841858) {
            if (input[0] <= 4.5) {
                var66 = [0.0, 1.0, 0.0];
            } else {
                if (input[5] <= 1.2774022817611694) {
                    var66 = [0.0, 1.0, 0.0];
                } else {
                    if (input[11] <= 2.5) {
                        var66 = [0.0, 0.0, 1.0];
                    } else {
                        var66 = [0.0, 1.0, 0.0];
                    }
                }
            }
        } else {
            if (input[3] <= 7.625) {
                if (input[9] <= 2.583333373069763) {
                    if (input[2] <= 2.299999952316284) {
                        var66 = [0.0, 1.0, 0.0];
                    } else {
                        var66 = [0.0, 0.0, 1.0];
                    }
                } else {
                    if (input[1] <= 6.5) {
                        if (input[11] <= 1.5) {
                            var66 = [1.0, 0.0, 0.0];
                        } else {
                            var66 = [0.0, 0.0, 1.0];
                        }
                    } else {
                        var66 = [0.0, 0.0, 1.0];
                    }
                }
            } else {
                if (input[7] <= 55.0) {
                    if (input[7] <= 21.590909004211426) {
                        if (input[5] <= 2.3302865028381348) {
                            if (input[4] <= 0.9962875247001648) {
                                var66 = [1.0, 0.0, 0.0];
                            } else {
                                var66 = [0.0, 0.0, 1.0];
                            }
                        } else {
                            var66 = [1.0, 0.0, 0.0];
                        }
                    } else {
                        if (input[4] <= 0.4857022613286972) {
                            var66 = [0.0, 0.0, 1.0];
                        } else {
                            if (input[2] <= 5.75) {
                                var66 = [1.0, 0.0, 0.0];
                            } else {
                                if (input[11] <= 1.5) {
                                    if (input[3] <= 9.722221851348877) {
                                        var66 = [0.0, 1.0, 0.0];
                                    } else {
                                        var66 = [0.0, 0.0, 1.0];
                                    }
                                } else {
                                    var66 = [1.0, 0.0, 0.0];
                                }
                            }
                        }
                    }
                } else {
                    var66 = [0.0, 0.0, 1.0];
                }
            }
        }
    }
    ;
    if (input[2] <= 6.166666746139526) {
        if (input[2] <= 2.549999952316284) {
            var67 = [0.0, 1.0, 0.0];
        } else {
            if (input[4] <= 0.45220860838890076) {
                if (input[9] <= 1.6666666865348816) {
                    if (input[8] <= 12.5) {
                        if (input[11] <= 1.5) {
                            if (input[2] <= 4.0) {
                                var67 = [0.6, 0.4, 0.0];
                            } else {
                                var67 = [0.0, 1.0, 0.0];
                            }
                        } else {
                            var67 = [1.0, 0.0, 0.0];
                        }
                    } else {
                        var67 = [0.0, 1.0, 0.0];
                    }
                } else {
                    var67 = [0.0, 1.0, 0.0];
                }
            } else {
                if (input[4] <= 1.5998365879058838) {
                    if (input[3] <= 11.202380657196045) {
                        if (input[4] <= 1.0425942242145538) {
                            if (input[5] <= 1.6102492213249207) {
                                var67 = [0.0, 0.0, 1.0];
                            } else {
                                var67 = [1.0, 0.0, 0.0];
                            }
                        } else {
                            var67 = [0.0, 0.0, 1.0];
                        }
                    } else {
                        if (input[11] <= 2.5) {
                            var67 = [0.0, 0.0, 1.0];
                        } else {
                            var67 = [1.0, 0.0, 0.0];
                        }
                    }
                } else {
                    var67 = [1.0, 0.0, 0.0];
                }
            }
        }
    } else {
        if (input[8] <= 22.5) {
            if (input[11] <= 1.5) {
                var67 = [0.0, 1.0, 0.0];
            } else {
                if (input[5] <= 2.873224139213562) {
                    if (input[8] <= 10.0) {
                        if (input[12] <= 1.5) {
                            var67 = [1.0, 0.0, 0.0];
                        } else {
                            if (input[10] <= 0.5) {
                                if (input[1] <= 6.0) {
                                    var67 = [0.0, 1.0, 0.0];
                                } else {
                                    var67 = [1.0, 0.0, 0.0];
                                }
                            } else {
                                var67 = [1.0, 0.0, 0.0];
                            }
                        }
                    } else {
                        var67 = [0.0, 1.0, 0.0];
                    }
                } else {
                    var67 = [0.0, 1.0, 0.0];
                }
            }
        } else {
            if (input[10] <= 5.0) {
                if (input[1] <= 10.0) {
                    var67 = [0.0, 0.0, 1.0];
                } else {
                    var67 = [1.0, 0.0, 0.0];
                }
            } else {
                var67 = [1.0, 0.0, 0.0];
            }
        }
    }
    ;
    if (input[9] <= 3.625) {
        if (input[11] <= 2.5) {
            if (input[1] <= 2.5) {
                if (input[7] <= 25.0) {
                    var68 = [1.0, 0.0, 0.0];
                } else {
                    if (input[3] <= 1.75) {
                        var68 = [0.0, 1.0, 0.0];
                    } else {
                        if (input[10] <= 1.5) {
                            var68 = [0.0, 1.0, 0.0];
                        } else {
                            if (input[10] <= 4.0) {
                                var68 = [1.0, 0.0, 0.0];
                            } else {
                                var68 = [0.0, 1.0, 0.0];
                            }
                        }
                    }
                }
            } else {
                if (input[7] <= 36.66666603088379) {
                    if (input[12] <= 1.5) {
                        if (input[3] <= 6.650000095367432) {
                            if (input[10] <= 1.0) {
                                if (input[4] <= 0.8593118041753769) {
                                    if (input[4] <= 0.2357022613286972) {
                                        var68 = [0.0, 1.0, 0.0];
                                    } else {
                                        if (input[5] <= 1.095014065504074) {
                                            var68 = [0.0, 1.0, 0.0];
                                        } else {
                                            var68 = [0.0, 0.0, 1.0];
                                        }
                                    }
                                } else {
                                    var68 = [0.0, 1.0, 0.0];
                                }
                            } else {
                                var68 = [1.0, 0.0, 0.0];
                            }
                        } else {
                            var68 = [0.0, 0.0, 1.0];
                        }
                    } else {
                        if (input[2] <= 7.0) {
                            if (input[3] <= 12.05555534362793) {
                                var68 = [0.0, 0.0, 1.0];
                            } else {
                                if (input[3] <= 18.583333015441895) {
                                    var68 = [1.0, 0.0, 0.0];
                                } else {
                                    var68 = [0.0, 0.0, 1.0];
                                }
                            }
                        } else {
                            var68 = [0.0, 1.0, 0.0];
                        }
                    }
                } else {
                    if (input[10] <= 2.5) {
                        if (input[1] <= 7.5) {
                            if (input[2] <= 2.649999976158142) {
                                if (input[8] <= 16.66666603088379) {
                                    if (input[0] <= 2.5) {
                                        var68 = [0.0, 1.0, 0.0];
                                    } else {
                                        var68 = [0.0, 0.0, 1.0];
                                    }
                                } else {
                                    var68 = [0.0, 1.0, 0.0];
                                }
                            } else {
                                var68 = [0.0, 0.0, 1.0];
                            }
                        } else {
                            var68 = [0.0, 1.0, 0.0];
                        }
                    } else {
                        var68 = [0.0, 1.0, 0.0];
                    }
                }
            }
        } else {
            if (input[3] <= 52.875) {
                var68 = [1.0, 0.0, 0.0];
            } else {
                var68 = [0.0, 1.0, 0.0];
            }
        }
    } else {
        if (input[12] <= 4.5) {
            if (input[11] <= 1.5) {
                if (input[7] <= 61.90476036071777) {
                    var68 = [0.0, 0.0, 1.0];
                } else {
                    var68 = [1.0, 0.0, 0.0];
                }
            } else {
                var68 = [1.0, 0.0, 0.0];
            }
        } else {
            var68 = [0.0, 0.0, 1.0];
        }
    }
    ;
    if (input[3] <= 11.166666507720947) {
        if (input[9] <= 1.100000023841858) {
            if (input[8] <= 32.5) {
                if (input[7] <= 58.33333206176758) {
                    var69 = [0.0, 1.0, 0.0];
                } else {
                    if (input[6] <= 25.0) {
                        var69 = [0.0, 0.0, 1.0];
                    } else {
                        var69 = [0.0, 1.0, 0.0];
                    }
                }
            } else {
                var69 = [0.0, 0.0, 1.0];
            }
        } else {
            if (input[7] <= 30.952380180358887) {
                if (input[1] <= 4.5) {
                    if (input[4] <= 0.8236095458269119) {
                        var69 = [0.0, 0.0, 1.0];
                    } else {
                        var69 = [0.0, 1.0, 0.0];
                    }
                } else {
                    if (input[9] <= 1.5535714030265808) {
                        var69 = [0.0, 1.0, 0.0];
                    } else {
                        if (input[2] <= 6.916666746139526) {
                            var69 = [0.0, 0.0, 1.0];
                        } else {
                            if (input[7] <= 9.090909004211426) {
                                var69 = [1.0, 0.0, 0.0];
                            } else {
                                var69 = [0.0, 0.0, 1.0];
                            }
                        }
                    }
                }
            } else {
                if (input[10] <= 1.0) {
                    if (input[9] <= 1.3666666746139526) {
                        var69 = [1.0, 0.0, 0.0];
                    } else {
                        if (input[1] <= 7.5) {
                            if (input[3] <= 9.166666507720947) {
                                if (input[2] <= 2.5) {
                                    if (input[12] <= 1.5) {
                                        var69 = [0.0, 0.0, 1.0];
                                    } else {
                                        var69 = [0.0, 1.0, 0.0];
                                    }
                                } else {
                                    var69 = [0.0, 0.0, 1.0];
                                }
                            } else {
                                var69 = [0.0, 1.0, 0.0];
                            }
                        } else {
                            var69 = [1.0, 0.0, 0.0];
                        }
                    }
                } else {
                    if (input[11] <= 1.5) {
                        if (input[10] <= 8.5) {
                            var69 = [0.0, 1.0, 0.0];
                        } else {
                            if (input[3] <= 2.9166666865348816) {
                                var69 = [1.0, 0.0, 0.0];
                            } else {
                                var69 = [0.0, 1.0, 0.0];
                            }
                        }
                    } else {
                        var69 = [1.0, 0.0, 0.0];
                    }
                }
            }
        }
    } else {
        if (input[0] <= 17.0) {
            if (input[3] <= 15.107142925262451) {
                var69 = [1.0, 0.0, 0.0];
            } else {
                if (input[9] <= 1.600000023841858) {
                    var69 = [0.0, 1.0, 0.0];
                } else {
                    if (input[7] <= 20.09803867340088) {
                        var69 = [0.0, 0.0, 1.0];
                    } else {
                        var69 = [1.0, 0.0, 0.0];
                    }
                }
            }
        } else {
            if (input[4] <= 1.0988911390304565) {
                var69 = [0.0, 1.0, 0.0];
            } else {
                var69 = [1.0, 0.0, 0.0];
            }
        }
    }
    ;
    if (input[9] <= 2.5277777910232544) {
        if (input[2] <= 6.041666746139526) {
            if (input[0] <= 1.5) {
                if (input[2] <= 4.0) {
                    if (input[2] <= 2.5) {
                        var70 = [0.0, 1.0, 0.0];
                    } else {
                        var70 = [1.0, 0.0, 0.0];
                    }
                } else {
                    var70 = [0.0, 1.0, 0.0];
                }
            } else {
                if (input[5] <= 2.3472421169281006) {
                    if (input[9] <= 1.3095238208770752) {
                        if (input[4] <= 0.8110994100570679) {
                            if (input[4] <= 0.48065122961997986) {
                                if (input[2] <= 3.200000047683716) {
                                    var70 = [0.0, 1.0, 0.0];
                                } else {
                                    var70 = [0.0, 0.0, 1.0];
                                }
                            } else {
                                var70 = [0.0, 0.0, 1.0];
                            }
                        } else {
                            var70 = [1.0, 0.0, 0.0];
                        }
                    } else {
                        if (input[7] <= 77.5) {
                            var70 = [0.0, 0.0, 1.0];
                        } else {
                            if (input[6] <= 49.99999809265137) {
                                var70 = [0.0, 1.0, 0.0];
                            } else {
                                var70 = [0.0, 0.0, 1.0];
                            }
                        }
                    }
                } else {
                    if (input[12] <= 1.5) {
                        var70 = [1.0, 0.0, 0.0];
                    } else {
                        var70 = [0.0, 0.0, 1.0];
                    }
                }
            }
        } else {
            if (input[9] <= 2.25) {
                if (input[3] <= 11.666666507720947) {
                    var70 = [0.0, 1.0, 0.0];
                } else {
                    if (input[4] <= 0.8164966106414795) {
                        if (input[12] <= 2.0) {
                            var70 = [1.0, 0.0, 0.0];
                        } else {
                            var70 = [0.0, 1.0, 0.0];
                        }
                    } else {
                        var70 = [0.0, 1.0, 0.0];
                    }
                }
            } else {
                var70 = [0.0, 0.0, 1.0];
            }
        }
    } else {
        if (input[10] <= 0.5) {
            if (input[5] <= 0.22587697207927704) {
                var70 = [1.0, 0.0, 0.0];
            } else {
                if (input[9] <= 2.833333373069763) {
                    var70 = [1.0, 0.0, 0.0];
                } else {
                    if (input[8] <= 19.64285707473755) {
                        var70 = [0.0, 0.0, 1.0];
                    } else {
                        if (input[2] <= 7.1875) {
                            var70 = [1.0, 0.0, 0.0];
                        } else {
                            var70 = [0.0, 0.0, 1.0];
                        }
                    }
                }
            }
        } else {
            var70 = [1.0, 0.0, 0.0];
        }
    }
    ;
    if (input[4] <= 0.45220860838890076) {
        if (input[11] <= 1.5) {
            if (input[6] <= 25.0) {
                if (input[10] <= 2.5) {
                    var71 = [0.0, 1.0, 0.0];
                } else {
                    if (input[2] <= 4.0) {
                        var71 = [0.5, 0.5, 0.0];
                    } else {
                        var71 = [0.0, 1.0, 0.0];
                    }
                }
            } else {
                var71 = [0.0, 1.0, 0.0];
            }
        } else {
            if (input[11] <= 3.0) {
                if (input[3] <= 12.75) {
                    var71 = [1.0, 0.0, 0.0];
                } else {
                    var71 = [0.0, 1.0, 0.0];
                }
            } else {
                var71 = [1.0, 0.0, 0.0];
            }
        }
    } else {
        if (input[3] <= 9.633333683013916) {
            if (input[8] <= 58.33333206176758) {
                if (input[2] <= 7.75) {
                    if (input[4] <= 1.2302853465080261) {
                        if (input[0] <= 3.5) {
                            if (input[9] <= 1.3333333134651184) {
                                var71 = [0.0, 1.0, 0.0];
                            } else {
                                var71 = [0.0, 0.0, 1.0];
                            }
                        } else {
                            var71 = [0.0, 0.0, 1.0];
                        }
                    } else {
                        if (input[1] <= 4.5) {
                            var71 = [0.0, 1.0, 0.0];
                        } else {
                            var71 = [0.0, 0.0, 1.0];
                        }
                    }
                } else {
                    if (input[11] <= 2.0) {
                        var71 = [0.0, 1.0, 0.0];
                    } else {
                        var71 = [1.0, 0.0, 0.0];
                    }
                }
            } else {
                var71 = [1.0, 0.0, 0.0];
            }
        } else {
            if (input[3] <= 9.940170764923096) {
                var71 = [1.0, 0.0, 0.0];
            } else {
                if (input[2] <= 8.142857074737549) {
                    if (input[1] <= 5.5) {
                        var71 = [1.0, 0.0, 0.0];
                    } else {
                        if (input[4] <= 1.361760437488556) {
                            if (input[7] <= 24.999999046325684) {
                                var71 = [0.0, 0.0, 1.0];
                            } else {
                                if (input[11] <= 1.5) {
                                    var71 = [0.0, 0.0, 1.0];
                                } else {
                                    var71 = [1.0, 0.0, 0.0];
                                }
                            }
                        } else {
                            if (input[11] <= 1.5) {
                                var71 = [0.0, 1.0, 0.0];
                            } else {
                                var71 = [1.0, 0.0, 0.0];
                            }
                        }
                    }
                } else {
                    if (input[9] <= 2.692857086658478) {
                        var71 = [0.0, 1.0, 0.0];
                    } else {
                        var71 = [0.0, 0.0, 1.0];
                    }
                }
            }
        }
    }
    ;
    if (input[0] <= 1.5) {
        if (input[2] <= 8.5) {
            if (input[2] <= 2.5) {
                var72 = [0.0, 1.0, 0.0];
            } else {
                if (input[2] <= 4.0) {
                    var72 = [0.4, 0.6, 0.0];
                } else {
                    var72 = [0.0, 1.0, 0.0];
                }
            }
        } else {
            var72 = [1.0, 0.0, 0.0];
        }
    } else {
        if (input[2] <= 2.549999952316284) {
            if (input[6] <= 63.33333206176758) {
                var72 = [0.0, 1.0, 0.0];
            } else {
                var72 = [0.0, 0.0, 1.0];
            }
        } else {
            if (input[11] <= 1.5) {
                if (input[9] <= 1.100000023841858) {
                    var72 = [0.0, 1.0, 0.0];
                } else {
                    if (input[4] <= 1.5998365879058838) {
                        var72 = [0.0, 0.0, 1.0];
                    } else {
                        if (input[2] <= 6.0) {
                            var72 = [1.0, 0.0, 0.0];
                        } else {
                            var72 = [0.0, 0.0, 1.0];
                        }
                    }
                }
            } else {
                if (input[4] <= 2.4203792810440063) {
                    if (input[4] <= 0.45220860838890076) {
                        if (input[4] <= 0.4028453379869461) {
                            if (input[5] <= 5.812334656715393) {
                                if (input[7] <= 29.16666603088379) {
                                    if (input[8] <= 20.0) {
                                        var72 = [1.0, 0.0, 0.0];
                                    } else {
                                        var72 = [0.0, 0.0, 1.0];
                                    }
                                } else {
                                    var72 = [1.0, 0.0, 0.0];
                                }
                            } else {
                                var72 = [0.0, 1.0, 0.0];
                            }
                        } else {
                            var72 = [0.0, 1.0, 0.0];
                        }
                    } else {
                        if (input[2] <= 5.375) {
                            if (input[5] <= 3.943899154663086) {
                                var72 = [0.0, 0.0, 1.0];
                            } else {
                                var72 = [1.0, 0.0, 0.0];
                            }
                        } else {
                            if (input[0] <= 6.5) {
                                if (input[9] <= 2.1666666865348816) {
                                    var72 = [0.0, 1.0, 0.0];
                                } else {
                                    var72 = [1.0, 0.0, 0.0];
                                }
                            } else {
                                if (input[5] <= 2.3857325315475464) {
                                    var72 = [0.0, 0.0, 1.0];
                                } else {
                                    if (input[9] <= 1.5) {
                                        var72 = [0.0, 1.0, 0.0];
                                    } else {
                                        var72 = [1.0, 0.0, 0.0];
                                    }
                                }
                            }
                        }
                    }
                } else {
                    var72 = [1.0, 0.0, 0.0];
                }
            }
        }
    }
    ;
    if (input[10] <= 1.0) {
        if (input[9] <= 1.3666666746139526) {
            if (input[11] <= 1.5) {
                var73 = [0.0, 1.0, 0.0];
            } else {
                if (input[2] <= 6.055555582046509) {
                    if (input[2] <= 2.7333333492279053) {
                        var73 = [1.0, 0.0, 0.0];
                    } else {
                        if (input[9] <= 1.2428571581840515) {
                            if (input[3] <= 6.666666746139526) {
                                var73 = [1.0, 0.0, 0.0];
                            } else {
                                var73 = [0.0, 0.0, 1.0];
                            }
                        } else {
                            var73 = [1.0, 0.0, 0.0];
                        }
                    }
                } else {
                    var73 = [0.0, 1.0, 0.0];
                }
            }
        } else {
            if (input[2] <= 5.055555582046509) {
                if (input[7] <= 77.5) {
                    var73 = [0.0, 0.0, 1.0];
                } else {
                    if (input[12] <= 1.5) {
                        var73 = [0.0, 0.0, 1.0];
                    } else {
                        var73 = [0.0, 1.0, 0.0];
                    }
                }
            } else {
                if (input[5] <= 2.0731165409088135) {
                    if (input[3] <= 10.386363506317139) {
                        if (input[9] <= 2.833333373069763) {
                            if (input[2] <= 5.708333253860474) {
                                var73 = [1.0, 0.0, 0.0];
                            } else {
                                var73 = [0.0, 0.0, 1.0];
                            }
                        } else {
                            var73 = [0.0, 0.0, 1.0];
                        }
                    } else {
                        if (input[9] <= 1.7708333134651184) {
                            var73 = [0.0, 1.0, 0.0];
                        } else {
                            var73 = [1.0, 0.0, 0.0];
                        }
                    }
                } else {
                    var73 = [1.0, 0.0, 0.0];
                }
            }
        }
    } else {
        if (input[2] <= 8.5) {
            var73 = [0.0, 1.0, 0.0];
        } else {
            if (input[12] <= 1.5) {
                var73 = [1.0, 0.0, 0.0];
            } else {
                var73 = [0.0, 1.0, 0.0];
            }
        }
    }
    ;
    if (input[5] <= 0.7581702470779419) {
        if (input[5] <= 0.46157923340797424) {
            if (input[7] <= 41.66666603088379) {
                var74 = [1.0, 0.0, 0.0];
            } else {
                if (input[1] <= 4.5) {
                    var74 = [0.0, 1.0, 0.0];
                } else {
                    if (input[1] <= 6.5) {
                        var74 = [1.0, 0.0, 0.0];
                    } else {
                        var74 = [0.0, 0.0, 1.0];
                    }
                }
            }
        } else {
            if (input[8] <= 29.16666603088379) {
                var74 = [0.0, 1.0, 0.0];
            } else {
                var74 = [0.0, 0.0, 1.0];
            }
        }
    } else {
        if (input[5] <= 2.0840890407562256) {
            if (input[2] <= 5.458333253860474) {
                if (input[3] <= 9.25) {
                    var74 = [0.0, 0.0, 1.0];
                } else {
                    if (input[6] <= 7.142857074737549) {
                        var74 = [0.0, 1.0, 0.0];
                    } else {
                        if (input[5] <= 1.506864070892334) {
                            var74 = [0.0, 0.0, 1.0];
                        } else {
                            var74 = [1.0, 0.0, 0.0];
                        }
                    }
                }
            } else {
                if (input[3] <= 20.214285850524902) {
                    if (input[12] <= 1.5) {
                        if (input[5] <= 0.8859826326370239) {
                            var74 = [0.0, 1.0, 0.0];
                        } else {
                            var74 = [1.0, 0.0, 0.0];
                        }
                    } else {
                        var74 = [0.0, 0.0, 1.0];
                    }
                } else {
                    var74 = [0.0, 1.0, 0.0];
                }
            }
        } else {
            if (input[2] <= 2.583333373069763) {
                var74 = [0.0, 1.0, 0.0];
            } else {
                if (input[3] <= 14.544642925262451) {
                    var74 = [1.0, 0.0, 0.0];
                } else {
                    if (input[5] <= 3.959495782852173) {
                        var74 = [0.0, 1.0, 0.0];
                    } else {
                        if (input[12] <= 1.5) {
                            var74 = [1.0, 0.0, 0.0];
                        } else {
                            var74 = [0.0, 0.0, 1.0];
                        }
                    }
                }
            }
        }
    }
    ;
    if (input[2] <= 7.75) {
        if (input[5] <= 2.5306248664855957) {
            if (input[3] <= 3.6999999284744263) {
                if (input[1] <= 6.0) {
                    if (input[6] <= 41.66666603088379) {
                        if (input[9] <= 1.5) {
                            if (input[2] <= 2.5) {
                                var75 = [0.0, 1.0, 0.0];
                            } else {
                                if (input[10] <= 4.0) {
                                    var75 = [0.5, 0.5, 0.0];
                                } else {
                                    var75 = [0.0, 1.0, 0.0];
                                }
                            }
                        } else {
                            var75 = [0.0, 1.0, 0.0];
                        }
                    } else {
                        var75 = [0.0, 0.0, 1.0];
                    }
                } else {
                    var75 = [0.0, 0.0, 1.0];
                }
            } else {
                if (input[8] <= 41.66666603088379) {
                    if (input[7] <= 8.333333015441895) {
                        if (input[4] <= 0.9962875247001648) {
                            var75 = [1.0, 0.0, 0.0];
                        } else {
                            var75 = [0.0, 1.0, 0.0];
                        }
                    } else {
                        if (input[6] <= 40.83333396911621) {
                            if (input[9] <= 1.3428571224212646) {
                                if (input[7] <= 58.33333206176758) {
                                    var75 = [1.0, 0.0, 0.0];
                                } else {
                                    var75 = [0.0, 0.0, 1.0];
                                }
                            } else {
                                var75 = [0.0, 0.0, 1.0];
                            }
                        } else {
                            var75 = [0.0, 1.0, 0.0];
                        }
                    }
                } else {
                    var75 = [1.0, 0.0, 0.0];
                }
            }
        } else {
            if (input[9] <= 1.2666667103767395) {
                if (input[1] <= 6.5) {
                    var75 = [0.0, 0.0, 1.0];
                } else {
                    var75 = [0.0, 1.0, 0.0];
                }
            } else {
                var75 = [1.0, 0.0, 0.0];
            }
        }
    } else {
        var75 = [0.0, 1.0, 0.0];
    }
    ;
    if (input[9] <= 1.1500000357627869) {
        if (input[10] <= 2.5) {
            if (input[2] <= 5.2888888120651245) {
                if (input[7] <= 29.16666603088379) {
                    if (input[0] <= 4.0) {
                        var76 = [1.0, 0.0, 0.0];
                    } else {
                        var76 = [0.0, 0.0, 1.0];
                    }
                } else {
                    var76 = [0.0, 1.0, 0.0];
                }
            } else {
                var76 = [0.0, 1.0, 0.0];
            }
        } else {
            if (input[2] <= 4.0) {
                var76 = [1.0, 0.0, 0.0];
            } else {
                if (input[3] <= 7.25) {
                    var76 = [0.0, 1.0, 0.0];
                } else {
                    var76 = [1.0, 0.0, 0.0];
                }
            }
        }
    } else {
        if (input[0] <= 1.5) {
            var76 = [0.0, 1.0, 0.0];
        } else {
            if (input[9] <= 1.7222222089767456) {
                if (input[5] <= 0.8859826326370239) {
                    if (input[12] <= 1.5) {
                        var76 = [0.0, 1.0, 0.0];
                    } else {
                        if (input[0] <= 4.5) {
                            var76 = [0.0, 1.0, 0.0];
                        } else {
                            var76 = [0.0, 0.0, 1.0];
                        }
                    }
                } else {
                    if (input[2] <= 2.950000047683716) {
                        var76 = [0.0, 1.0, 0.0];
                    } else {
                        var76 = [0.0, 0.0, 1.0];
                    }
                }
            } else {
                if (input[5] <= 2.0731165409088135) {
                    if (input[2] <= 5.458333253860474) {
                        var76 = [0.0, 0.0, 1.0];
                    } else {
                        if (input[3] <= 4.464285612106323) {
                            var76 = [0.0, 0.0, 1.0];
                        } else {
                            if (input[4] <= 1.9792214632034302) {
                                if (input[7] <= 55.0) {
                                    var76 = [1.0, 0.0, 0.0];
                                } else {
                                    if (input[4] <= 1.2066758275032043) {
                                        var76 = [1.0, 0.0, 0.0];
                                    } else {
                                        var76 = [0.0, 0.0, 1.0];
                                    }
                                }
                            } else {
                                var76 = [0.0, 0.0, 1.0];
                            }
                        }
                    }
                } else {
                    var76 = [1.0, 0.0, 0.0];
                }
            }
        }
    }
    ;
    if (input[9] <= 1.100000023841858) {
        if (input[11] <= 1.5) {
            if (input[0] <= 1.5) {
                if (input[10] <= 2.5) {
                    var77 = [0.0, 1.0, 0.0];
                } else {
                    if (input[10] <= 4.0) {
                        var77 = [1.0, 0.0, 0.0];
                    } else {
                        var77 = [0.0, 1.0, 0.0];
                    }
                }
            } else {
                var77 = [0.0, 1.0, 0.0];
            }
        } else {
            if (input[0] <= 3.5) {
                var77 = [1.0, 0.0, 0.0];
            } else {
                if (input[1] <= 2.5) {
                    var77 = [0.0, 1.0, 0.0];
                } else {
                    if (input[0] <= 4.5) {
                        var77 = [0.0, 1.0, 0.0];
                    } else {
                        var77 = [0.0, 0.0, 1.0];
                    }
                }
            }
        }
    } else {
        if (input[2] <= 4.722222089767456) {
            if (input[8] <= 26.66666603088379) {
                if (input[0] <= 6.5) {
                    var77 = [0.0, 0.0, 1.0];
                } else {
                    if (input[0] <= 8.5) {
                        var77 = [1.0, 0.0, 0.0];
                    } else {
                        var77 = [0.0, 0.0, 1.0];
                    }
                }
            } else {
                if (input[2] <= 3.25) {
                    var77 = [0.0, 1.0, 0.0];
                } else {
                    var77 = [0.0, 0.0, 1.0];
                }
            }
        } else {
            if (input[5] <= 0.8859826326370239) {
                if (input[4] <= 0.46650634706020355) {
                    var77 = [0.0, 1.0, 0.0];
                } else {
                    if (input[9] <= 1.9999999403953552) {
                        var77 = [0.0, 1.0, 0.0];
                    } else {
                        if (input[11] <= 1.5) {
                            var77 = [0.0, 0.0, 1.0];
                        } else {
                            var77 = [1.0, 0.0, 0.0];
                        }
                    }
                }
            } else {
                if (input[5] <= 1.6701045632362366) {
                    if (input[1] <= 4.5) {
                        if (input[11] <= 1.5) {
                            var77 = [0.0, 0.0, 1.0];
                        } else {
                            var77 = [1.0, 0.0, 0.0];
                        }
                    } else {
                        var77 = [0.0, 0.0, 1.0];
                    }
                } else {
                    if (input[0] <= 11.0) {
                        var77 = [1.0, 0.0, 0.0];
                    } else {
                        if (input[1] <= 5.0) {
                            var77 = [1.0, 0.0, 0.0];
                        } else {
                            if (input[1] <= 11.5) {
                                var77 = [0.0, 0.0, 1.0];
                            } else {
                                var77 = [1.0, 0.0, 0.0];
                            }
                        }
                    }
                }
            }
        }
    }
    ;
    if (input[11] <= 1.5) {
        if (input[0] <= 3.5) {
            if (input[8] <= 16.66666603088379) {
                if (input[5] <= 0.43570226430892944) {
                    if (input[5] <= 0.1749635487794876) {
                        var78 = [0.0, 1.0, 0.0];
                    } else {
                        var78 = [0.0, 0.0, 1.0];
                    }
                } else {
                    if (input[3] <= 2.333333373069763) {
                        if (input[2] <= 2.5) {
                            var78 = [0.0, 1.0, 0.0];
                        } else {
                            var78 = [0.5, 0.5, 0.0];
                        }
                    } else {
                        if (input[5] <= 1.095014065504074) {
                            var78 = [0.0, 1.0, 0.0];
                        } else {
                            var78 = [0.0, 0.0, 1.0];
                        }
                    }
                }
            } else {
                if (input[12] <= 1.5) {
                    var78 = [0.0, 0.0, 1.0];
                } else {
                    var78 = [0.0, 1.0, 0.0];
                }
            }
        } else {
            if (input[5] <= 2.1924078464508057) {
                var78 = [0.0, 0.0, 1.0];
            } else {
                if (input[4] <= 1.3976657688617706) {
                    var78 = [1.0, 0.0, 0.0];
                } else {
                    var78 = [0.0, 1.0, 0.0];
                }
            }
        }
    } else {
        if (input[7] <= 47.727272033691406) {
            if (input[9] <= 1.2666667103767395) {
                if (input[5] <= 1.593089371919632) {
                    if (input[7] <= 12.5) {
                        var78 = [1.0, 0.0, 0.0];
                    } else {
                        var78 = [0.0, 0.0, 1.0];
                    }
                } else {
                    var78 = [0.0, 1.0, 0.0];
                }
            } else {
                if (input[1] <= 9.5) {
                    if (input[7] <= 20.833333015441895) {
                        if (input[6] <= 7.142857074737549) {
                            var78 = [1.0, 0.0, 0.0];
                        } else {
                            var78 = [0.0, 0.0, 1.0];
                        }
                    } else {
                        var78 = [1.0, 0.0, 0.0];
                    }
                } else {
                    if (input[12] <= 3.5) {
                        var78 = [1.0, 0.0, 0.0];
                    } else {
                        var78 = [0.0, 0.0, 1.0];
                    }
                }
            }
        } else {
            if (input[8] <= 13.333333015441895) {
                if (input[4] <= 0.8150278627872467) {
                    if (input[7] <= 63.33333206176758) {
                        if (input[9] <= 2.300000011920929) {
                            var78 = [0.0, 0.0, 1.0];
                        } else {
                            var78 = [1.0, 0.0, 0.0];
                        }
                    } else {
                        var78 = [0.0, 0.0, 1.0];
                    }
                } else {
                    var78 = [1.0, 0.0, 0.0];
                }
            } else {
                if (input[7] <= 59.61538314819336) {
                    var78 = [0.0, 1.0, 0.0];
                } else {
                    var78 = [1.0, 0.0, 0.0];
                }
            }
        }
    }
    ;
    if (input[5] <= 3.2592287063598633) {
        if (input[8] <= 12.698412418365479) {
            if (input[9] <= 1.4166666865348816) {
                if (input[3] <= 6.25) {
                    if (input[7] <= 25.0) {
                        var79 = [1.0, 0.0, 0.0];
                    } else {
                        if (input[3] <= 2.25) {
                            if (input[3] <= 1.75) {
                                var79 = [0.0, 1.0, 0.0];
                            } else {
                                var79 = [0.2, 0.8, 0.0];
                            }
                        } else {
                            var79 = [0.0, 1.0, 0.0];
                        }
                    }
                } else {
                    var79 = [0.0, 1.0, 0.0];
                }
            } else {
                if (input[2] <= 6.541666746139526) {
                    if (input[7] <= 15.476190090179443) {
                        var79 = [1.0, 0.0, 0.0];
                    } else {
                        var79 = [0.0, 0.0, 1.0];
                    }
                } else {
                    if (input[5] <= 1.1495760679244995) {
                        if (input[5] <= 0.2357022613286972) {
                            var79 = [1.0, 0.0, 0.0];
                        } else {
                            var79 = [0.0, 1.0, 0.0];
                        }
                    } else {
                        var79 = [1.0, 0.0, 0.0];
                    }
                }
            }
        } else {
            if (input[2] <= 9.392857074737549) {
                if (input[0] <= 4.5) {
                    if (input[5] <= 0.7163534909486771) {
                        var79 = [0.0, 0.0, 1.0];
                    } else {
                        if (input[10] <= 1.0) {
                            var79 = [0.0, 1.0, 0.0];
                        } else {
                            var79 = [1.0, 0.0, 0.0];
                        }
                    }
                } else {
                    var79 = [0.0, 0.0, 1.0];
                }
            } else {
                if (input[5] <= 0.5299311280250549) {
                    var79 = [1.0, 0.0, 0.0];
                } else {
                    var79 = [0.0, 1.0, 0.0];
                }
            }
        }
    } else {
        if (input[7] <= 11.764705657958984) {
            var79 = [0.0, 0.0, 1.0];
        } else {
            if (input[4] <= 0.24494896829128265) {
                var79 = [0.0, 1.0, 0.0];
            } else {
                var79 = [1.0, 0.0, 0.0];
            }
        }
    }
    ;
    if (input[11] <= 2.5) {
        if (input[1] <= 4.5) {
            if (input[2] <= 3.708333373069763) {
                if (input[4] <= 0.3863389939069748) {
                    if (input[0] <= 5.5) {
                        if (input[2] <= 2.5) {
                            var80 = [0.0, 1.0, 0.0];
                        } else {
                            var80 = [0.5, 0.5, 0.0];
                        }
                    } else {
                        var80 = [1.0, 0.0, 0.0];
                    }
                } else {
                    var80 = [0.0, 0.0, 1.0];
                }
            } else {
                if (input[3] <= 11.125) {
                    if (input[2] <= 5.666666746139526) {
                        if (input[4] <= 0.6495190411806107) {
                            var80 = [0.0, 1.0, 0.0];
                        } else {
                            var80 = [0.0, 0.0, 1.0];
                        }
                    } else {
                        var80 = [0.0, 1.0, 0.0];
                    }
                } else {
                    if (input[7] <= 41.66666603088379) {
                        var80 = [0.0, 1.0, 0.0];
                    } else {
                        if (input[0] <= 2.5) {
                            var80 = [1.0, 0.0, 0.0];
                        } else {
                            var80 = [0.0, 1.0, 0.0];
                        }
                    }
                }
            }
        } else {
            if (input[9] <= 1.2916666865348816) {
                var80 = [0.0, 1.0, 0.0];
            } else {
                if (input[3] <= 7.400000095367432) {
                    var80 = [0.0, 0.0, 1.0];
                } else {
                    if (input[0] <= 9.5) {
                        if (input[9] <= 1.9285714030265808) {
                            if (input[4] <= 1.7886045575141907) {
                                var80 = [0.0, 0.0, 1.0];
                            } else {
                                var80 = [0.0, 1.0, 0.0];
                            }
                        } else {
                            if (input[4] <= 1.8364916443824768) {
                                var80 = [1.0, 0.0, 0.0];
                            } else {
                                if (input[5] <= 1.941713571548462) {
                                    var80 = [0.0, 0.0, 1.0];
                                } else {
                                    var80 = [1.0, 0.0, 0.0];
                                }
                            }
                        }
                    } else {
                        var80 = [0.0, 0.0, 1.0];
                    }
                }
            }
        }
    } else {
        if (input[4] <= 1.4164966344833374) {
            var80 = [1.0, 0.0, 0.0];
        } else {
            var80 = [0.0, 1.0, 0.0];
        }
    }
    ;
    if (input[4] <= 0.45220860838890076) {
        if (input[1] <= 3.5) {
            if (input[11] <= 1.5) {
                if (input[3] <= 2.333333373069763) {
                    var81 = [1.0, 0.0, 0.0];
                } else {
                    var81 = [0.0, 1.0, 0.0];
                }
            } else {
                if (input[7] <= 41.66666603088379) {
                    if (input[5] <= 1.6499157845973969) {
                        var81 = [1.0, 0.0, 0.0];
                    } else {
                        var81 = [0.0, 1.0, 0.0];
                    }
                } else {
                    if (input[0] <= 2.5) {
                        var81 = [1.0, 0.0, 0.0];
                    } else {
                        var81 = [0.0, 1.0, 0.0];
                    }
                }
            }
        } else {
            if (input[9] <= 1.9583333730697632) {
                if (input[4] <= 0.21650634706020355) {
                    var81 = [0.0, 0.0, 1.0];
                } else {
                    var81 = [0.0, 1.0, 0.0];
                }
            } else {
                var81 = [1.0, 0.0, 0.0];
            }
        }
    } else {
        if (input[11] <= 2.5) {
            if (input[12] <= 3.0) {
                if (input[3] <= 9.333333492279053) {
                    if (input[2] <= 6.041666746139526) {
                        var81 = [0.0, 0.0, 1.0];
                    } else {
                        if (input[0] <= 2.5) {
                            var81 = [0.0, 0.0, 1.0];
                        } else {
                            if (input[3] <= 5.464285612106323) {
                                var81 = [0.0, 0.0, 1.0];
                            } else {
                                var81 = [0.0, 1.0, 0.0];
                            }
                        }
                    }
                } else {
                    if (input[5] <= 0.9869237542152405) {
                        var81 = [0.0, 1.0, 0.0];
                    } else {
                        if (input[4] <= 1.361760437488556) {
                            if (input[3] <= 10.291666507720947) {
                                var81 = [1.0, 0.0, 0.0];
                            } else {
                                var81 = [0.0, 0.0, 1.0];
                            }
                        } else {
                            var81 = [1.0, 0.0, 0.0];
                        }
                    }
                }
            } else {
                var81 = [1.0, 0.0, 0.0];
            }
        } else {
            if (input[4] <= 1.2539415061473846) {
                var81 = [1.0, 0.0, 0.0];
            } else {
                if (input[5] <= 3.2592287063598633) {
                    var81 = [0.0, 1.0, 0.0];
                } else {
                    var81 = [1.0, 0.0, 0.0];
                }
            }
        }
    }
    ;
    if (input[3] <= 11.083333015441895) {
        if (input[0] <= 1.5) {
            if (input[7] <= 58.33333206176758) {
                var82 = [0.5, 0.5, 0.0];
            } else {
                var82 = [0.0, 1.0, 0.0];
            }
        } else {
            if (input[3] <= 8.96666669845581) {
                if (input[4] <= 0.2357022613286972) {
                    if (input[8] <= 20.0) {
                        if (input[11] <= 2.0) {
                            var82 = [0.0, 1.0, 0.0];
                        } else {
                            var82 = [1.0, 0.0, 0.0];
                        }
                    } else {
                        var82 = [0.0, 0.0, 1.0];
                    }
                } else {
                    if (input[8] <= 58.33333206176758) {
                        if (input[2] <= 6.041666746139526) {
                            if (input[12] <= 1.5) {
                                var82 = [0.0, 0.0, 1.0];
                            } else {
                                if (input[9] <= 1.699999988079071) {
                                    var82 = [0.0, 0.0, 1.0];
                                } else {
                                    if (input[1] <= 5.5) {
                                        var82 = [0.0, 1.0, 0.0];
                                    } else {
                                        var82 = [0.0, 0.0, 1.0];
                                    }
                                }
                            }
                        } else {
                            if (input[9] <= 1.8333333134651184) {
                                var82 = [0.0, 1.0, 0.0];
                            } else {
                                var82 = [0.0, 0.0, 1.0];
                            }
                        }
                    } else {
                        var82 = [1.0, 0.0, 0.0];
                    }
                }
            } else {
                if (input[9] <= 1.7619047164916992) {
                    if (input[9] <= 1.1428571343421936) {
                        var82 = [0.0, 1.0, 0.0];
                    } else {
                        if (input[0] <= 6.5) {
                            var82 = [0.0, 1.0, 0.0];
                        } else {
                            if (input[1] <= 5.5) {
                                var82 = [1.0, 0.0, 0.0];
                            } else {
                                var82 = [0.0, 0.0, 1.0];
                            }
                        }
                    }
                } else {
                    if (input[5] <= 1.6701045632362366) {
                        var82 = [0.0, 0.0, 1.0];
                    } else {
                        if (input[4] <= 2.4203792810440063) {
                            if (input[9] <= 3.476190447807312) {
                                var82 = [1.0, 0.0, 0.0];
                            } else {
                                var82 = [0.0, 0.0, 1.0];
                            }
                        } else {
                            var82 = [1.0, 0.0, 0.0];
                        }
                    }
                }
            }
        }
    } else {
        if (input[12] <= 2.5) {
            if (input[9] <= 1.699999988079071) {
                if (input[12] <= 1.5) {
                    var82 = [1.0, 0.0, 0.0];
                } else {
                    if (input[0] <= 9.5) {
                        var82 = [0.0, 1.0, 0.0];
                    } else {
                        var82 = [0.0, 0.0, 1.0];
                    }
                }
            } else {
                var82 = [1.0, 0.0, 0.0];
            }
        } else {
            var82 = [0.0, 1.0, 0.0];
        }
    }
    ;
    if (input[0] <= 7.5) {
        if (input[0] <= 4.5) {
            if (input[6] <= 25.0) {
                if (input[11] <= 1.5) {
                    if (input[2] <= 6.0) {
                        if (input[2] <= 3.5) {
                            if (input[1] <= 2.5) {
                                if (input[3] <= 1.5) {
                                    var83 = [0.0, 1.0, 0.0];
                                } else {
                                    var83 = [0.3333333333333333, 0.6666666666666666, 0.0];
                                }
                            } else {
                                var83 = [0.0, 1.0, 0.0];
                            }
                        } else {
                            if (input[5] <= 0.7163534909486771) {
                                var83 = [0.0, 0.0, 1.0];
                            } else {
                                var83 = [1.0, 0.0, 0.0];
                            }
                        }
                    } else {
                        if (input[5] <= 0.43570226430892944) {
                            var83 = [0.0, 0.0, 1.0];
                        } else {
                            var83 = [0.0, 1.0, 0.0];
                        }
                    }
                } else {
                    if (input[1] <= 2.5) {
                        if (input[2] <= 3.708333373069763) {
                            var83 = [1.0, 0.0, 0.0];
                        } else {
                            var83 = [0.0, 1.0, 0.0];
                        }
                    } else {
                        var83 = [1.0, 0.0, 0.0];
                    }
                }
            } else {
                var83 = [0.0, 0.0, 1.0];
            }
        } else {
            if (input[9] <= 2.1666666865348816) {
                if (input[1] <= 2.5) {
                    var83 = [0.0, 1.0, 0.0];
                } else {
                    if (input[4] <= 0.2357022613286972) {
                        if (input[5] <= 1.593089371919632) {
                            var83 = [0.0, 0.0, 1.0];
                        } else {
                            var83 = [0.0, 1.0, 0.0];
                        }
                    } else {
                        var83 = [0.0, 0.0, 1.0];
                    }
                }
            } else {
                if (input[1] <= 9.0) {
                    var83 = [1.0, 0.0, 0.0];
                } else {
                    var83 = [0.0, 0.0, 1.0];
                }
            }
        }
    } else {
        if (input[7] <= 20.09803867340088) {
            if (input[6] <= 3.3333332538604736) {
                if (input[3] <= 19.464285850524902) {
                    var83 = [1.0, 0.0, 0.0];
                } else {
                    var83 = [0.0, 1.0, 0.0];
                }
            } else {
                var83 = [0.0, 0.0, 1.0];
            }
        } else {
            if (input[1] <= 3.0) {
                var83 = [0.0, 1.0, 0.0];
            } else {
                if (input[4] <= 0.7201562225818634) {
                    var83 = [0.0, 0.0, 1.0];
                } else {
                    if (input[0] <= 8.5) {
                        if (input[1] <= 11.0) {
                            var83 = [0.0, 0.0, 1.0];
                        } else {
                            var83 = [1.0, 0.0, 0.0];
                        }
                    } else {
                        var83 = [1.0, 0.0, 0.0];
                    }
                }
            }
        }
    }
    ;
    if (input[0] <= 4.5) {
        if (input[7] <= 90.0) {
            if (input[9] <= 2.333333373069763) {
                if (input[8] <= 41.66666603088379) {
                    if (input[6] <= 16.66666603088379) {
                        if (input[2] <= 4.833333253860474) {
                            if (input[2] <= 3.8333332538604736) {
                                if (input[1] <= 2.5) {
                                    var84 = [0.5, 0.5, 0.0];
                                } else {
                                    var84 = [0.0, 1.0, 0.0];
                                }
                            } else {
                                var84 = [0.0, 0.0, 1.0];
                            }
                        } else {
                            if (input[3] <= 11.125) {
                                var84 = [0.0, 1.0, 0.0];
                            } else {
                                if (input[5] <= 1.25) {
                                    var84 = [1.0, 0.0, 0.0];
                                } else {
                                    var84 = [0.0, 1.0, 0.0];
                                }
                            }
                        }
                    } else {
                        var84 = [0.0, 1.0, 0.0];
                    }
                } else {
                    if (input[7] <= 36.66666603088379) {
                        var84 = [1.0, 0.0, 0.0];
                    } else {
                        var84 = [0.0, 0.0, 1.0];
                    }
                }
            } else {
                var84 = [1.0, 0.0, 0.0];
            }
        } else {
            var84 = [0.0, 0.0, 1.0];
        }
    } else {
        if (input[2] <= 5.055555582046509) {
            if (input[9] <= 1.3666666746139526) {
                if (input[3] <= 8.416666507720947) {
                    if (input[7] <= 16.66666603088379) {
                        var84 = [0.0, 0.0, 1.0];
                    } else {
                        var84 = [1.0, 0.0, 0.0];
                    }
                } else {
                    var84 = [0.0, 0.0, 1.0];
                }
            } else {
                var84 = [0.0, 0.0, 1.0];
            }
        } else {
            if (input[3] <= 23.797618865966797) {
                if (input[4] <= 1.3137825727462769) {
                    if (input[8] <= 6.666666507720947) {
                        if (input[9] <= 1.4375) {
                            var84 = [0.0, 1.0, 0.0];
                        } else {
                            if (input[4] <= 1.2066758275032043) {
                                var84 = [1.0, 0.0, 0.0];
                            } else {
                                var84 = [0.0, 0.0, 1.0];
                            }
                        }
                    } else {
                        var84 = [0.0, 0.0, 1.0];
                    }
                } else {
                    var84 = [1.0, 0.0, 0.0];
                }
            } else {
                if (input[4] <= 1.9947147965431213) {
                    var84 = [0.0, 1.0, 0.0];
                } else {
                    var84 = [1.0, 0.0, 0.0];
                }
            }
        }
    }
    ;
    if (input[11] <= 2.5) {
        if (input[2] <= 6.166666746139526) {
            if (input[0] <= 3.5) {
                if (input[7] <= 58.33333206176758) {
                    if (input[10] <= 4.0) {
                        if (input[1] <= 2.5) {
                            var85 = [1.0, 0.0, 0.0];
                        } else {
                            if (input[4] <= 1.085538849234581) {
                                if (input[7] <= 36.66666603088379) {
                                    if (input[9] <= 1.3333333134651184) {
                                        var85 = [0.0, 1.0, 0.0];
                                    } else {
                                        var85 = [0.0, 0.0, 1.0];
                                    }
                                } else {
                                    var85 = [0.0, 0.0, 1.0];
                                }
                            } else {
                                var85 = [1.0, 0.0, 0.0];
                            }
                        }
                    } else {
                        var85 = [0.0, 1.0, 0.0];
                    }
                } else {
                    var85 = [0.0, 1.0, 0.0];
                }
            } else {
                if (input[2] <= 2.549999952316284) {
                    var85 = [0.0, 1.0, 0.0];
                } else {
                    if (input[0] <= 6.5) {
                        if (input[2] <= 3.708333373069763) {
                            var85 = [0.0, 0.0, 1.0];
                        } else {
                            if (input[4] <= 0.7501000612974167) {
                                if (input[0] <= 4.5) {
                                    var85 = [0.0, 1.0, 0.0];
                                } else {
                                    var85 = [0.0, 0.0, 1.0];
                                }
                            } else {
                                var85 = [0.0, 0.0, 1.0];
                            }
                        }
                    } else {
                        if (input[2] <= 5.222222328186035) {
                            if (input[5] <= 1.7344118356704712) {
                                var85 = [1.0, 0.0, 0.0];
                            } else {
                                if (input[12] <= 1.5) {
                                    var85 = [0.0, 0.0, 1.0];
                                } else {
                                    var85 = [1.0, 0.0, 0.0];
                                }
                            }
                        } else {
                            var85 = [0.0, 0.0, 1.0];
                        }
                    }
                }
            }
        } else {
            if (input[7] <= 53.571428298950195) {
                if (input[9] <= 2.25) {
                    if (input[2] <= 14.300000190734863) {
                        var85 = [0.0, 1.0, 0.0];
                    } else {
                        var85 = [1.0, 0.0, 0.0];
                    }
                } else {
                    if (input[3] <= 6.733333468437195) {
                        var85 = [0.0, 0.0, 1.0];
                    } else {
                        var85 = [1.0, 0.0, 0.0];
                    }
                }
            } else {
                if (input[3] <= 2.6190476417541504) {
                    if (input[7] <= 61.90476036071777) {
                        var85 = [0.0, 0.0, 1.0];
                    } else {
                        var85 = [1.0, 0.0, 0.0];
                    }
                } else {
                    var85 = [0.0, 1.0, 0.0];
                }
            }
        }
    } else {
        if (input[8] <= 5.55555534362793) {
            var85 = [1.0, 0.0, 0.0];
        } else {
            var85 = [0.0, 1.0, 0.0];
        }
    }
    ;
    if (input[3] <= 9.5) {
        if (input[3] <= 6.583333253860474) {
            if (input[11] <= 1.5) {
                if (input[1] <= 4.5) {
                    if (input[4] <= 0.4145781099796295) {
                        if (input[5] <= 0.4857022613286972) {
                            var86 = [0.0, 1.0, 0.0];
                        } else {
                            if (input[3] <= 4.0) {
                                var86 = [0.5, 0.5, 0.0];
                            } else {
                                var86 = [0.0, 1.0, 0.0];
                            }
                        }
                    } else {
                        if (input[0] <= 3.5) {
                            var86 = [0.0, 1.0, 0.0];
                        } else {
                            var86 = [0.0, 0.0, 1.0];
                        }
                    }
                } else {
                    if (input[8] <= 58.33333206176758) {
                        if (input[12] <= 1.5) {
                            var86 = [0.0, 0.0, 1.0];
                        } else {
                            if (input[0] <= 2.5) {
                                var86 = [0.0, 0.0, 1.0];
                            } else {
                                if (input[6] <= 16.66666603088379) {
                                    var86 = [0.0, 0.0, 1.0];
                                } else {
                                    var86 = [0.0, 1.0, 0.0];
                                }
                            }
                        }
                    } else {
                        var86 = [1.0, 0.0, 0.0];
                    }
                }
            } else {
                var86 = [1.0, 0.0, 0.0];
            }
        } else {
            if (input[3] <= 9.166666507720947) {
                if (input[2] <= 6.375) {
                    if (input[4] <= 0.42204125225543976) {
                        if (input[0] <= 5.5) {
                            var86 = [0.0, 0.0, 1.0];
                        } else {
                            var86 = [1.0, 0.0, 0.0];
                        }
                    } else {
                        var86 = [0.0, 0.0, 1.0];
                    }
                } else {
                    if (input[1] <= 6.0) {
                        var86 = [0.0, 1.0, 0.0];
                    } else {
                        var86 = [1.0, 0.0, 0.0];
                    }
                }
            } else {
                var86 = [0.0, 1.0, 0.0];
            }
        }
    } else {
        if (input[6] <= 3.3333332538604736) {
            if (input[9] <= 1.60317462682724) {
                if (input[2] <= 5.888888835906982) {
                    var86 = [0.0, 0.0, 1.0];
                } else {
                    if (input[4] <= 0.547722578048706) {
                        if (input[0] <= 2.5) {
                            var86 = [1.0, 0.0, 0.0];
                        } else {
                            var86 = [0.0, 1.0, 0.0];
                        }
                    } else {
                        var86 = [0.0, 1.0, 0.0];
                    }
                }
            } else {
                var86 = [1.0, 0.0, 0.0];
            }
        } else {
            if (input[4] <= 1.9456480741500854) {
                var86 = [0.0, 0.0, 1.0];
            } else {
                var86 = [1.0, 0.0, 0.0];
            }
        }
    }
    ;
    if (input[1] <= 2.5) {
        if (input[8] <= 12.5) {
            if (input[11] <= 1.5) {
                var87 = [0.0, 1.0, 0.0];
            } else {
                if (input[3] <= 12.75) {
                    var87 = [1.0, 0.0, 0.0];
                } else {
                    if (input[5] <= 1.25) {
                        var87 = [1.0, 0.0, 0.0];
                    } else {
                        var87 = [0.0, 1.0, 0.0];
                    }
                }
            }
        } else {
            var87 = [0.0, 1.0, 0.0];
        }
    } else {
        if (input[2] <= 6.166666746139526) {
            if (input[2] <= 2.583333373069763) {
                var87 = [0.0, 1.0, 0.0];
            } else {
                if (input[11] <= 2.5) {
                    if (input[2] <= 2.7333333492279053) {
                        var87 = [1.0, 0.0, 0.0];
                    } else {
                        if (input[8] <= 49.99999809265137) {
                            if (input[1] <= 8.5) {
                                if (input[3] <= 4.75) {
                                    if (input[1] <= 4.0) {
                                        var87 = [0.0, 1.0, 0.0];
                                    } else {
                                        var87 = [0.0, 0.0, 1.0];
                                    }
                                } else {
                                    var87 = [0.0, 0.0, 1.0];
                                }
                            } else {
                                var87 = [1.0, 0.0, 0.0];
                            }
                        } else {
                            var87 = [1.0, 0.0, 0.0];
                        }
                    }
                } else {
                    var87 = [1.0, 0.0, 0.0];
                }
            }
        } else {
            if (input[9] <= 1.8333333134651184) {
                var87 = [0.0, 1.0, 0.0];
            } else {
                if (input[5] <= 0.8213316202163696) {
                    if (input[4] <= 1.0801234245300293) {
                        var87 = [0.0, 1.0, 0.0];
                    } else {
                        var87 = [0.0, 0.0, 1.0];
                    }
                } else {
                    var87 = [1.0, 0.0, 0.0];
                }
            }
        }
    }
    ;
    if (input[10] <= 0.5) {
        if (input[9] <= 1.100000023841858) {
            if (input[5] <= 0.2357022613286972) {
                var88 = [1.0, 0.0, 0.0];
            } else {
                if (input[12] <= 1.5) {
                    if (input[6] <= 25.0) {
                        if (input[3] <= 6.833333492279053) {
                            var88 = [0.0, 1.0, 0.0];
                        } else {
                            var88 = [0.0, 0.0, 1.0];
                        }
                    } else {
                        var88 = [0.0, 1.0, 0.0];
                    }
                } else {
                    var88 = [0.0, 1.0, 0.0];
                }
            }
        } else {
            if (input[2] <= 5.458333253860474) {
                if (input[3] <= 12.291666507720947) {
                    if (input[5] <= 2.4348318576812744) {
                        if (input[3] <= 9.375) {
                            var88 = [0.0, 0.0, 1.0];
                        } else {
                            if (input[2] <= 4.214285731315613) {
                                var88 = [1.0, 0.0, 0.0];
                            } else {
                                var88 = [0.0, 0.0, 1.0];
                            }
                        }
                    } else {
                        var88 = [1.0, 0.0, 0.0];
                    }
                } else {
                    if (input[9] <= 1.524999976158142) {
                        var88 = [0.0, 1.0, 0.0];
                    } else {
                        var88 = [1.0, 0.0, 0.0];
                    }
                }
            } else {
                if (input[0] <= 2.5) {
                    var88 = [0.0, 0.0, 1.0];
                } else {
                    if (input[11] <= 2.5) {
                        if (input[8] <= 40.47618913650513) {
                            if (input[7] <= 9.090909004211426) {
                                if (input[0] <= 4.5) {
                                    var88 = [0.0, 1.0, 0.0];
                                } else {
                                    var88 = [1.0, 0.0, 0.0];
                                }
                            } else {
                                var88 = [0.0, 0.0, 1.0];
                            }
                        } else {
                            var88 = [1.0, 0.0, 0.0];
                        }
                    } else {
                        var88 = [1.0, 0.0, 0.0];
                    }
                }
            }
        }
    } else {
        if (input[11] <= 1.5) {
            if (input[2] <= 8.5) {
                if (input[10] <= 4.0) {
                    if (input[5] <= 0.25) {
                        var88 = [0.0, 1.0, 0.0];
                    } else {
                        var88 = [1.0, 0.0, 0.0];
                    }
                } else {
                    var88 = [0.0, 1.0, 0.0];
                }
            } else {
                if (input[8] <= 50.0) {
                    var88 = [0.0, 1.0, 0.0];
                } else {
                    var88 = [1.0, 0.0, 0.0];
                }
            }
        } else {
            var88 = [1.0, 0.0, 0.0];
        }
    }
    ;
    if (input[2] <= 6.541666746139526) {
        if (input[5] <= 0.5999270975589752) {
            if (input[4] <= 0.7071067690849304) {
                if (input[5] <= 0.25) {
                    var89 = [0.0, 1.0, 0.0];
                } else {
                    if (input[3] <= 1.75) {
                        var89 = [0.0, 1.0, 0.0];
                    } else {
                        var89 = [1.0, 0.0, 0.0];
                    }
                }
            } else {
                var89 = [0.0, 0.0, 1.0];
            }
        } else {
            if (input[2] <= 2.950000047683716) {
                var89 = [0.0, 1.0, 0.0];
            } else {
                if (input[0] <= 7.5) {
                    if (input[3] <= 6.583333253860474) {
                        if (input[0] <= 3.5) {
                            if (input[3] <= 5.464285612106323) {
                                var89 = [0.0, 0.0, 1.0];
                            } else {
                                var89 = [0.0, 1.0, 0.0];
                            }
                        } else {
                            var89 = [0.0, 0.0, 1.0];
                        }
                    } else {
                        if (input[3] <= 9.25) {
                            var89 = [0.0, 0.0, 1.0];
                        } else {
                            if (input[3] <= 9.550000190734863) {
                                var89 = [0.0, 1.0, 0.0];
                            } else {
                                var89 = [0.0, 0.0, 1.0];
                            }
                        }
                    }
                } else {
                    if (input[8] <= 5.0) {
                        var89 = [1.0, 0.0, 0.0];
                    } else {
                        var89 = [0.0, 0.0, 1.0];
                    }
                }
            }
        }
    } else {
        if (input[2] <= 8.166666507720947) {
            if (input[3] <= 4.712499976158142) {
                if (input[1] <= 4.0) {
                    var89 = [0.0, 1.0, 0.0];
                } else {
                    var89 = [0.0, 0.0, 1.0];
                }
            } else {
                if (input[5] <= 1.3655142188072205) {
                    if (input[11] <= 2.5) {
                        var89 = [0.0, 1.0, 0.0];
                    } else {
                        var89 = [1.0, 0.0, 0.0];
                    }
                } else {
                    var89 = [1.0, 0.0, 0.0];
                }
            }
        } else {
            if (input[7] <= 41.66666603088379) {
                var89 = [0.0, 1.0, 0.0];
            } else {
                var89 = [1.0, 0.0, 0.0];
            }
        }
    }
    ;
    if (input[1] <= 3.5) {
        if (input[4] <= 0.20000000298023224) {
            if (input[12] <= 1.5) {
                if (input[3] <= 14.75) {
                    if (input[3] <= 6.166666746139526) {
                        if (input[2] <= 6.25) {
                            if (input[3] <= 1.8333333134651184) {
                                var90 = [0.0, 1.0, 0.0];
                            } else {
                                if (input[7] <= 25.0) {
                                    var90 = [1.0, 0.0, 0.0];
                                } else {
                                    if (input[6] <= 30.0) {
                                        if (input[2] <= 4.0) {
                                            var90 = [0.5, 0.5, 0.0];
                                        } else {
                                            var90 = [0.0, 1.0, 0.0];
                                        }
                                    } else {
                                        var90 = [0.0, 1.0, 0.0];
                                    }
                                }
                            }
                        } else {
                            var90 = [1.0, 0.0, 0.0];
                        }
                    } else {
                        var90 = [0.0, 1.0, 0.0];
                    }
                } else {
                    var90 = [1.0, 0.0, 0.0];
                }
            } else {
                var90 = [0.0, 1.0, 0.0];
            }
        } else {
            if (input[11] <= 1.5) {
                var90 = [0.0, 0.0, 1.0];
            } else {
                var90 = [0.0, 1.0, 0.0];
            }
        }
    } else {
        if (input[9] <= 1.7222222089767456) {
            if (input[2] <= 5.833333492279053) {
                if (input[8] <= 5.0) {
                    if (input[9] <= 1.2916666865348816) {
                        var90 = [0.0, 1.0, 0.0];
                    } else {
                        var90 = [0.0, 0.0, 1.0];
                    }
                } else {
                    var90 = [0.0, 0.0, 1.0];
                }
            } else {
                var90 = [0.0, 1.0, 0.0];
            }
        } else {
            if (input[3] <= 11.041666507720947) {
                if (input[4] <= 0.9672653079032898) {
                    if (input[4] <= 0.6582483053207397) {
                        var90 = [1.0, 0.0, 0.0];
                    } else {
                        var90 = [0.0, 1.0, 0.0];
                    }
                } else {
                    if (input[1] <= 10.0) {
                        var90 = [0.0, 0.0, 1.0];
                    } else {
                        var90 = [1.0, 0.0, 0.0];
                    }
                }
            } else {
                var90 = [1.0, 0.0, 0.0];
            }
        }
    }
    ;
    if (input[4] <= 0.20000000298023224) {
        if (input[10] <= 4.0) {
            if (input[7] <= 75.0) {
                if (input[10] <= 1.5) {
                    if (input[1] <= 3.0) {
                        var91 = [0.0, 1.0, 0.0];
                    } else {
                        var91 = [1.0, 0.0, 0.0];
                    }
                } else {
                    var91 = [1.0, 0.0, 0.0];
                }
            } else {
                var91 = [0.0, 1.0, 0.0];
            }
        } else {
            if (input[10] <= 8.5) {
                var91 = [0.0, 1.0, 0.0];
            } else {
                if (input[10] <= 10.5) {
                    var91 = [1.0, 0.0, 0.0];
                } else {
                    var91 = [0.0, 1.0, 0.0];
                }
            }
        }
    } else {
        if (input[9] <= 1.550000011920929) {
            if (input[0] <= 4.5) {
                if (input[2] <= 5.666666746139526) {
                    if (input[2] <= 4.375) {
                        var91 = [0.0, 1.0, 0.0];
                    } else {
                        var91 = [0.0, 0.0, 1.0];
                    }
                } else {
                    var91 = [0.0, 1.0, 0.0];
                }
            } else {
                if (input[0] <= 6.5) {
                    var91 = [0.0, 0.0, 1.0];
                } else {
                    if (input[1] <= 5.5) {
                        var91 = [1.0, 0.0, 0.0];
                    } else {
                        var91 = [0.0, 1.0, 0.0];
                    }
                }
            }
        } else {
            if (input[11] <= 2.5) {
                if (input[12] <= 1.5) {
                    if (input[0] <= 3.5) {
                        if (input[2] <= 5.166666507720947) {
                            var91 = [0.0, 0.0, 1.0];
                        } else {
                            if (input[1] <= 6.5) {
                                var91 = [1.0, 0.0, 0.0];
                            } else {
                                var91 = [0.0, 0.0, 1.0];
                            }
                        }
                    } else {
                        var91 = [0.0, 0.0, 1.0];
                    }
                } else {
                    if (input[11] <= 1.5) {
                        if (input[8] <= 16.66666603088379) {
                            var91 = [0.0, 0.0, 1.0];
                        } else {
                            if (input[6] <= 16.66666603088379) {
                                var91 = [0.0, 0.0, 1.0];
                            } else {
                                var91 = [0.0, 1.0, 0.0];
                            }
                        }
                    } else {
                        if (input[3] <= 14.087500095367432) {
                            if (input[7] <= 21.590909004211426) {
                                if (input[2] <= 8.809523582458496) {
                                    var91 = [0.0, 1.0, 0.0];
                                } else {
                                    var91 = [0.0, 0.0, 1.0];
                                }
                            } else {
                                var91 = [1.0, 0.0, 0.0];
                            }
                        } else {
                            var91 = [0.0, 0.0, 1.0];
                        }
                    }
                }
            } else {
                var91 = [1.0, 0.0, 0.0];
            }
        }
    }
    ;
    if (input[10] <= 0.5) {
        if (input[0] <= 7.5) {
            if (input[11] <= 2.5) {
                if (input[8] <= 29.16666603088379) {
                    if (input[1] <= 3.5) {
                        if (input[4] <= 0.4614553153514862) {
                            if (input[5] <= 2.562334656715393) {
                                var92 = [0.0, 1.0, 0.0];
                            } else {
                                var92 = [1.0, 0.0, 0.0];
                            }
                        } else {
                            var92 = [0.0, 0.0, 1.0];
                        }
                    } else {
                        if (input[3] <= 7.599999904632568) {
                            if (input[4] <= 1.1826265454292297) {
                                var92 = [0.0, 0.0, 1.0];
                            } else {
                                if (input[1] <= 5.0) {
                                    var92 = [0.0, 1.0, 0.0];
                                } else {
                                    var92 = [0.0, 0.0, 1.0];
                                }
                            }
                        } else {
                            if (input[0] <= 5.5) {
                                var92 = [0.0, 1.0, 0.0];
                            } else {
                                var92 = [0.0, 0.0, 1.0];
                            }
                        }
                    }
                } else {
                    if (input[3] <= 4.349999904632568) {
                        var92 = [0.0, 0.0, 1.0];
                    } else {
                        var92 = [1.0, 0.0, 0.0];
                    }
                }
            } else {
                var92 = [1.0, 0.0, 0.0];
            }
        } else {
            if (input[4] <= 0.710468590259552) {
                var92 = [0.0, 0.0, 1.0];
            } else {
                if (input[1] <= 6.0) {
                    var92 = [1.0, 0.0, 0.0];
                } else {
                    if (input[11] <= 1.5) {
                        var92 = [0.0, 1.0, 0.0];
                    } else {
                        if (input[5] <= 2.0062886476516724) {
                            var92 = [0.0, 1.0, 0.0];
                        } else {
                            if (input[9] <= 1.3888888955116272) {
                                var92 = [0.0, 1.0, 0.0];
                            } else {
                                var92 = [1.0, 0.0, 0.0];
                            }
                        }
                    }
                }
            }
        }
    } else {
        if (input[3] <= 4.833333253860474) {
            if (input[9] <= 3.5) {
                if (input[10] <= 5.0) {
                    if (input[3] <= 1.75) {
                        var92 = [0.0, 1.0, 0.0];
                    } else {
                        var92 = [0.5, 0.5, 0.0];
                    }
                } else {
                    var92 = [0.0, 1.0, 0.0];
                }
            } else {
                var92 = [1.0, 0.0, 0.0];
            }
        } else {
            var92 = [1.0, 0.0, 0.0];
        }
    }
    ;
    if (input[11] <= 1.5) {
        if (input[9] <= 1.100000023841858) {
            if (input[10] <= 2.5) {
                var93 = [0.0, 1.0, 0.0];
            } else {
                if (input[3] <= 2.25) {
                    var93 = [1.0, 0.0, 0.0];
                } else {
                    var93 = [0.0, 1.0, 0.0];
                }
            }
        } else {
            if (input[10] <= 3.5) {
                if (input[12] <= 1.5) {
                    if (input[8] <= 10.0) {
                        if (input[7] <= 10.0) {
                            var93 = [0.0, 1.0, 0.0];
                        } else {
                            var93 = [0.0, 0.0, 1.0];
                        }
                    } else {
                        var93 = [0.0, 0.0, 1.0];
                    }
                } else {
                    if (input[2] <= 6.875) {
                        var93 = [1.0, 0.0, 0.0];
                    } else {
                        var93 = [0.0, 1.0, 0.0];
                    }
                }
            } else {
                var93 = [0.0, 1.0, 0.0];
            }
        }
    } else {
        if (input[8] <= 5.0) {
            if (input[3] <= 5.229166746139526) {
                var93 = [0.0, 0.0, 1.0];
            } else {
                if (input[5] <= 1.0448623895645142) {
                    var93 = [1.0, 0.0, 0.0];
                } else {
                    if (input[4] <= 0.18633899092674255) {
                        var93 = [0.0, 1.0, 0.0];
                    } else {
                        if (input[0] <= 4.5) {
                            var93 = [0.0, 1.0, 0.0];
                        } else {
                            if (input[6] <= 11.309523582458496) {
                                if (input[7] <= 20.833333015441895) {
                                    if (input[9] <= 2.5) {
                                        var93 = [0.0, 0.0, 1.0];
                                    } else {
                                        var93 = [1.0, 0.0, 0.0];
                                    }
                                } else {
                                    if (input[2] <= 3.9333332777023315) {
                                        var93 = [0.0, 0.0, 1.0];
                                    } else {
                                        var93 = [1.0, 0.0, 0.0];
                                    }
                                }
                            } else {
                                var93 = [1.0, 0.0, 0.0];
                            }
                        }
                    }
                }
            }
        } else {
            if (input[9] <= 1.8333333134651184) {
                if (input[8] <= 18.333333015441895) {
                    var93 = [0.0, 0.0, 1.0];
                } else {
                    var93 = [0.0, 1.0, 0.0];
                }
            } else {
                if (input[12] <= 4.5) {
                    var93 = [1.0, 0.0, 0.0];
                } else {
                    var93 = [0.0, 0.0, 1.0];
                }
            }
        }
    }
    ;
    if (input[5] <= 3.2592287063598633) {
        if (input[4] <= 0.45220860838890076) {
            if (input[1] <= 3.5) {
                if (input[0] <= 1.5) {
                    if (input[7] <= 58.33333206176758) {
                        if (input[3] <= 2.25) {
                            if (input[2] <= 2.5) {
                                var94 = [0.0, 1.0, 0.0];
                            } else {
                                var94 = [0.3333333333333333, 0.6666666666666666, 0.0];
                            }
                        } else {
                            var94 = [0.0, 1.0, 0.0];
                        }
                    } else {
                        var94 = [0.0, 1.0, 0.0];
                    }
                } else {
                    if (input[3] <= 6.166666746139526) {
                        var94 = [1.0, 0.0, 0.0];
                    } else {
                        var94 = [0.0, 1.0, 0.0];
                    }
                }
            } else {
                var94 = [1.0, 0.0, 0.0];
            }
        } else {
            if (input[9] <= 1.3666666746139526) {
                if (input[9] <= 1.2678571343421936) {
                    var94 = [0.0, 1.0, 0.0];
                } else {
                    if (input[11] <= 1.5) {
                        var94 = [0.0, 1.0, 0.0];
                    } else {
                        var94 = [1.0, 0.0, 0.0];
                    }
                }
            } else {
                if (input[2] <= 2.5) {
                    if (input[1] <= 6.0) {
                        var94 = [0.0, 1.0, 0.0];
                    } else {
                        var94 = [0.0, 0.0, 1.0];
                    }
                } else {
                    if (input[3] <= 10.386363506317139) {
                        if (input[4] <= 2.66541063785553) {
                            if (input[2] <= 9.392857074737549) {
                                var94 = [0.0, 0.0, 1.0];
                            } else {
                                var94 = [0.0, 1.0, 0.0];
                            }
                        } else {
                            var94 = [1.0, 0.0, 0.0];
                        }
                    } else {
                        if (input[3] <= 10.659090995788574) {
                            var94 = [0.0, 1.0, 0.0];
                        } else {
                            if (input[9] <= 1.8660714030265808) {
                                var94 = [0.0, 0.0, 1.0];
                            } else {
                                var94 = [1.0, 0.0, 0.0];
                            }
                        }
                    }
                }
            }
        }
    } else {
        if (input[1] <= 3.0) {
            var94 = [0.0, 1.0, 0.0];
        } else {
            var94 = [1.0, 0.0, 0.0];
        }
    }
    ;
    if (input[11] <= 2.5) {
        if (input[5] <= 0.7254734337329865) {
            if (input[10] <= 14.5) {
                if (input[12] <= 1.5) {
                    if (input[7] <= 58.33333206176758) {
                        if (input[2] <= 4.333333373069763) {
                            if (input[0] <= 2.0) {
                                if (input[3] <= 1.75) {
                                    var95 = [0.0, 1.0, 0.0];
                                } else {
                                    var95 = [0.5, 0.5, 0.0];
                                }
                            } else {
                                var95 = [1.0, 0.0, 0.0];
                            }
                        } else {
                            var95 = [0.0, 1.0, 0.0];
                        }
                    } else {
                        var95 = [0.0, 1.0, 0.0];
                    }
                } else {
                    var95 = [0.0, 1.0, 0.0];
                }
            } else {
                var95 = [1.0, 0.0, 0.0];
            }
        } else {
            if (input[9] <= 2.4652777910232544) {
                if (input[9] <= 1.3666666746139526) {
                    if (input[1] <= 2.5) {
                        var95 = [0.0, 1.0, 0.0];
                    } else {
                        if (input[6] <= 10.476190328598022) {
                            if (input[5] <= 1.5722646713256836) {
                                if (input[2] <= 5.0666667222976685) {
                                    if (input[4] <= 0.2357022613286972) {
                                        var95 = [0.0, 0.0, 1.0];
                                    } else {
                                        var95 = [0.0, 1.0, 0.0];
                                    }
                                } else {
                                    var95 = [0.0, 1.0, 0.0];
                                }
                            } else {
                                var95 = [0.0, 0.0, 1.0];
                            }
                        } else {
                            if (input[3] <= 11.75) {
                                var95 = [1.0, 0.0, 0.0];
                            } else {
                                var95 = [0.0, 1.0, 0.0];
                            }
                        }
                    }
                } else {
                    if (input[3] <= 12.416666507720947) {
                        var95 = [0.0, 0.0, 1.0];
                    } else {
                        var95 = [1.0, 0.0, 0.0];
                    }
                }
            } else {
                if (input[9] <= 3.642857074737549) {
                    var95 = [1.0, 0.0, 0.0];
                } else {
                    var95 = [0.0, 0.0, 1.0];
                }
            }
        }
    } else {
        var95 = [1.0, 0.0, 0.0];
    }
    ;
    if (input[2] <= 6.763888835906982) {
        if (input[9] <= 1.2678571343421936) {
            if (input[12] <= 1.5) {
                if (input[5] <= 1.7774022817611694) {
                    if (input[3] <= 5.333333253860474) {
                        if (input[10] <= 2.5) {
                            var96 = [0.0, 1.0, 0.0];
                        } else {
                            if (input[5] <= 0.25) {
                                var96 = [0.0, 1.0, 0.0];
                            } else {
                                var96 = [0.5, 0.5, 0.0];
                            }
                        }
                    } else {
                        if (input[4] <= 0.21650634706020355) {
                            var96 = [1.0, 0.0, 0.0];
                        } else {
                            var96 = [0.0, 1.0, 0.0];
                        }
                    }
                } else {
                    if (input[11] <= 1.5) {
                        var96 = [0.0, 1.0, 0.0];
                    } else {
                        var96 = [0.0, 0.0, 1.0];
                    }
                }
            } else {
                var96 = [0.0, 0.0, 1.0];
            }
        } else {
            if (input[1] <= 4.5) {
                if (input[0] <= 5.5) {
                    if (input[2] <= 4.833333253860474) {
                        var96 = [0.0, 0.0, 1.0];
                    } else {
                        var96 = [0.0, 1.0, 0.0];
                    }
                } else {
                    var96 = [1.0, 0.0, 0.0];
                }
            } else {
                if (input[4] <= 0.9710386097431183) {
                    if (input[9] <= 1.6888889074325562) {
                        var96 = [0.0, 0.0, 1.0];
                    } else {
                        if (input[4] <= 0.8412609994411469) {
                            if (input[6] <= 16.66666603088379) {
                                var96 = [1.0, 0.0, 0.0];
                            } else {
                                var96 = [0.0, 1.0, 0.0];
                            }
                        } else {
                            var96 = [1.0, 0.0, 0.0];
                        }
                    }
                } else {
                    if (input[0] <= 8.0) {
                        var96 = [0.0, 0.0, 1.0];
                    } else {
                        var96 = [1.0, 0.0, 0.0];
                    }
                }
            }
        }
    } else {
        if (input[8] <= 22.5) {
            if (input[1] <= 2.5) {
                var96 = [1.0, 0.0, 0.0];
            } else {
                if (input[9] <= 3.142857074737549) {
                    var96 = [0.0, 1.0, 0.0];
                } else {
                    if (input[3] <= 8.564934968948364) {
                        var96 = [1.0, 0.0, 0.0];
                    } else {
                        var96 = [0.0, 0.0, 1.0];
                    }
                }
            }
        } else {
            if (input[7] <= 45.238094329833984) {
                var96 = [1.0, 0.0, 0.0];
            } else {
                if (input[4] <= 2.0360257625579834) {
                    var96 = [0.0, 0.0, 1.0];
                } else {
                    var96 = [1.0, 0.0, 0.0];
                }
            }
        }
    }
    ;
    if (input[8] <= 18.333333015441895) {
        if (input[5] <= 0.8859826326370239) {
            if (input[3] <= 6.166666746139526) {
                if (input[0] <= 2.5) {
                    var97 = [0.0, 1.0, 0.0];
                } else {
                    if (input[11] <= 1.5) {
                        var97 = [0.0, 0.0, 1.0];
                    } else {
                        var97 = [1.0, 0.0, 0.0];
                    }
                }
            } else {
                var97 = [0.0, 1.0, 0.0];
            }
        } else {
            if (input[9] <= 1.3809524178504944) {
                if (input[3] <= 10.0) {
                    if (input[0] <= 4.5) {
                        var97 = [0.0, 1.0, 0.0];
                    } else {
                        var97 = [1.0, 0.0, 0.0];
                    }
                } else {
                    if (input[10] <= 1.5) {
                        var97 = [0.0, 1.0, 0.0];
                    } else {
                        var97 = [1.0, 0.0, 0.0];
                    }
                }
            } else {
                if (input[7] <= 15.476190090179443) {
                    var97 = [1.0, 0.0, 0.0];
                } else {
                    if (input[1] <= 7.5) {
                        var97 = [0.0, 0.0, 1.0];
                    } else {
                        var97 = [1.0, 0.0, 0.0];
                    }
                }
            }
        }
    } else {
        if (input[12] <= 1.5) {
            if (input[3] <= 6.333333253860474) {
                if (input[10] <= 1.0) {
                    var97 = [0.0, 0.0, 1.0];
                } else {
                    var97 = [1.0, 0.0, 0.0];
                }
            } else {
                var97 = [0.0, 0.0, 1.0];
            }
        } else {
            if (input[11] <= 1.5) {
                var97 = [0.0, 1.0, 0.0];
            } else {
                var97 = [1.0, 0.0, 0.0];
            }
        }
    }
    ;
    if (input[4] <= 0.18633899092674255) {
        if (input[2] <= 13.0) {
            if (input[0] <= 2.5) {
                var98 = [0.0, 1.0, 0.0];
            } else {
                if (input[3] <= 43.75) {
                    if (input[5] <= 1.25) {
                        var98 = [1.0, 0.0, 0.0];
                    } else {
                        var98 = [0.0, 1.0, 0.0];
                    }
                } else {
                    var98 = [0.0, 1.0, 0.0];
                }
            }
        } else {
            var98 = [1.0, 0.0, 0.0];
        }
    } else {
        if (input[9] <= 1.550000011920929) {
            if (input[4] <= 1.1713321208953857) {
                if (input[5] <= 2.4348318576812744) {
                    if (input[2] <= 7.300000190734863) {
                        if (input[0] <= 4.5) {
                            if (input[3] <= 8.125) {
                                var98 = [0.0, 0.0, 1.0];
                            } else {
                                var98 = [0.0, 1.0, 0.0];
                            }
                        } else {
                            var98 = [0.0, 0.0, 1.0];
                        }
                    } else {
                        var98 = [0.0, 1.0, 0.0];
                    }
                } else {
                    var98 = [1.0, 0.0, 0.0];
                }
            } else {
                if (input[2] <= 5.666666746139526) {
                    var98 = [0.0, 0.0, 1.0];
                } else {
                    var98 = [0.0, 1.0, 0.0];
                }
            }
        } else {
            if (input[6] <= 7.499999761581421) {
                if (input[10] <= 0.5) {
                    if (input[0] <= 5.0) {
                        if (input[4] <= 1.3498365879058838) {
                            var98 = [0.0, 0.0, 1.0];
                        } else {
                            if (input[8] <= 33.33333206176758) {
                                var98 = [0.0, 0.0, 1.0];
                            } else {
                                var98 = [1.0, 0.0, 0.0];
                            }
                        }
                    } else {
                        if (input[2] <= 4.388888835906982) {
                            var98 = [0.0, 0.0, 1.0];
                        } else {
                            if (input[12] <= 3.5) {
                                if (input[5] <= 2.0731165409088135) {
                                    if (input[7] <= 16.66666603088379) {
                                        var98 = [1.0, 0.0, 0.0];
                                    } else {
                                        var98 = [0.0, 0.0, 1.0];
                                    }
                                } else {
                                    var98 = [1.0, 0.0, 0.0];
                                }
                            } else {
                                var98 = [0.0, 0.0, 1.0];
                            }
                        }
                    }
                } else {
                    var98 = [1.0, 0.0, 0.0];
                }
            } else {
                if (input[12] <= 1.5) {
                    var98 = [0.0, 0.0, 1.0];
                } else {
                    var98 = [0.0, 1.0, 0.0];
                }
            }
        }
    }
    ;
    if (input[2] <= 5.375) {
        if (input[7] <= 42.727272033691406) {
            if (input[5] <= 2.3472421169281006) {
                if (input[2] <= 3.7333333492279053) {
                    if (input[4] <= 0.20000000298023224) {
                        var99 = [1.0, 0.0, 0.0];
                    } else {
                        var99 = [0.0, 0.0, 1.0];
                    }
                } else {
                    var99 = [0.0, 0.0, 1.0];
                }
            } else {
                var99 = [1.0, 0.0, 0.0];
            }
        } else {
            if (input[4] <= 0.4614553153514862) {
                if (input[0] <= 1.5) {
                    if (input[10] <= 2.5) {
                        var99 = [0.0, 1.0, 0.0];
                    } else {
                        var99 = [1.0, 0.0, 0.0];
                    }
                } else {
                    var99 = [0.0, 1.0, 0.0];
                }
            } else {
                if (input[2] <= 2.649999976158142) {
                    var99 = [0.0, 1.0, 0.0];
                } else {
                    if (input[7] <= 47.727272033691406) {
                        var99 = [1.0, 0.0, 0.0];
                    } else {
                        if (input[5] <= 2.9088910818099976) {
                            var99 = [0.0, 0.0, 1.0];
                        } else {
                            var99 = [1.0, 0.0, 0.0];
                        }
                    }
                }
            }
        }
    } else {
        if (input[9] <= 2.25) {
            if (input[12] <= 1.5) {
                if (input[11] <= 1.5) {
                    var99 = [0.0, 1.0, 0.0];
                } else {
                    if (input[10] <= 1.5) {
                        if (input[0] <= 5.5) {
                            var99 = [0.0, 1.0, 0.0];
                        } else {
                            var99 = [1.0, 0.0, 0.0];
                        }
                    } else {
                        var99 = [1.0, 0.0, 0.0];
                    }
                }
            } else {
                if (input[0] <= 7.0) {
                    var99 = [0.0, 1.0, 0.0];
                } else {
                    if (input[8] <= 10.0) {
                        var99 = [1.0, 0.0, 0.0];
                    } else {
                        var99 = [0.0, 1.0, 0.0];
                    }
                }
            }
        } else {
            if (input[0] <= 7.5) {
                if (input[4] <= 1.1869642734527588) {
                    if (input[0] <= 4.0) {
                        if (input[7] <= 26.66666603088379) {
                            var99 = [0.0, 0.0, 1.0];
                        } else {
                            if (input[7] <= 45.238094329833984) {
                                var99 = [1.0, 0.0, 0.0];
                            } else {
                                var99 = [0.0, 0.0, 1.0];
                            }
                        }
                    } else {
                        var99 = [1.0, 0.0, 0.0];
                    }
                } else {
                    var99 = [0.0, 0.0, 1.0];
                }
            } else {
                var99 = [1.0, 0.0, 0.0];
            }
        }
    }
    const votes: Vector3[] = [
    var0, var1, var2, var3, var4, var5, var6, var7, var8, var9,
    var10, var11, var12, var13, var14, var15, var16, var17, var18, var19,
    var20, var21, var22, var23, var24, var25, var26, var27, var28, var29,
    var30, var31, var32, var33, var34, var35, var36, var37, var38, var39,
    var40, var41, var42, var43, var44, var45, var46, var47, var48, var49,
    var50, var51, var52, var53, var54, var55, var56, var57, var58, var59,
    var60, var61, var62, var63, var64, var65, var66, var67, var68, var69,
    var70, var71, var72, var73, var74, var75, var76, var77, var78, var79,   
    var80, var81, var82, var83, var84, var85, var86, var87, var88, var89,
    var90, var91, var92, var93, var94, var95, var96, var97, var98, var99,
  ];

  const summed = votes.reduce<Vector3>(
    (acc, v) => addVectors(acc, v),
    [0, 0, 0]
  );
  const result = mulVectorNumber(summed, 0.01);
  return result;
}

function addVectors(v1: Vector3, v2: Vector3): Vector3 {
  return [
    v1[0] + v2[0],
    v1[1] + v2[1],
    v1[2] + v2[2],
  ];
}
function mulVectorNumber(v1: Vector3, num: number): Vector3 {
  return [
    v1[0] * num,
    v1[1] * num,
    v1[2] * num,
  ];
}